import QRCode from 'qrcodejs2';
import draggable from 'vuedraggable';
import Tooltip from '../../../components/Tooltip';
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
import { Object } from 'core-js';
// import Driver from 'driver.js';
// import { DropdownItem } from 'element-ui';
import "tui-image-editor/dist/tui-image-editor.css";
import "tui-color-picker/dist/tui-color-picker.css";
let echarts = require('echarts/lib/echarts');
require('echarts/lib/chart/bar');
require('echarts/lib/component/tooltip'); // tooltip组件
const ImageEditor = require("tui-image-editor");
const locale_zh = {
  History: '歷史',
  DeleteAll: "全部刪除",
  // Delete: "删除",
  Undo: "撤銷",
  Redo: "反撤銷",
  // Reset: "重置",
  Draw: "畫",
  Text: "文字標註",
  Free: "曲線",
  Straight: "直線",
  Color: "顏色",
  Range: "區間",
  Bold: "加粗",
  Italic: "斜體",
  Underline: "下劃線",
  Left: "左對齊",
  Center: "居中",
  Right: "右對齊",
  "Text size": "字體大小",
};
// 画布组件自定义样式
const customTheme = {
  "common.bi.image": "", // 在这里换上你喜欢的logo图片
  "common.bisize.width": "0px",
  "common.bisize.height": "0px",
  "common.backgroundImage": "none",
  "header.backgroundImage": "none",
  "loadButton.display": "none", 
  "downloadButton.display": "none",
  "menu.normalIcon.color": "#8a8a8a",
  "menu.activeIcon.color": "#555555",
  "menu.disabledIcon.color": "#434343",
  "menu.hoverIcon.color": "#e9e9e9",
  "submenu.normalIcon.color": "#8a8a8a",
  "submenu.activeIcon.color": "#e9e9e9",
  "menu.iconSize.width": "24px",
  "menu.iconSize.height": "24px",
  "submenu.iconSize.width": "32px",
  "submenu.iconSize.height": "32px",
}
export default {
  name: 'post',
  data() {
    let buildValue = (rule, value, callback) => {
      if ((this.propertyInfo.buildingNameWithCulture == '' || !this.propertyInfo.buildingNameWithCulture) && this.isHaveTo) {
        callback(new Error('請選擇座數'))
      } else {
        callback();
      }
    }
    // let phaValue = (rule, value, callback) => {
    //   if (this.propertyInfo.phaseWithCulture == '' || !this.propertyInfo.phaseWithCulture) {
    //     callback(new Error('請選擇期數'))
    //   } else {
    //     callback();
    //   }
    // }
    let floorNameValue = (rule, value, callback) => {
      // 屋苑单栋模式下 楼层为必填.其余类型均为星级盘要求必填
      if (this.propertyInfo.propertyCategory == "1" && this.propertyInfo.buildingType == 1) {
        if (!this.propertyInfo.floorName && this.estAdress.unitFloorList.length) {
          callback(new Error('請選擇樓層'))
        } else if (this.estAdress.unitFloorList.length && !this.propertyInfo.unitFloor) {
            callback(new Error('請選擇樓層補充資料'))
        }else if(!this.estAdress.unitFloorList.length && !this.propertyInfo.unitFloor){
          callback(new Error('請選擇高/中/低層'));
        }else{
          callback();
        }
      } else {
        callback();
      }
    };
    let estNameValue = (rule, value, callback) => {
      if (!this.addressSearch) {
        if ((!this.propertyInfo.estateName || this.propertyInfo?.estateName?.trim().length == 0) && (!this.propertyInfo.estateNameEN || this.propertyInfo?.estateNameEN?.trim().length == 0)) {
          callback(new Error('請輸入屋苑或大廈名稱'))
        } else {
          callback();
        }
      } else {
        callback();
      }
    }
    /**樓盤類型子类必填*/
    let cateSubValue = (rule, value, callback) => {
      //当前模式如果是立即付款 不用校验小分类必填
      if (this.mode == 1) {
        callback();
      }
      if ((this.propertyInfo.propertyCategory == 1 || this.propertyInfo.propertyCategory == 5 || this.propertyInfo.propertyCategory == 4) && (Array.from(this.propertyInfo.subCategory).length == 0)) {
        callback(new Error('請選擇樓盤詳細類別'));
      } else {
        callback();
      }
    }
    /** 實用面積必須細過或等於建築面積验证*/
    let validarea = (rule, value, callback) => {
      if (this.propertyInfo.saleableArea && this.propertyInfo.buildingArea && Number(this.propertyInfo.buildingArea) < Number(this.propertyInfo.saleableArea)) {
        callback(new Error('實用面積必須細過或等於建築面積'));
      } else {
        callback();
      }
    };
    let validReq = (rule, vale, callback) => {
      if (this.propertyInfo.saleableArea || this.propertyInfo.buildingArea) {
        callback();
      } else {
        callback(new Error('建築面積或實用面積至少填寫一項'));
      }
    };
    let validServiceEn = (rule, vale, callback) => {
      if (this.propertyInfo.servicesEN ) {
        if(this.propertyInfo.servicesEN.includes('28hse.com')){
          callback(new Error('不支援此連結格式-28hse.com'));
        }else if(this.propertyInfo.servicesEN.includes('https://api.whatsapp.com/')){
          callback(new Error('不支援此連結格式-https://api.whatsapp.com/'));
        }else if(this.propertyInfo.servicesEN.includes('wa.me')){
          callback(new Error('不支援此連結格式-wa.me'));
        }else if(this.propertyInfo.servicesEN.includes('link>>>https://www.example.com<<<link')){
          callback(new Error('請把https://www.example.com更換為其他連結'));
        }else{
          callback();
        }
      } else {
        callback();
      }
    };
    let validGscopeFaCode = (rule, vale, callback) => {
      if(!this.propertyInfo.gscopeFaCode){
        callback(new Error('請選擇屋苑所在地區'));
      }else{
        callback();
      }
    };
    let validGscopeCode = (rule, vale, callback) => {
      if(!this.propertyInfo.gscopeCode){
        callback(new Error('請選擇屋苑所在樓市片區'));
      }else{
        callback();
      }
    };
    let validProintEn = (rule, vale, callback) => {
      if (this.propertyInfo.introduceEN ) {
        if(this.propertyInfo.introduceEN.includes('28hse.com')){
          callback(new Error('不支援此連結格式-28hse.com'));
        }else if(this.propertyInfo.introduceEN.includes('https://api.whatsapp.com/')){
          callback(new Error('不支援此連結格式-https://api.whatsapp.com/'));
        }else if(this.propertyInfo.introduceEN.includes('wa.me')){
          callback(new Error('不支援此連結格式-wa.me'));
        }else if(this.propertyInfo.introduceEN.includes('link>>>https://www.example.com<<<link')){
          callback(new Error('請把https://www.example.com更換為其他連結'));
        }else{
          callback();
        }
      } else {
        callback();
      }
    };
    let validProint = (rule, vale, callback) => {
      if (this.propertyInfo.introduceCN ) {
        if(this.propertyInfo.introduceCN.includes('28hse.com')){
          callback(new Error('不支援此連結格式-28hse.com'));
        }else if(this.propertyInfo.introduceCN.includes('https://api.whatsapp.com/')){
          callback(new Error('不支援此連結格式-https://api.whatsapp.com/'));
        }else if(this.propertyInfo.introduceCN.includes('wa.me')){
          callback(new Error('不支援此連結格式-wa.me'));
        }else if(this.propertyInfo.introduceCN.includes('link>>>https://www.example.com<<<link')){
          callback(new Error('請把https://www.example.com更換為其他連結'));
        }else{
          callback();
        }
      } else {
        callback(new Error('請填寫樓盤介紹（中文）'));
      }
    };
    let validService = (rule, vale, callback) => {
      if (this.propertyInfo.servicesCN ) {
        if(this.propertyInfo.servicesCN.includes('28hse.com')){
          callback(new Error('不支援此連結格式-28hse.com'));
        }else if(this.propertyInfo.servicesCN.includes('https://api.whatsapp.com/')){
          callback(new Error('不支援此連結格式-https://api.whatsapp.com/'));
        }else if(this.propertyInfo.servicesCN.includes('wa.me')){
          callback(new Error('不支援此連結格式-wa.me'));
        }else if(this.propertyInfo.servicesCN.includes('link>>>https://www.example.com<<<link')){
          callback(new Error('請把https://www.example.com更換為其他連結'));
        }else{
          callback();
        }
      } else {
        callback(new Error('請填寫設施及服務（中文）'));
      }
    };
    let validPriceAll = (rule, vale, callback) => {
      if(this.conditions){
        let judgeType = ''
        this.isHosPrice ? judgeType = 'unPaidSalePrice' : judgeType = 'paidSalePrice'
        let priceFoot = Number(this.propertyInfo.priceFoot / 10000)
        let priceTop = Number(this.propertyInfo.priceTop / 10000)
        // 先判断价格上限  然后 在判断大小
        if(!this.propertyInfo[judgeType] || this.propertyInfo[judgeType] > priceTop || this.propertyInfo[judgeType] < priceFoot){
          return callback(new Error(`${this.isHosPrice ? '未補':'已補'}價格可輸入範圍為${this.propertyInfo.priceFoot > 100000000 ? this.propertyInfo.priceFoot / 100000000 : this.propertyInfo.priceFoot / 10000}${this.propertyInfo.priceFoot > 100000000 ? '億' : '萬'}——${this.propertyInfo.priceTop > 100000000 ? this.propertyInfo.priceTop / 100000000 : this.propertyInfo.priceTop / 10000}${this.propertyInfo.priceTop > 100000000 ? '億' : '萬'}`));
        }
        if (this.propertyInfo.unPaidSalePrice && this.propertyInfo.paidSalePrice && Number(this.propertyInfo.paidSalePrice) < Number(this.propertyInfo.unPaidSalePrice)) {
          callback(new Error('已補售價必須大於等於未補售價'))
        } else {
          callback();
        }
      }else{
        if (this.propertyInfo.unPaidSalePrice || this.propertyInfo.paidSalePrice) {
          if (this.propertyInfo.unPaidSalePrice && this.propertyInfo.paidSalePrice && Number(this.propertyInfo.paidSalePrice) < Number(this.propertyInfo.unPaidSalePrice)) {
            callback(new Error('已補售價必須大於等於未補售價'))
          } else {
            callback();
          }
        } else {
          callback(new Error('未補或已補地價至少填寫一項'));
        }
      }
    };
    let titleValid = (rule, vale, callback) => {
      let regExp = /^[2-9]/;
      let numAll = this.propertyInfo.titleCN?.match(/\d+\.?\d*/g)?.filter(item => item.length == 8)
      let testPass = false
      if (numAll) {
        for (let i = 0; i < numAll.length; i++) {
          if (regExp.test(numAll[i])) {
            testPass = true
            break;
          }
        }
      }
      if (testPass) {
        callback(new Error('請不要輸入電話號碼'));
      } else {
        callback();
      }
    };
    let validautoRec= (rule, vale, callback) => {
      if (this.propertyInfo.isAutoRecommend && !this.propertyInfo.propertyCoinSetID) {
        callback(new Error('必須選擇一個自動置頂配置'));
      } else {
        callback();
      }
    };
    let titleENValid = (rule, vale, callback) => {
      let regExp = /^[2-9]/;
      let numAll = this.propertyInfo.titleEN?.match(/\d+\.?\d*/g)?.filter(item => item.length == 8)
      let testPass = false
      if (numAll) {
        for (let i = 0; i < numAll.length; i++) {
          if (regExp.test(numAll[i])) {
            testPass = true
            break;
          }
        }
      }
      if (testPass) {
        callback(new Error('請不要輸入電話號碼'));
      } else {
        callback();
      }
    };
    /**上传楼盘验证文件*/
    // let validVerify = (rule, value, callback) => {
    //   if ((this.propertyInfo.isVerify && this.mode === '2') || (this.propertyInfo.isVerify && this.mode === 'edit') || (this.propertyInfo.isVerify && this.mode === '1')) {
    //     callback();
    //     // verifyFile
    //   } else if (this.verifyFile.length === 0 && this.propertyInfo.isVerify) {
    //     callback(new Error('請上傳樓盤驗證文件'));
    //   } else {
    //     callback();
    //   }
    // };
    let vrVerify = (rule, value, callback) => {
      if (this.propertyInfo.inputVRURL) {
        // let vrreg = new RegExp('^https://(webresource[\.]123kanfang[\.]com|my[\.]matterport[\.]com|www[\.]720real[\.]com|tour[\.]pivo[\.]app).*')
        let vrreg = new RegExp(`^${this.verifyVr}.*`)
        if (!vrreg.test(this.propertyInfo.inputVRURL)) {
          callback(new Error("暫不支援此VR連結格式，如需加入此VR請 WhatsApp到 5726 6308 與客戶服務聯絡"))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    let videoVerify = (rule, value, callback) => {
      let videoEnter = false
      if (!this.videos[0].videoPath.startsWith('www.youtube.com/watch') && this.videos[0].videoPath.startsWith('https://')) {
        videoEnter = false
      } else if (this.videos[0].videoPath.startsWith('www.youtube.com/watch') && !this.videos[0].videoPath.startsWith('https://')) {
        videoEnter = false
      } else {
        videoEnter = true
      }
      if (this.videos[0].videoPath !== "") {
        var reg4 = new RegExp(`^${this.verifyVideo}.*`);
        // var reg4 = new RegExp('^https://(www[\.]youtube[\.]com|www[\.]facebook[\.]com|fb[\.]watch|youtu[\.]be|m[\.]youtube[\.]com|m[\.]facebook[\.]com)/.*');
        if (!reg4.test(this.videos[0].videoPath) || videoEnter) {
          callback(new Error("請輸入帶有https:// 的YouTube或Facebook網站的影片連結"))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    /**利嘉格 ||  中原 价格修改限制*/
    let priceInterval = (rule, value, callback) => {
      if (this.conditions) {
        if (this.propertyInfo.rentalType == 1) {
          value = value * 10000;
        }
        if (value < this.propertyInfo.priceFoot || value > this.propertyInfo.priceTop) {
          if (this.propertyInfo.rentalType == 1) {
            callback(new Error(`價格可修改範圍為${this.propertyInfo.priceFoot > 100000000 ? this.propertyInfo.priceFoot / 100000000 : this.propertyInfo.priceFoot / 10000}${this.propertyInfo.priceFoot > 100000000 ? '億' : '萬'}——${this.propertyInfo.priceTop > 100000000 ? this.propertyInfo.priceTop / 100000000 : this.propertyInfo.priceTop / 10000}${this.propertyInfo.priceTop > 100000000 ? '億' : '萬'}`));
          } else {
            callback(new Error(`價格可修改範圍為${this.propertyInfo.priceFoot}——${this.propertyInfo.priceTop}`));
          }
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {  
      propertyOrder:{},
      upgradeDiaStep:false,
      suggestSubCategory:'',
      showSubTxt:'',
      matchSubText:'',
      processingCount: 0, // 跟踪正在处理的任务数（包括压缩和上传）
      isUploadComplete: false, // 标记所有任务是否完成
      errlogCount:0,//记录重新上传图片的弹框出现次数log
      failedFiles:[],
      draftType:'',
      originEstateName:'',
      isUploading: false, // 是否正在上传
      imgQueue: {},       // 待上传队列
      uploading: false,   // 防止重复触发上传
      isDeleting:false,
      modifyDefaulting:false,
      isRotating:false,
      uploadImgStatus:false,
      estateStep:'',

      exeDraftInter:true,
      exeMesInter:true,
      // hasPushedException:false, 
      // isReconnecting:false, 
      fromZy:false,//是否为中原优惠券跳转刊登盘
      couponPhase:false,//优惠券跳转刊登，无期数时(true),期数解除禁用可自选
      couponBuild:false,
      showZyAdress:true,//中原优惠券楼盘修改时，屋苑地址禁用（超出时间取消禁用）。（默认为true，避免刊登时禁用状态出现取消情况）
      formattedZyDate:'',
      isDisableStand:false,//中原优惠券禁用的放盘方式
      isDisableSuper: false,
      isDisableStar: false,
      reconnectAttempts:0,
      // autocompleteName:'',
      // autocompleteNameEN:'',
      autocompletebuild:'',
      dynamicClass:'autolist',
      manualAdd:false,
      isEditMode:false,
      couponPro:{},
      orderInfo:{},
      payOrderMoney:'',
      payOrderDia:'',
      disCoin:true,//灰标金币
      disDiamond:true,
      payCoinDis:false,//禁用金币
      payDiaDis:false,
      isinit:false,
      // maxRetries:150,
      showClearDia:true,
      postNext:true,//刊登成功时 无须存入草稿箱
      existRoomNo:false,//中利接口是否有返回roomNo
      formSource:true,//编辑页面 路由跳转 直接点击楼盘管理
      butFormSource:false,//编辑页面直接点击按钮提交更改(无校验错误情况)需直接跳转
      validatePass:false,//校验是否通过-路由跳转时使用
      editImgDialogVisible:false,
      /**
       * editNewDataRule使用规则:楼盘地址栏相关选项是否需要必填
       * 1.中利 -无论新老数据 皆遵循原来规则 即-非必填 false
       * 2.非中利 新数据必填,老数据修改时非必填(false).老数据续期时需必填(true) 
       * 补充:老数据的支付功能是禁用
       * */
      editNewDataRule: true,
      estateSrcList: '',//可选楼盘类型
      showEstAdressbui: true,//展示输入类型座数
      oneBuilFlo: false,
      startFloDis: true, // 初始进入页面切换楼盘类型时 楼层单位禁用
      startBuilRoom: true,//初始进入页面是否禁用
      oneBuilRoom: false,//单位是否禁用 根据选中屋苑判断
      propertyDisPlayList: [],//楼盘资料显示
      isCutomadded: false,//搜索时判断是否村屋
      showPropVerify: false,//展示楼盘验证文字入口
      showEditerror: false,//修改楼盘期数等未上传验证文件报错
      verifyUpdate: false,//修改楼盘 可直接提交updateproperty
      verifyVisible: false,//修改楼盘-期数,单位,座数,楼盘改变时,是否重新修改验证文件
      showVerifyAgain: true,//修改楼盘弹出框只能展示一次
      verifyExpire: ['期數', '樓層', '座數及單位'],
      postScoreVisible: false,//等級提示彈出框
      showScoreAgain: true,//分数等级弹框只可以弹出一次
      goPost: false,//等級提示框點擊繼續放盤後 不再彈出
      postScore: {//等級提示框數據
        scoreAdRank: '',
        scoreReason: [],
        score: '',
        scoreStar: '',
      },
      evalue:false,//即时银行估值
      evaluationDate:'',
      evaluationValue:'',
      showAgreeEva:true,
      showBankEva:true,
      showEvaBut:true,
      vrRules: [],
      isShowBoc: false,
      videoRules: [],
      verifyVideo: '',
      verifyVr: '',
      nFlor: 0,//大图轮播实现
      aFlor: false,
      nPlat: 0,
      aPlat: false,
      isFirst: false,//是否展示刊登页引导
      orignprice: -1,//修改时第一次售价
      orignrprice: -1,//修改第一次租价
      subway: "",//距港铁时间
      draftTagsData: {},//草稿箱回显的标签数据
      selectedTags: [],//拖拽的数据数组
      flatTag:[],
      tagsChar: [],//页面展示和回显所需
      tagsSce: [],
      tagsRen: [],
      tagsMat: [],
      tagsBus: [],
      tagsPark:[],
      accountType: true,
      isaddVR: false,
      InputVR: false,
      adRank: false,
      isEditStandardEstateName: false,
      isEditSuperEstateName: false,
      isEditStarEstateName: false,
      isShowTelephoneBtn:false,
      isShowCoinHistory: true,//同管理后台联动数据
      isShowDiamondHistory: true,
      isUsedCoin: true,
      isUseStar: true,
      isUseSuper: true,
      isUseStandard: true,
      isShowAutoRecCount:0,//后台开启的放盘方式个数
      isShowHighTop:false,
      isUseInstantEstateVolume:false,
      isUseHideAgent: true,
      isUpdateCompany:true,
      couponEffectiveDays:'',
      isUseCoupon:false,//是否展示优惠券
      isDisCoupon:false,//是否禁用优惠券输入
      isCouponStatus:false,//优惠券是否为错误提示标红
      isDisCouponMes:'',
      imgwarning: false,//当图片未上传完成时的变量
      imgUploadPass:false,//图片未上传完成是否可以直接刊登
      nonSuccessCount:0,//未上传成功图片数量
      buttonup: 'primary',
      buttondel: '',
      vurls: [],//存储视频
      isHidden: true,//视频是否展示默认楼盘
      promptinfo: '',//物业编号重复信息
      PageCount: '10',
      PageIndex: '1',
      ruleInfo: '',
      showLogin: false,
      disablePost: false,//刊登禁用
      showTopImage: false,
      defaultImgTip:false,
      expireTimeCulture: '', //订单过期天数
      // asyncPostImage:false, //图片转换中
      // isProhibitPublishGoldTop: true, //是否展示精选盘
      isUsedDiamond: false,//是否允许使用钻石(指只要标准精选星级,有一种可使用钻石,就表允许使用)
      timer: null,
      // 是否含有敏感词
      hasSenWrods: {
        titleEN: false, //标题(英文)
        titleCN: false, //标题(繁体)
        introduceEN: false, //介绍英文
        introduceCN: false, //介绍中文
        servicesCN:false,
        servicesEN:false,
      },
      companyCategory: 3,
      isHosPrice: true,
      isVerifyPropertyNO: false,
      searchRes: false,//其与condition字段共同控制页面相关栏显示
      lijiageAco:false,//是否为利嘉格displytype为1类型，是则平面图禁止切换
      isDaWanQu:false,//切换楼盘类型时,是否为从大湾区切换而来
      imgQueue: {},
      curQueue: {},
      isUpLoading: false,
      commonWords: false, //关键字弹窗显示
      Words: {
        flag: 1, //为1选择
        checkedIntr: [], //选中的介绍
        checkedTitle: [], //选中的标题title  为2选择文字介绍
        Introduction: [],
        title: [],
        checkedFacSer:[],
        facilitiesWord:[],
        serviceWord:[],
        dialogTitle: '',

      }, //关键词
      BusinessWords: {
        flag: 1, //为1选择
        Introduction: [],
        title: [],
      },
      mode: 'post',
      scoket: null,
      baseUrl:'',
      token: '',
      identification: '',
      propertyId: '', //当前楼盘ID
      propertyUserInfo: [{}], //代理人信息
      editcompanyUserInfo:[],//修改资料取消后，重新回显代理人原本信息
      editAgentList:[],
      agent: [], //代理人唯一标识acctID
      addressSearch: true, //是否手动输入地址搜索
      changeAddressSearch :true,//（true:字典输入）字典输入禁止改为手动
      apiData: {}, //接口楼盘返回的信息
      publicAgentNumber: 0,
      isDefaultPropertyNoL:'',
      EstateInfo: {}, //楼盘信息搜索到的
      planImgInfo: {//页面使用的筛选项
        phaseEstates: [],//期数
        buildings: [],//座数
        floorList: [],//楼层
        unitList: [],//单位
        areaList: []//使用面积
      },
      buildingsList: '',
      estAdress: {
        phaseEstates: [],//期数
        buildings: [],//座数
        floorList: [],//楼层
        unitList: [],//单位
        areaList: [],//使用面积
        unitFloorList: [],//楼层资料缺失补充
      },
      // exeBlurArea: true,
      editFloCheck: false, //控制是否删除修改时选中的plan数据
      editCheck: false,
      editPlat: false,
      alreaSel: false,
      imageType: 100,//100:单位平面图,101:楼层平面
      disshowShai: false,//控制平面图筛选后四项是否禁用
      platUrls: [],//页面中的单位平面图
      floUrls: [],//页面中的楼层平面图
      plaCount: '',
      floCount: '',
      planChecked: [],//选中的平面图片数据
      planfloChecked: [],
      disSelToil: false,
      isReduceUnpaid:false, //是否展示公屋未补减价盘
      isReducePaid:false ,
      rentReducePrice:false,
      showReducePrice :false,//是否展示减价盘模块
      clearBoc:false,//是否修改屋苑类型,屋苑名称
      roomNoZl:'',//中利单位 需单独判断
      compareNo:{
        propertyNo:'',
        estateName: '',
        buildingName: '', 
        buildingNameWithCulture: '',
        floorName: '',
        roomNo: '',
        unitFloor:'',
        // estateAddress:'',
        estateAddressWithCulture:'',
        buildingAge: '', 
        roomNumber: '', 
        toiletNumber: '',
        buildingArea: '', 
        saleableArea: '', 
      },
      isPropertySource:false,
      isOwner:false,
      isShowOwner:false,//后台业主开关关闭，修改楼盘时，修改一个已勾选业主的楼盘，需要保持展示
      starUpgradeObj:{},
      propertyInfo: {
        targetUpTopType:'',
        subCategorySuggestText:'',
        propertyCoinSetID:'',
        isAutoRecommend:false,//是否自动置顶
        autoRecommendPaymentType:3,//自动置顶的支付类型
        couponKeyword:'',//优惠券
        paymentType:'',//支付类型 0金币,3钻石
        unitID:'',
        unitCode:'',
        isReducePaidSalePrice:false,//是否减价盘
        isReduceUnPaidSalePrice:false,
        isReduceRentPrice:false,
        isVerifyArea:false,
        firstPaidSalePrice:'',//原始价
        firstUnPaidSalePrice:'',
        firstRentPrice:'',
        buildingType: '',
        // 平面图
        phaseEstateId: '',//期数
        // planbuildingId: '',//座数
        floorDisplay: "",//楼层
        roomNo: '',//单位
        roomNoEN: '',
        inputSaleableArea: '',//使用面积
        planImages: [],//选中的平面图
        changeimage: '',
        propertyRemark: '',
        propertyTags: [],//楼盘标签

        isBoc: true,//银行估价
        addVR: false,//是否展示vr
        inputVRURL: '',//vr链接
        draftID:'',
        input: '',
        categoryNo: '',
        propertySource: 2, //默认为2 代理盘
        propertyCategory: '', // 放盘分类Int32
        subCategory: '' || [], //小分类In32
        rentalType: '', //租售类型 sale1 rent2(默认修改为空)
        propertyNo: '', // 楼盘编号
        salePrice: '', //售价
        rentPrice: '', // 租价
        unPaidSalePrice: '',//绿白表未補
        paidSalePrice: '',//绿白表已補
        buildingArea: '', //建筑面积
        saleableArea: '', //使用面积
        isForeclosure:false,
        isShowForeclosureDesc:false,
        // isLinkParking: '', //带车位
        beginRentTime: '', //起租日
        rentLabel: [], //租房-其他
        gscopeFaCode: '',
        estateType: '',
        phaseWithCulture: '', //期数
        gscopeCode: '', //区域板块
        estateName: '', //楼盘名繁体
        estateNameEN: '', //楼盘名英文
        estateAddress: '', //楼盘地址繁
        estateAddressEN: '', //楼盘地址繁
        buildingName: '', //座数
        buildingNameWithCulture: '',//座数
        buildingNameEN: '',
        floorNameEN: '',//存在资料时 存入楼层名字
        floorName: '',
        unitFloorWithCulture: '',
        floorNameWithCulture: '',//楼层
        unitID: '',
        propertyDisPlayType: '',//樓盤資料顯示类型 1,2,3,4
        buildingID: '',//栋座id
        buildingAge: '', //楼龄
        roomNumber: '', //房间数目
        toiletNumber: '',//洗手间数目
        toiletNumberWithCulture: '',
        unitFloor: '', //单位楼层
        titleEN: '', //标题(英文)
        titleCN: '', //标题(繁体)
        introduceEN: '', //介绍英文
        introduceCN: '', //介绍中文
        servicesCN:'',
        servicesEN:'',
        propertyManagementFee: '', //管理费
        topType: '0', //是否置顶盘源
        isVerify: false, //放盤-樓盤驗證標籤
        verifyImage: [], //樓盤驗證照片
        agree: '', //同意条款
        regionNameWithCulture: '',
        gscopeNameWithCulture: '',
        propertyCategoryWithCulture: '',//楼盘类型
      },
      diConfig: {
        PropertyTag: [],
        ChildrenTag: [],
        PropertyCategory: [] /** 楼盘分类 */,
        ChildrenCategory: [] /** 子分类 */,
        UnitFloor: [],
        RoomNumber: [],
        ToiletNumber: [],
        PropertyImageType: [] /** 圖片位置 */,
        RentLabel: [] /** 其他选项 */,
        gscope: [] /**  区域板块 */,
        ChildrenGscope: [] /**  子区域 */,
        agentList: [] /**  代理列表 */,
        properUsing: {} /**  正在使用中楼盘数量 */,
        Normal: {},
        GoldTop: {},
        VerifyLabel: {},
        phaseList: [] /**  期数列表 */
      },
      images: [],//楼盘图片相关信息
      isRetryDialogOpen: false,//是否弹出失败图片重传弹框
      videos: [{ defaultImagePath: '', videoPath: "" }],//视频图片相关信息
      rules: {
        estateNameAll: [{ required: true, validator: estNameValue, trigger: 'change' }],
        floorNameAll: [{ required: true, validator: floorNameValue, trigger: 'change' }],
        buildingNameWithCulture: [{ required: true, validator: buildValue, trigger: 'change' }],
        // phaseWithCulture: [{ required: true,validator: phaValue, trigger: 'change' }],
        // buildingNameWithCulture: [{ required: true, message: '請選擇座數', trigger: 'change' }],
        phaseWithCulture: [{ required: true, message: '請選擇期數', trigger: 'change' }],
        subCategory: [{ validator: cateSubValue, trigger: ['blur', 'change'] }],
        propertyCategory: [{ required: true, message: '必須選擇樓盤類型', trigger: 'change' }],
        categoryNo: [{ required: true, message: '請填寫銷售機會編號', trigger: ['blur', 'change'] }],
        // rentalType: [{ required: true, message: '必須選擇出租或放售', trigger: 'change' }],
        // propertyNo: [{ required: true, message: '請填寫物業編號', trigger: 'blur' }, { validator: propertyNoRepeat, trigger: 'blur' }],
        propertyNo: [
          {
            required: true,
            message: '請填寫物業編號',
            trigger: ['change']
          }
        ],
        vrVal: [{
          message: "暫不支援此VR連結格式，如需加入此VR請 WhatsApp到 5726 6308 與客戶服務聯絡",
          trigger: 'blur',
          validator: vrVerify
        }],
        videoVal: [{
          message: "請輸入帶有https:// 的YouTube或Facebook網站的影片連結",
          trigger: ['change'],
          validator: videoVerify
          // pattern:'/^https://www.(youtube|facebook).com/.*/'
        }],
        salePrice: [{ required: true, message: '請填寫放售價', trigger: 'blur' }, { validator: priceInterval, trigger: 'blur' }],
        rentPrice: [{ required: true, message: '請填寫每月租金', trigger: 'blur' }, { validator: priceInterval, trigger: 'blur' }],
        buildingArea: [{ required: true, trigger: 'blur', validator: validReq }, { validator: validarea, trigger: 'blur' }],
        paidSalePrice:[{required: true, trigger: 'blur', validator: validPriceAll}],
        titleCN: [
          {
            required: true,
            message: '請填寫放盤標題（中文）',
            trigger: ['blur', 'change'],
            pattern: '[^ \x22]+'
            // pattern: /^\S[\s\S]+/
            // pattern:/(^\s)|(\s$)/g
          }, { validator: titleValid, trigger: 'blur' }
        ],
        titleEN: [{ validator: titleENValid, trigger: 'blur' }],
        autoRec:[{ validator: validautoRec, trigger: 'change' }],
        introduceCN: [{ required: true, trigger: ['blur', 'change'],validator: validProint }],
        introduceEN: [{ trigger: ['blur', 'change'],validator: validProintEn }],
        // message: '請填寫設施及服務（中文）',
        servicesCN: [{ required: true,  trigger: ['blur', 'change'] ,validator: validService}],
        servicesEN: [{ trigger: ['blur', 'change'] ,validator: validServiceEn}],
        // isVerify: [{ trigger: ['change', 'click'], validator: validVerify }],
        estateName: [
          {
            required: true,
            message: '請填寫屋苑或大廈名稱（中文）',
            trigger: 'change'
          }
        ],
        gscopeFaCode: [{ required: true, validator: validGscopeFaCode, trigger: 'change' }],
        gscopeCode: [{ required: true,validator: validGscopeCode, trigger: 'change' }],
        // gscopeFaCode: [{ required: true, message: '請選擇屋苑所在地區', trigger: 'click' }],
        // gscopeCode: [{ required: true, message: '請選擇屋苑所在地區', trigger: 'change' }],
        agree: [
          {
            required: true,
            message: '必須同意放盤條款才可繼續',
            trigger: 'click',
            pattern: /true/
          }
        ],

      },
      estate: [],
      attachVisible: false,
      remainderStrDiamond : 0,
      remainderStrPropertyCoin: 0,
      remainderDiamond: 0,
      remainderPropertyCoin: 0,
      coin: true,
      empty: '',
      payWayEmpy:false,
      showCoinPay:true,
      showDiamondPay :true,
      isEmpty_agent: false,
      isdis_agent:false,
      draftlen: false,
      tip: false /** 付款确认提示框*/,
      preData: {} /** 发送到后端的楼盘数据*/,
      preUserData: [] /** 发送到后端的代理人数据*/,
      propertyNoRepeat: false /**物业编号是否重复*/,
      file: [],
      // verifyFile: [],
      // draftVerifyFile: [],
      draftverifyimage: [],
      selectedImage: [],
      enLarge: false, // 图片放大遮罩
      userInfo: [],
      draggableStart: false, //是否开启拖拽
      selectImgShow: false, //是否展示选择图片弹窗
      selList: [], //选择图片列表
      enLarge1: false, //是否展示放大图片
      getConImgae: false, //图片加载中标识
      disSub:{},
      dRentLabel:[],
      arrCat:[],
      hkGscope:[],//hk gscopecode
      overseaGscope:[],//海外gscopecode
      overseaChilGscope:[],
      // 柱状图所需数据
      chartEstateID:'',
      chartScopeCode:'',
      resetID:'',//清空楼盘地址一栏资料时候用来获取楼盘地址和楼龄的estatedid
      chartOne:{
        maxValue:'',
        minValue:'',
        xAxisRangeData:[],
        xAxisData:[],
        seriesOriginData:[],
        transparentArr:[],
        proCompeteCount:'',
        avgVal:''
      },
      chartTwo:{
        minValue:'',
        maxValue:'',
        xAxisRangeData:[],
        xAxisData:[],
        seriesOriginData:[],
        transparentArr:[],
        proCompeteCount:'',
        avgVal:''
      },
      disableAddress:false,//是否禁止输入楼盘地址
      isShowChart:false,
      jumpAutoRec:false,//勾选,跳转楼盘表需弹出自动置顶弹框
      isShowAutoRec:false,//是否展示自动勾选字段
      topRentRecPrice:[],
      topSaleRecPrice:[],
      starRentRecPrice:[],
      starSaleRecPrice:[],
      autoRecommendList:[],
      recAutoDia:'',//自动置顶所需钻石
      restMoney:'',//当前账户选中支付类型后,该支付类型的余额
      disConfirm:false,//刊登最后弹框确认按钮是否禁用
      estateZoneCode:'',
      estateGscopeCode:''
    };
  },
  components: {
    Tooltip,
    ElImageViewer,
    draggable
  },
  watch: {
    isHaveTo(val) {
      this.$refs.propertyInfo.clearValidate('buildingNameWithCulture')
    },
    /**当文件数量变化 手动触发表单验证*/
    // verifyFile(nwal) {
    //   if (nwal.length) {
    //     this.$refs.propertyInfo.validateField('isVerify');
    //   }
    // },
    // 期数,楼层,座数单位,改变 验证文件框
    // 'propertyInfo.buildingName': {
    //   handler(newVal, oldVal) {
    //     this.watchVerifyChange()
    //   },
    // },
    // 'propertyInfo.unitFloor': {
    //   handler(newVal, oldVal) {
    //     this.watchVerifyChange()
    //   },
    // },

    // 'propertyInfo.propertyCategory': {
    //   handler(newVal, oldVal) {
    //     this.tagshow()
    //   },
    //   immediate: true
    // },
    'propertyInfo.rentalType': {
      handler(newVal, oldVal) {
        this.tagshow()
      },
      immediate: true
    },
    addressSearch() {
      this.changesubway()
      this.changeParkSubway()
    },
  },
  computed: {
    isArea:{
      get(){
        return this.propertyInfo.isVerifyArea ? false : true
      },
      set(newVal){
        this.propertyInfo.isVerifyArea = !newVal
      }
    },
    bankVal() {
      let terms = false
      if(this.isVerifyPropertyNO){
        terms = (this.propertyInfo.unitCode || this.propertyInfo.unitID) && this.propertyInfo.buildingType == 1 && this.propertyInfo.roomNo ?true:false
      }else{
        terms = this.propertyInfo.roomNo && this.estAdress.unitList.length && this.propertyInfo.propertyCategory == '1' && this.propertyInfo.buildingType == 1?true:false
      }
      // if ( this.propertyInfo.roomNo && this.estAdress.unitList.length && this.propertyInfo.propertyCategory == '1' && this.propertyInfo.buildingType == 1) {
        if (terms) {
          this.isBoc = true
          // 显示估值
          this.showEvaBut = true
          this.showAgreeEva = true
          this.showBankEva = true
          return true
        } 
          this.isBoc = false
          return false
        
      
    },
    showBankAll(){
      if(this.propertyInfo.isBoc){
        this.showEvaBut = true
        this.showAgreeEva = true
        this.showBankEva = true
        return true
      }
        return false
      
    },
    // 金币钻石不足时或未选具体货币支付类型时,或立即付款 接口返回支付类型与当前金币权限冲突 禁止放盘按钮
    disPostBut() {
      let proType = this.propertyInfo.topType == '0' ? 'Normal' :this.propertyInfo.topType == '1'?'GoldTop':'Star'
      let coinRs = this.propertyInfo.rentalType == 1 ? 'coinSalePrice':'coinRentPrice'
      let diamondRs = this.propertyInfo.rentalType == 1 ? 'diamondSalePrice':'diamondRentPrice'
      let payway = this.propertyInfo.paymentType === 0 ? coinRs : diamondRs
      let ecoinRs = this.propertyInfo.rentalType == 1 ? 'enableCoinSalePrice':'enableCoinRentPrice'
      let ediamondRs = this.propertyInfo.rentalType == 1 ? 'enableDiamondSalePrice':'enableDiamondRentPrice'
      this.restMoney = this.diConfig[proType][payway]
      let flag = this.propertyInfo.paymentType == 0 ?this.diConfig[proType][ecoinRs]:this.diConfig[proType][ediamondRs]
      // 优惠券支付
      if(this.isDisCoupon){
        return false
      }else if(this.diConfig[proType][ecoinRs] && this.diConfig[proType][ediamondRs] && (this.propertyInfo.paymentType !== 0 && this.propertyInfo.paymentType !== 3 )){
        return true
      }else if(this.propertyInfo.paymentType === 0 && this.remainderPropertyCoin < this.diConfig[proType][payway]){
        return true
      }else if(this.propertyInfo.paymentType === 3 && this.remainderDiamond < this.diConfig[proType][payway]){
        return true
      }else if(this.mode ==='1' && !flag){
        return true
      }else if(this.mode ==='1' && this.payOrderMoney && this.remainderPropertyCoin < this.payOrderMoney){
        return true
      }else if(this.mode ==='1' && this.payOrderDia && this.remainderDiamond < this.payOrderDia){
        return true
      }
        return false
      
      // if (this.propertyInfo.topType == '0' && this.remainderPropertyCoin < 100) {
      //   return true
      // } else if (this.propertyInfo.topType == '1' && this.remainderDiamond < 3) {
      //   return true
      // } else if (this.propertyInfo.topType == '3' && this.remainderDiamond < 5 && this.propertyInfo.rentalType == 2) {
      //   return true
      // } else if (this.propertyInfo.topType == '3' && this.remainderDiamond < 10 && this.propertyInfo.rentalType == 1) {
      //   return true
      // } else {
      //   false
      // }
    },
    isHaveTo() {
      if (this.propertyInfo.propertyCategory == 1 && !this.isCutomadded && this.showEstAdressbui && this.editNewDataRule && this.addressSearch) {
        return true
      } 
        return false
      
    },
    // editEst为true 代表屋苑可修改
    editEst() {
      if (this.propertyInfo.topType == '0' && this.isEditStandardEstateName) {
        return true
      } else if (this.propertyInfo.topType == '1' && this.isEditSuperEstateName) {
        return true
      } else if (this.propertyInfo.topType == '3' && this.isEditStarEstateName) {
        return true
      } 
        return false
      
    },
    // true代表去后端拿取数据
    conditions() {
      if (this.isVerifyPropertyNO != false && (this.propertyInfo.propertyCategory == '1' || this.propertyInfo.propertyCategory == '2')) {
        return true;
      } 
        return false;
      
    },
    // 如果是中原 || 利嘉格  conditions返回true
    // conditions() {
    //   if (this.companyCategory != 3 && (this.propertyInfo.propertyCategory == '1' || this.propertyInfo.propertyCategory == '2')) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // },
    // 如果是中原账户刊登住宅||工商铺  返回true
    centaline() {
      if (this.companyCategory == 1 && (this.propertyInfo.propertyCategory == '1' || this.propertyInfo.propertyCategory == '2')) {
        return true;
      } 
        return false;
      
    },
    demo: {
      get: function () {
        return this.propertyInfo;
      }
    },
    // 精选 ｜｜ 星级盘 + 验证
    totaldiamond() {
      // if (this.apiData.isVerify && this.mode === '2') {
      //   return this.propertyInfo.topType === '1' ? this.diConfig.GoldTop.diamond : this.diConfig.Star.diamond;
      // }
      // 可选链操作符?.
      // let diaSlowNetDia = this.propertyInfo.rentalType == 1 ? 10 : 5
      // return this.propertyInfo.topType === '1' ? this.diConfig.GoldTop?.diamond ? this.diConfig.GoldTop.diamond : 3 : this.diConfig.Star?.diamond ? this.diConfig.Star.diamond : diaSlowNetDia;
      // 旧版 楼盘验证所需钻石数
      // return this.propertyInfo.topType === '1' ? (this.propertyInfo.isVerify ? this.diConfig.VerifyLabel.diamond + this.diConfig.GoldTop.diamond : this.diConfig.GoldTop.diamond) : this.propertyInfo.isVerify ? this.diConfig.VerifyLabel.diamond + this.diConfig.Star.diamond : this.diConfig.Star.diamond;
      let isSaleRent = ''
      isSaleRent = this.propertyInfo.rentalType == 1 ? 'diamondSalePrice' : 'diamondRentPrice'
      if(this.isDisCoupon){
        return this.couponPro[isSaleRent]
      }
        return this.mode === '1' && this.payOrderDia ? this.payOrderDia:this.propertyInfo.topType === '1'&& this.diConfig.GoldTop ? this.diConfig.GoldTop[isSaleRent] : this.propertyInfo.topType === '3' && this.diConfig.Star? this.diConfig.Star[isSaleRent] : this.diConfig.Normal[isSaleRent];
      
    },
    totalPrice() {
      let isSaleRent = ''
      isSaleRent = this.propertyInfo.rentalType == 1 ? 'coinSalePrice' : 'coinRentPrice'
      if(this.isDisCoupon){
        return this.couponPro[isSaleRent]
      }
        return this.mode === '1' && this.payOrderMoney ? this.payOrderMoney:this.propertyInfo.topType === '1'&& this.diConfig.GoldTop? this.diConfig.GoldTop[isSaleRent] : this.propertyInfo.topType === '3'&& this.diConfig.Star ? this.diConfig.Star[isSaleRent] : this.diConfig.Normal[isSaleRent];
      
    },
    OriginalPrice(){
      let isSaleRent = ''
      if(this.propertyInfo.paymentType == 3){
        isSaleRent = this.propertyInfo.rentalType == 1 ? 'diamondSalePrice' : 'diamondRentPrice'
      }else{
        isSaleRent = this.propertyInfo.rentalType == 1 ? 'coinSalePrice' : 'coinRentPrice'
      }
      return this.propertyInfo.topType === '1'&& this.diConfig.GoldTop? this.diConfig.GoldTop[isSaleRent] : this.propertyInfo.topType === '3'&& this.diConfig.Star ? this.diConfig.Star[isSaleRent] : this.diConfig.Normal[isSaleRent];
      
    }
  },
  async beforeRouteLeave(to, from, next) { 
    sessionStorage.setItem('refreshpro','false')
    sessionStorage.setItem("refreshID",'')
   if(this.mode !=='edit'){
    if(to.fullPath !== '/login' && this.postNext){
      if((this.propertyInfo.estateName === undefined || this.propertyInfo.estateName == '') && this.images.length == 0){
        let data = {
          'draftID':[this.propertyInfo.draftID],
        };
        fetch(`${this.baseUrl}Property/RemovePropertyDraft?cityen=hk&platform=pc&language=zh-hk&token=${this.token}`, {
          method: 'POST',
          body:JSON.stringify(data),
          headers: {'Content-Type': 'application/json'},
          keepalive: true
        });
      }else if(this.draftType != 'historyBack' &&(this.propertyInfo.estateName || ( this.images && this.images.length != 0))){
        await this.addDraft('acquireId')
      }
      next()
    }else{
      next()
    }
   }else{
    if (to.fullPath === '/property/index?fromSource=edit' || this.butFormSource) {
      return next()
    }
    this.$confirm('如果你在頁面上有進行過修改，離開當前頁面會導致所做的修改將丟失', '提示', {
      confirmButtonText: '儲存',
      cancelButtonText: '捨棄',
      closeOnClickModal: false,
      distinguishCancelAndClose:true,
      type: 'warning'
    }).then(async () => {
      this.formSource = false
      this.showScoreAgain = false
      this.validation('propertyInfo')
      setTimeout(()=>{
        if(this.validatePass){
            next({path:'/property/index',query: { fromSource: 'edit' }})
        }
      },2000)
    }).catch(action => {
      if(action == 'cancel'){
        next()
      }
    })
   }
  },
  async created() {
    // 第三方登录
    let info = this.$route.query
    if (info.email && info.signature) {
      info.signature = info.signature.replace(/\s+/g, '+')
      let loginInfo = await this.axios
        .post(this.pub.getApi().LoginEmail, {
          encryptEmail: encodeURI(info.signature),
          email: info.email,
          key: info.key,
          license: info.license
        })
      if (loginInfo.data.code == 0) {
        this.pub.setCookie('dEVaUDFrZ1kd0RA', loginInfo.data.result.token);
        // 修改uerinfo 获取当前用户权限
        loginInfo.data.result.roleList.forEach(item => {
          if (item.roleID === loginInfo.data.result.roleID) {
            res.data.result.currentRoleID = item.roleName;
          }
        });
        this.$store.commit('setUserInfo', loginInfo.data.result);
        await this.pub.obtainAndSetRoutes(loginInfo.data.result.currentRoleID)
        await this.pub.obtainAndSetPermissions(loginInfo.data.result.currentRoleID);
        this.propertyInfo.propertyCategory = info.propertyCategory;
        if (info.propertyCategory == '2') {
          // 工商铺
          this.propertyInfo.categoryNo = info.postNo;
          this.checkRepeat(this.propertyInfo.categoryNo);
        }
        else if (info.propertyCategory == '1') {
          // 住宅
          this.propertyInfo.propertyNo = info.postNo;
          this.checkRepeat(this.propertyInfo.propertyNo);
        }
      }
      else if (loginInfo.data.code == 1336) {
        this.warning('自動登錄超時')
        this.pub.delCookie('dEVaUDFrZ1kd0RA');
        this.$router.push('/login')
      }
      else {
        return this.showLogin = true;
      }
    }

    if (this.$route.query.rentalType) {
      this.propertyInfo.rentalType = this.$route.query.rentalType;
    }
    if (this.$route.query.type) {
      this.mode = this.$route.query.type;
    }
    let res = await Promise.all([this.SearchStaffUser(), this.GetGscope(), this.getDictionary(), this.GetUserInfo(), this.GetCompanyCofig(), this.GetAccountResource(), this.getAppConfig(),this.GetDisSub()])
    this.diConfig.agentList = res[0].data.result; /** 获取当前代理列表 */
    this.editAgentList = JSON.parse(JSON.stringify( res[0].data.result));
    // if (res[5].data.result.resourceValue == 1) {
    //   //若是为1 则需要展示刊登引导 则展示页面假元素
    //   this.isFirst = true
    // }
    /** 获取地区 */ 
    res[1].data.result.forEach(item => {
      if(item.gscopeCode != "HK10"){
        item.children.forEach(i => {
          this.hkGscope.push(i);
          this.diConfig.gscope.push(i);
        });
      }else{
        item.children.forEach(i => {
          this.overseaGscope.push(i);
        });
      }
    });
    this.disSub = res[7].data.result
    //   /** 字典赋值 */
    this.diConfig.PropertyTag = res[2].PropertyTag.children
    this.flatTag = this.diConfig.PropertyTag.flatMap(obj=>obj.children)
    this.tagshow()
    // 取消刊登引导
    // if (this.isFirst) {
    //   // 首次进入 则显示引导图
    //   this.guidePage()
    // }
    // 刊登 中原李嘉格 禁止选择土地
    // this.diConfig.PropertyCategory = res[2].PropertyCategory.children;
    this.diConfig.UnitFloor = res[2].UnitFloor.children;
    this.diConfig.RoomNumber = res[2].RoomNumber.children;
    this.diConfig.ToiletNumber = res[2].ToiletNumber.children;
    this.diConfig.PropertyImageType = res[2].PropertyImageType.children;
    this.diConfig.RentLabel = res[2].RentLabel.children;
    this.dRentLabel = res[2].RentLabel.children;
    // this.diConfig.UnitFloor.unshift({
    //   dictionaryNameWithCulture: '請選擇樓層',
    //   dictionaryValue: null
    // });
    this.diConfig.PropertyImageType.unshift({
      dictionaryNameWithCulture: '圖片位置',
      dictionaryValue: ''
    });
    this.remainderDiamond = res[3].data.result.remainderDiamond;
    this.remainderPropertyCoin = res[3].data.result.remainderPropertyCoin;
    //   /**当前用户金币赋值userInfo赋值*/
    this.remainderStrDiamond = res[3].data.result.remainderDiamond.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    this.remainderStrPropertyCoin = res[3].data.result.remainderPropertyCoin.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    this.userInfo = res[3].data.result;
    this.isUseInstantEstateVolume = res[4].data.result.isUseInstantEstateVolume
    this.publicAgentNumber = res[4].data.result.publicAgentNumber;
    this.companyCategory = res[4].data.result.companyCategory;//1.中原 2.李嘉格 3.普通用户
    this.isVerifyPropertyNO = res[4].data.result.isVerifyPropertyNO
    this.isUseHideAgent = res[4].data.result.isUseHideAgent
    this.isUpdateCompany = res[4].data.result.isUpdateCompany
    this.isUseStandard = res[4].data.result.isUseStandard
    this.isUseStar = res[4].data.result.isUseStar
    this.isUseSuper = res[4].data.result.isUseSuper
    this.isUsedDiamond = res[4].data.result.isUsedDiamond;
    this.isOwner = res[4].data.result.isOwner;
    this.isDefaultPropertyNo = res[4].data.result.isDefaultPropertyNo
    // 仅针对 是否显示 自动置顶与可升级放盘 的文字提示使用
    this.isShowAutoRecCount = 0
    let propertyVal = [ this.isUseStandard,this.isUseSuper,this.isUseStar]
    for (let i = 0; i < propertyVal.length; i++) {
      if(propertyVal[i] == true){
        this.isShowAutoRecCount++
      }
    }
    this.isUsedCoin = res[4].data.result.isUsedCoin
    this.isShowDiamondHistory = res[4].data.result.isShowDiamondHistory
    this.isShowCoinHistory = res[4].data.result.isShowCoinHistory
    this.accountType = res[4].data.result.accountType
    this.isaddVR = res[4].data.result.addVR
    this.InputVR = res[4].data.result.inputVR
    this.adRank = res[4].data.result.adRank
    this.isEditStandardEstateName = res[4].data.result.isEditStandardEstateName
    this.isEditSuperEstateName = res[4].data.result.isEditSuperEstateName
    this.isEditStarEstateName = res[4].data.result.isEditStarEstateName
    this.isShowTelephoneBtn = res[4].data.result.isShowTelephoneBtn
    this.vrRules = res[6].data.result.vrPrefixJudgment
    this.isShowBoc = res[6].data.result.Isboc
    for (let i = 0; i < res[6].data.result.prefixJudgment.length; i++) {
      this.videoRules.push(...res[6].data.result.prefixJudgment[i].urlPrefix)
    }
    // .replace(/https/g,"(https|http)")
    this.verifyVideo = this.videoRules.join('|').replace(/\./g, "[\.]")
    this.verifyVr = this.vrRules[0].urlPrefix.join('|').replace(/https/g, "(https|http)").replace(/\./g, "[\.]")
    // 中利老数据楼盘地址栏相关项无须必填
    if (this.companyCategory !== 3) {
      this.editNewDataRule = false
    }
    // true代表为公司账户
    if (this.accountType && (this.userInfo.roleID == 1 || this.userInfo.roleID == 2)) {
      await this.getDepartmentById(this.userInfo.departmentID);
    }

    if (this.companyCategory == 1) {
      this.diConfig.agentList = [{ ...this.userInfo }];
      let copyUserInfo=Object.assign({}, this.userInfo);
      this.editcompanyUserInfo.push(copyUserInfo)
      this.propertyUserInfo = [{ ...this.userInfo }];
      this.editAgentList.push(copyUserInfo)
      this.agent.push(this.diConfig.agentList[0].accountID);
    }
    // 刊登楼盘页 编辑楼盘代理人控制在getpropertyuserinfo 付款页3改1时候,不能显示为放盘人
    if (this.publicAgentNumber == 1 && this.$route.query.type != 1) {
      this.diConfig.agentList = [{ ...this.userInfo }];
      let copyUserInfo=Object.assign({}, this.userInfo);
      this.editcompanyUserInfo.push(copyUserInfo)
      this.propertyUserInfo = [{ ...this.userInfo }];
      this.editAgentList.push(copyUserInfo)
      this.agent.push(this.diConfig.agentList[0].accountID);
    }
    // if (!this.$route.query.draftID) {
    //   this.SearchPropertyPriceSet(); /** 搜索房源服务价格 */
    // }
    this.GetPropertyCount(); /** 获取当前房源数量 */
    this.GetCommonWord(); /** 获取常用词*/
    this.sensitive = this.debounce(this.sensitive, 500); /** 搜索敏感词，防抖*/
    this.sendData = this.debounce(this.sendData, 500); /** 提交楼盘，续期 防抖*/
    this.draft = this.debounce(this.draft, 500)//草稿防抖
    await this.SearchPropertyPriceSet()
    /**  type 获取当前模式   edit 修改 copy复制  1立即付款  2续期 */
    if (this.$route.query.type) {
      // this.mode = this.$route.query.type;
      if (this.mode != 'post') {
        this.searchRes = true;
      }
      // 屋苑下拉框样式更改
      if(this.mode != 'post' && this.mode != 'copy'){
        this.dynamicClass = ''
      }
      this.propertyId = this.$route.query.propertyId;
      this.GetPropertyFullById();
      this.GetPropertyUserInfoFullById();
    }
     // 刊登隐藏禁用楼盘类型 编辑禁用后台禁用楼盘类型
     this.arrCat = res[4].data.result
    // post(刊登,复制,草稿箱)需要删除土地选项 -- 编辑楼盘(edit)可保留土地 --中利
    // if (this.mode == 'post' && this.$route.query.type !== 'edit' && (res[4].data.result.companyCategory == 1 || res[4].data.result.companyCategory == 2)) {
    //   this.diConfig.PropertyCategory.splice(-1, 1)
    // }
    // if (this.$route.query.rentalType) {
    //   this.propertyInfo.rentalType = this.$route.query.rentalType;
    // }
    /**HOUSEMIS-505  金幣餘額不足，將無法成功放盤，請先充值。 */
    // if (!this.isFirst) {
    // 首次进入走 引导中的钻石提示
    // }
    // 默认选中第一个盘
    if (this.isUseStandard && this.mode !== '1') {
      this.propertyInfo.topType = '0';
    } else if (this.isUseSuper) {
      this.propertyInfo.topType = '1';
    } else {
      this.propertyInfo.topType = '3';
    }
    if(this.mode === 'post'){
      let proCatStr= this.propertyInfo.rentalType == 1 ? 'propertyCategorySale':'propertyCategoryRent'
      this.diConfig.PropertyCategory = this.filterArray( this.arrCat[proCatStr])

      // 中原优惠券楼盘
      try {
        // fromZy 为判断是否中原优惠券盘关键字段 后续中原优惠券使用结束后，所有fromZy出现包裹代码即可删除
        if(this.$route.params.origin == 'zycoupon'){
          this.fromZy= true
          // 中原赋值楼盘类型
          this.propertyInfo.propertyCategory = '1'
          const item = this.diConfig.PropertyCategory.find(el => el.dictionaryValue == this.propertyInfo.propertyCategory);
          this.diConfig.ChildrenCategory = item.children;
          // 根据屋苑id 获取屋苑
          await this.setEstate(this.$route.params)
          this.subTypeSel()
          this.propertyInfo.couponKeyword = this.$route.params.couponKeyword
          //hk要求 zy优惠券跳转要默认选中其允许的放盘方式，不允许的要禁用。
          if(this.$route.params.topType){
            // 赋值页面topType
            let topType = this.$route.params.topType
            let topTypesArray = topType.split(',');
            let validNumbers = [];
            let elements  = [
              { value: 0, isUse: this.isUseStandard },
              { value: 1, isUse: this.isUseSuper },
              { value: 3, isUse: this.isUseStar }
            ];
            topTypesArray.forEach(numStr => {
              let num = parseInt(numStr, 10);
              let element = elements.find(e => e.value === num);
              if (element && element.isUse) {
                validNumbers.push(num);
              }
            });
            this.propertyInfo.topType = validNumbers.length > 0 ? Math.min(...validNumbers).toString() : '100';
            // 判断页面toptype是否禁用          
            let array = [0, 1, 3];
            array.forEach(num => {
              switch (num) {
                  case 0:
                      if (!topTypesArray.includes('0')) {
                        this.isDisableStand = true;
                      }
                      break;
                  case 1:
                      if (!topTypesArray.includes('1')) {
                        this.isDisableSuper = true;
                      }
                      break;
                  case 3:
                      if (!topTypesArray.includes('3')) {
                        this.isDisableStar = true;
                      }
                      break;
                  default:
                      break;
              }
            });
            
          }
          // zy存在期数去选期数筛选（eg获取对应座数下拉）
          if(this.$route.params.parentEstateID){
            let zyPhase ={}
            this.estAdress.phaseEstates.forEach(it => {
              if (this.$route.params.estateID == it.estateID) {
                this.propertyInfo.phaseEstateId = it.estateID
                zyPhase = it
              }
            })
            if(!this.$route.params.buildingID){
              this.propertyInfo.phaseWithCulture = zyPhase.phaseWithCulture
            }
            await this.setPhaBuild('phase', zyPhase)
            this.couponPhase = true
          }
          // 存在座数去获取座数下拉以及后续操作（eg楼层获取）
          if(this.$route.params.buildingID){
            let zyBuild={}
            this.estAdress.buildings.forEach(ele => {
              if(ele.buildingID == this.$route.params.buildingID) {
                zyBuild = ele
              } 
            });
            await this.setPhaBuild('build', zyBuild)
            this.couponBuild = true
          }
          this.couponConInput()
          let main = document.querySelector('.el-main');
          main.scroll({
            top: 0,
            left: 0,
          });
          // 由于中原数据存在座数对不上选项，为保证座数与所给数据一致，需后赋值
          // for (let key in this.$route.params) {
          //   console.log("key",key)
          //   if (this.propertyInfo.hasOwnProperty(key)) {
          //     this.propertyInfo[key] = this.$route.params[key]
          //   }
          // }
        }
      } catch (error) {
        console.log("zyError",error)
      }
      this.initializeEditMode()
      // 判断置顶文字 与 升级放盘方式文字 是否显示
      if(this.isShowAutoRecCount > 1){
        if((this.isUseSuper && this.propertyInfo.topType == '0') || (this.isUseStar && (this.propertyInfo.topType == '0' || this.propertyInfo.topType == '1'))) {
          this.isShowHighTop = true
        }else{
          this.isShowHighTop = false
        }
      }
      this.isShowRecAuto('isShowAutoRecCount',this.propertyInfo.topType)
      this.changeCoinDia()
      if(this.isDefaultPropertyNo){
        this.propertyInfo.propertyNo = '--'
      }
    }

    // 未选屋院时候 近港铁不予展示
    if (!Object.keys(this.EstateInfo).length) {
      this.changesubway()
      this.changeParkSubway()
    }

    //   /**来自草稿箱*/
    if (this.$route.query.draftID === 0 || this.$route.query.draftID) {
      await this.draftReview(this.$route.query.draftID)
    }
    
    this.diaTit()

  },//create的括号
  destroyed() {
    window.removeEventListener('popstate', this.goBack, false);
    // window.removeEventListener('beforeunload', e => this.beforeunloadHandler(e))
    // window.removeEventListener('unload', e => this.unloadHandler(e))
    window.removeEventListener('beforeunload', this.beforeunloadHandler);
    window.removeEventListener('unload', this.unloadHandler)
  },
  mounted() {
    if (window.history && window.history.pushState ) {
      history.pushState(null, null, document.URL);
      window.addEventListener('popstate', this.goBack, false);
    }
    this.$route.query.type == 'edit' || this.$route.query.type == 'copy' ?window.addEventListener('beforeunload', e => this.beforeunloadHandler(e)): window.addEventListener('unload',this.unloadHandler)
    this.baseUrl = process.env.VUE_APP_TYPE == 'dev' || process.env.VUE_APP_TYPE == 'uat'?'//uatpmsapi.house730.com.cn/':process.env.VUE_APP_TYPE == 'sim'?'//simpmsapi.house730.com/':'//pmsapi.house730.com/'
    // this.identification = this.pub.getGid();
    this.token = this.pub.getCookie('dEVaUDFrZ1kd0RA')
    this.imgBaseUrl = process.env.VUE_APP_TYPE == 'dev' || process.env.VUE_APP_TYPE == 'uat'?'https://uatrtc.house730.com.cn':process.env.VUE_APP_TYPE == 'sim'?'https://simrtc.house730.com':'https://rtc.house730.com'
    // let connectScript = document.createElement('script');
    // connectScript.type = 'text/javascript';
    // // connectScript.src = 'https://static.house730.com/m/js/signalr.min.js';
    // connectScript.src = 'https://static.house730.com/m/js/signalr6.min.js';
    
    // document.body.appendChild(connectScript);
    // connectScript.onload = () => this.initScoket();
    if(sessionStorage.getItem('refreshpro') == 'true'){
      this.$confirm('是否恢復最近的草稿', '提示', {
        confirmButtonText: '確認',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        showClose:false,
        type: 'warning'
      }).then(async () => {
        let draftID = sessionStorage.getItem('refreshID')
        if (!this.$route.query.draftID) {
          await this.draftReview(draftID)
        }
        if(this.$route.query.gradeRule == 'starValidate'){
          this.validaCustom()
        }
        // await this.draftReview(draftID)
        return
      }).catch(() => {
        sessionStorage.setItem("refreshID",'')
        sessionStorage.setItem('refreshpro','false')
        // 修改楼盘，其图片链接的id为楼盘id,其余的类型楼盘图片identification为草稿箱id
        // 生成新的草稿id 复制和修改在页面未曾刷新过（refreshpro为false）时，fullbyid方法中会进行草稿箱存储，
        // 刷新过后的页面，如用户不采用草稿覆盖，点击了取消，则去生成一个新的草稿id
        if(this.mode == 'copy' || this.mode == 'edit' || (this.mode == 'post' && !this.$route.query.draftID)){
          this.addDraft('acquireId')
        }
        if(this.$route.query.gradeRule == 'starValidate'){
          this.validaCustom()
        }
      })
    }else{
      if(this.mode == 'post' && !this.$route.query.draftID){
        this.addDraft('acquireId')
      }
    }
    // else{
    //   // 首次进入页面添加草稿，为了获取草稿id，用来配置生成code需要的identification
      // this.$nextTick(function () {
      //   this.createQRCode();
      // });
    // }
    // 引入图片上传插件
    let zipImg = document.createElement('script');
    zipImg.type = 'text/javascript';
    zipImg.src = 'https://static.house730.com/m/js/oss-upload.03.js';
    document.body.appendChild(zipImg);
    zipImg.onload = () => this.initZipImg();
    // window.addEventListener("click", this.changeP);
  },
  // beforeDestroy() {  // 实例销毁之前对点击事件进行解绑
  //   window.removeEventListener('click', this.changeP);
  // },
  beforeDestroy() {
    clearInterval(this.messageTimer);
    clearInterval(this.draftTimer);
  },

  methods: {
    // 是否开启切换手动输入
    initializeEditMode() {
      this.isEditMode = ['post', 'copy', 'edit'].includes(this.mode);
      this.manualAdd = !this.fromZy && this.isEditMode && !(this.mode === 'edit' && !this.editEst) && !this.conditions;
    },
    getPorpertyUpgradeOrder(id){
        this.axios.get(this.pub.getApi().GetPropertyCapabilities, {
            params: { propertyId: id }
        }).then(response => {
            this.propertyOrder = response.data.result
        })
    },
    getCache(){
      // if (this.isDeleting || this.uploadImgStatus) {
      //   return;
      // }
      if (this.isRetryDialogOpen) {return}
      return new Promise((resolve, reject) => {
        
      if(!this.identification){
        this.$confirm('無法與移動端共享圖片，請嘗試重新刊登屋苑名稱後掃碼', '提示', {
          confirmButtonText: '確認',
          showCancelButton:false,
          closeOnClickModal: false,
          showClose:false,
          type: 'warning'
        })
        resolve()
        return;
      }

      this.axios.get(this.imgBaseUrl+'/Cache/GetCache?identification='+this.identification ).then(res => {
          if (res.status == 200 && res.data) {
            let message = res.data;
            if(!this.isDeleting && !this.uploadImgStatus && !this.isRotating){
              if (this.file.length > this.images.length) {
                var temp = this.file.length - this.images.length;
              }
              this.images = message;
              this.file = message;
              for (var i = 1; i <= temp; i++) {
                this.file.push({ file: true });
              }
              if (this.images.length) {
                this.images.forEach(item => {
                  if (item.imageType === '0') {
                    item.imageType = '';
                  }
                });
              }
            }
            resolve()
          }
        }).catch(function (error) {
          resolve()
          let errData = {
            'type':'catch-pc-GetCacheMessage',
            'msg':error.response.statusText
          }
          this.axios.post(this.pub.getApi().PushException,errData);
          if(error.response.status == 401){
            this.error('登錄已過期，請重新登錄！');
          }else{
            this.error('有圖片獲取失敗，請嘗試刷新頁面再次獲取');
          }
        })
      })

    },
    async pushCache(type){
      if (this.isRetryDialogOpen) {return}
      // return
      return new Promise(async (resolve,reject)=>{

      if(!this.identification){
        this.$confirm('無法與移動端共享圖片，請嘗試重新刊登屋苑名稱後掃碼', '提示', {
          confirmButtonText: '確認',
          showCancelButton:false,
          closeOnClickModal: false,
          showClose:false,
          type: 'warning'
        })
        resolve()
        return;
      }
        const filteredImages = this.images
      .filter(item => item.imagePath) // 只保留已上传的图片
      .map(({ localPath, ...rest }) => rest); 
        let data ={
          'Identification':String(this.identification),
           "Message":JSON.stringify(filteredImages)
        }
        await this.axios.post(this.imgBaseUrl+'/Cache/PutCache' ,data ).then(res => {
          if(type == 'uploadImg'){
            this.uploadImgStatus = false 
          }
          if (res.status == 200 ) {
            console.log('pushCache');
          }
          resolve()
        }).catch(function (error) {
          this.uploadImgStatus = false 
          let errData = {
            'type':'catch-pc-PushCacheMessage',
            'msg':error.response.statusText
          }
          this.axios.post(this.pub.getApi().PushException,errData);
          if(error.response.status == 401){
            this.error('登錄已過期，請重新登錄！');
          }else{
            this.error('有圖片上傳失敗，請嘗試重新上傳！');
          }
          resolve()
        })
      })
    },

    clearVal(type){
      this.propertyInfo[type] = ''
      if(type == 'roomNo'){
        this.propertyInfo.roomNoEN = ''
        this.setEstData()
        // 清楚单位平面图
        this.platUrls = []
        this.planChecked = []
      }
    },
    setRoomNumber(item){
      if(this.propertyInfo.propertyCategory == 1 && item.dictionaryValue && this.isUseInstantEstateVolume){
        this.isShowChart = true
        if(!this.propertyInfo.estateID && this.chartScopeCode){
          this.getChartData('chartOne')
        }else if(this.propertyInfo.estateID){
          this.getChartData('chartOne')
          this.getChartData('chartTwo')
        }
      }
    },
    isShowRecAuto(type,topType){
        // this.jumpAutoRec = false
        this.propertyInfo.isAutoRecommend = false
        // this.isShowAutoRec = false
        // if(!this.isUseInstantEstateVolume || type == 'Normal' || topType == 0) return
        // if(!this.isUseInstantEstateVolume) return
        let autoRecPropertyType = ''
        if(type == 'isShowAutoRecCount'){
          autoRecPropertyType = topType == 1 ? 'GoldTop' : topType == 3 ? 'Star' :''
        }else{
          autoRecPropertyType = type
        }
        // 判断自动置顶
        // let permitRecAutoType = this.propertyInfo.rentalType == 1 ? 'enableDiamondSalePrice' : 'enableDiamondRentPrice'
        // let autoRecPriceType = this.propertyInfo.rentalType == 1 ? 'diamondSalePrice':'diamondRentPrice'
        // let autoRecDayType = this.propertyInfo.rentalType == 1 ? 'saleRecommendNumber':'rentRecommendNumber'
        this.axios.get(this.pub.getApi().GetCompanyPropertyAutoRecommendPriceSets).then(res => {
          if (res.data.code === 0 && res.data.result) {
            this.topRentRecPrice = res.data.result.filter(item => item.itemName === 'GoldTop' && item.rentalType === 2);
            this.topSaleRecPrice = res.data.result.filter(item => item.itemName === 'GoldTop' && item.rentalType === 1);
            this.starRentRecPrice = res.data.result.filter(item => item.itemName === 'Star' && item.rentalType === 2);
            this.starSaleRecPrice = res.data.result.filter(item => item.itemName === 'Star' && item.rentalType === 1);
            //自动置顶筛选项下拉列表
            this.changeAutoRecList(autoRecPropertyType)
            // let foundObj = res.data.result.find(obj => obj.itemName === autoRecPropertyType);
            // this.isShowAutoRec = foundObj ? foundObj[permitRecAutoType] : false; 
            // this.recAutoDia = this.isShowAutoRec ? foundObj[autoRecPriceType] :''
            // this.recAutoDay = this.isShowAutoRec ? foundObj[autoRecDayType] :''
          }
      });
    },
    changeAutoRecList(topType){
      this.propertyInfo.isAutoRecommend = false
      this.autoRecommendList = [] 
      this.isShowAutoRec = false
      if( topType == 'GoldTop' ){
          this.autoRecommendList = this.propertyInfo.rentalType == 1 ? this.topSaleRecPrice : this.topRentRecPrice
      }else if(topType == 'Star'){
          this.autoRecommendList = this.propertyInfo.rentalType == 1 ? this.starSaleRecPrice : this.starRentRecPrice
      }else{
        this.isShowAutoRec =false
        return
      }
      this.isShowAutoRec = this.autoRecommendList && this.autoRecommendList.length ? true : false; 
      if(this.autoRecommendList && this.autoRecommendList.length == 1){
        this.propertyInfo.propertyCoinSetID = this.autoRecommendList[0].id
        this.recAutoDia = this.autoRecommendList[0].price
      }else{
        this.recAutoDia = ''
        this.propertyInfo.propertyCoinSetID = ''
      }
    },
    clearRecSetID(){
      if(!this.propertyInfo.isAutoRecommend){
        this.propertyInfo.propertyCoinSetID =''
        this.recAutoDia = ''
      }else if(this.propertyInfo.isAutoRecommend && this.autoRecommendList && this.autoRecommendList.length == 1){
        this.recAutoDia = this.autoRecommendList[0].price
        this.propertyInfo.propertyCoinSetID = this.autoRecommendList[0].id
      }
    },
    selAutoRecOption(item){
      this.recAutoDia = item.price
      this.$forceUpdate()
    },
    async getChartData(type){
      if(this.propertyInfo.propertyCategory == 1 && (this.chartEstateID && this.propertyInfo.roomNumber) || (!this.chartEstateID && this.chartScopeCode && this.propertyInfo.roomNumber)){
        // 楼盘类型 屋苑id 价格都存在时可以发送请求
        let data={
          "propertyCategory":[1],
          "subCategory":this.propertyInfo.subCategory,
          "estateIds": [],//子屋苑id
          "rentalType": this.propertyInfo.rentalType,//租售类型
          "gscopeCode": [],
          "roomNumber":this.propertyInfo.roomNumber
        }
        if(this.chartEstateID && type == 'chartTwo'){
          data.estateIds.unshift(this.chartEstateID)
          data.gscopeCode = []
        }
        if(this.chartScopeCode && type == 'chartOne'){
          data.estateIds= []
          data.gscopeCode.unshift(this.chartScopeCode)
        }
        let res = await this.axios.post(this.pub.getApi().GetPropertyPriceStat, data)
        if(this.propertyInfo.rentalType == 1){
          this[type].avgVal =  res.data.result.avgValue ? ( res.data.result.avgValue >= 100000000 ? '$' + parseInt( Math.round(res.data.result.avgValue) / 100000000)+'億':'$' + parseInt( Math.round(res.data.result.avgValue) / 10000)+'萬') : '-' 
          this[type].maxValue  = res.data.result.maxValue >= 100000000?(res.data.result.maxValue / 100000000).toFixed(2)+'億':(res.data.result.maxValue / 10000)+'萬'
          this[type].minValue  = res.data.result.minValue >= 100000000?(res.data.result.minValue / 100000000).toFixed(2)+'億':(res.data.result.minValue / 10000)+'萬'
        }else{
          this[type].avgVal = res.data.result.avgValue ? '$' + parseInt(Math.round(res.data.result.avgValue))+'元' : '-' 
          this[type].maxValue = res.data.result.maxValue+'元'
          this[type].minValue = res.data.result.minValue+'元'
        }
        this[type].xAxisData = res.data.result.priceStats.filter(item => item.count !== 0);
        this[type].xAxisRangeData = this[type].xAxisData.map((item,index) => {
          if(this.propertyInfo.rentalType == 1){
            let priceEnd=''
            let priceStart =''
            priceEnd = item.maxValue>= 100000000?parseInt(item.maxValue / 100000000)+'億':parseInt(item.maxValue / 10000)+'萬'
            priceStart = item.minValue >= 100000000?parseInt(item.minValue / 100000000)+'億':parseInt(item.minValue / 10000)+'萬'
            // this[type].xAxisRangeData.push(priceStart+'-'+priceEnd) 
            return priceStart+'-'+priceEnd
          }
            return item.minValue+'元'+'-'+item.maxValue+'元'
          
        })
        this[type].proCompeteCount = res.data.result.allCount//同区竞争量
        // this[type].seriesOriginData = res.data.result.priceStats.map(item => item.count)
        this[type].seriesOriginData = this[type].xAxisData.map(item => {
          if(item.count == 1){
            item.count += 0.5
          }
          return item.count
        })
        this[type].transparentArr = new Array(this[type].seriesOriginData.length).fill(0.5)
        this.loadBar(type)
        // 当修改屋苑 同时价格还存在 对应价格是否高亮图中,再次判断
        this.isPassPriceChart().then(suc=>{
          this.changePriceChart(type,suc)
        })
      }
    },
    // 绘图价格变动时 重新绘图
    isPassPriceChart(){
      return new Promise((suc,err)=>{
            if(this.propertyInfo.rentalType == 2 ){
              if(this.propertyInfo.rentPrice){
                  suc(this.propertyInfo.rentPrice)
              }else{
                err()
              }
            }
            if(this.propertyInfo.rentalType == 1 ){
              if(this.propertyInfo.subCategory.includes('6')  || this.propertyInfo.subCategory.includes('7')||this.propertyInfo.subCategory.includes(6) || this.propertyInfo.subCategory.includes(7)){
                if (this.propertyInfo.paidSalePrice) {
                  suc(Number(this.propertyInfo.paidSalePrice)*10000)
                }else if(this.propertyInfo.unPaidSalePrice){
                  suc(Number(this.propertyInfo.unPaidSalePrice)*10000)
                }else{
                  err()
                }
              }else if(this.propertyInfo.salePrice){
                suc(this.propertyInfo.salePrice*10000)
              }else{
                err()
              }
            }
      })
    },
    changePriceChart(type,price){
      // 当价格改变时 调用此方法
      let xAxisCopyData = []
      let seriesChartData = []
      let colorHighlight={
        value: '',
        itemStyle: {
          color: '#0062FF'
        }
      }
      let echartType = type == 'chartOne' ? 'myChartOne':'myChartTwo'
      xAxisCopyData = JSON.parse(JSON.stringify(this[type].xAxisData))
      for (let index = 0; index < xAxisCopyData.length; index++) {
        if( price >= xAxisCopyData[index].minValue && price <= xAxisCopyData[index].maxValue){
          colorHighlight.value = xAxisCopyData[index].count
          xAxisCopyData[index].count = colorHighlight
          seriesChartData = xAxisCopyData.map(item => item.count)
          this[echartType].setOption({
              series: [{
                  id:'series2',
                  data:seriesChartData
              }]
          });
          break;
        }else{
          this[echartType].setOption({
              series: [{
                  id:'series2',
                  data:this[type].seriesOriginData
              }]
          });
        }
      }
    },
    loadBar(type){
      let echartType = type == 'chartOne' ? 'myChartOne':'myChartTwo'
      this[echartType] = echarts.init(document.getElementById(echartType));
      let maxlength = this[type].xAxisRangeData.length+2
      // 展示柱状图
      let option ={
        xAxis: {
            type: 'category',
            data:this[type].xAxisRangeData,
            axisLabel:{
              interval:20000,
              showMaxLabel:false,
              showMinLabel:false
            },
            min:-2,
            max:maxlength,
            axisTick:{
              show:false
            },
            axisLine: {
              onZero: false,
              lineStyle: {
                color: '#00479C ',// X轴线的颜色
                width: 4, // x轴线的宽度
                type:'solid'
              }
            },
            offset:2,//x轴加宽后被盖住问题
          },
          tooltip: {
            trigger: 'axis',
            formatter: function (params) {
              let returnData = params[0].name + "<br/>";
              for (let i = 0; i < params.length; i++) {
                  let indexColor = params[i].color;
                  returnData += '<span style="display:inline-block;margin-right:5px;border-   radius:10px;width:9px;height:9px;background:' + indexColor + '"></span>';
                  if (params[i].seriesType == "bar" && params[i].value == 1.5) {    //这里判断了一下，只有柱状图类型值为1.55才转换，如果为折线图则不变，label也是一样的
                      returnData += params[i].seriesName + ":1" + "</br>";
                  } else {
                      returnData += params[i].seriesName + ":" + (params[i].value ? params[i].value : 0) + "</br>";
                  }
              }
              return returnData;
          },
          },
          yAxis: {
            show:false,
            // type: 'value'
             type: 'log'
          },
          series: [
            {
              name:'盤量',
              data: this[type].seriesOriginData,
              type: 'bar',
              stack:"one",
              id:'series2',
              // barMaxWidth:40,//barCategoryGap冲突 会导致柱状图出现空隙
              itemStyle: {
                normal: {
                  color: '#B7DDFF'
                },
              },
              barCategoryGap:"-1%"
            }
          ],
          
      }
      
      this[echartType].setOption(option);
    },
    changeProOversea(){
      if(this.propertyInfo.propertyCategory != '6'){return}
      this.diConfig.gscope = this.overseaGscope
    },
    draftReview(draftID){
      return new Promise(async (resolve,reject)=>{
        this.dataFormat('post')
        let data = {
          'draftID': draftID,
          "pageIndex": this.PageIndex,
          "pageCount": this.PageCount
        }
        let draft = ""
        let res = await this.axios.post(this.pub.getApi().SearchPropertyDraft, data)
        this.draftTagsData = res.data.result.data[0]
        // 将titleCN默认为空格,命中校验规则(新校验规则为需大一个字符)
        if (res.data.result.data[0].titleCN === null) {
          res.data.result.data[0].titleCN = ' ';
        }
        // 将subcategory给一个空值,length为0
        if (res.data.result.data[0].subCategory === null) {
          res.data.result.data[0].subCategory = []
        }
        draft = JSON.parse(JSON.stringify(res.data.result.data[0]))
        // user为null值时页面需要显示代理人
        if (this.propertyUserInfo === null) {
          this.propertyUserInfo = [{}]//会导致代理检验那里不出错,因为agent长度变成了1
        }

        for (var attr in draft) {
          if (draft[attr] === null) {
            delete draft[attr];
            continue;
          }
        }
        this.propertyInfo = Object.assign(this.propertyInfo, draft);
        this.estateSrcList = draft.estateSrcList
        this.reviewPlat()
        // await this.getPhaBuild(this.propertyInfo)
        // this.getFloor(this.propertyInfo)
        // this.draftDisplayType()
        this.$nextTick(function () {  //页面加载完成后执行
          this.editTags('draftReview')
        })
        // bugfix: dataFormat会删除空数据，此处避免draft已清空了的数据，被getpropertyfullbyid的gscopeCode与gscopeFaCode覆盖问题
        if(!this.propertyInfo.estateID && !draft.gscopeCode && !draft.gscopeFaCode){
          this.propertyInfo.gscopeCode = ''
          this.propertyInfo.gscopeFaCode = ''
        }
        this.originEstateName = this.propertyInfo.estateName
        let proCatStr= this.propertyInfo.rentalType == 1 ? 'propertyCategorySale':'propertyCategoryRent'
        this.diConfig.PropertyCategory = this.filterArray( this.arrCat[proCatStr])
        this.dataFormat('edit', 'draft')
        this.isPropertySource = this.propertyInfo.propertySource == '1' ? true : false
        //当后台业主盘按钮关闭，将业主盘变更为代理盘
        if(!this.isOwner && this.propertyInfo.propertySource == '1'){
          this.propertyInfo.propertySource = 2
        }
        this.$set(this.propertyInfo, 'estateAddress', draft.estateAddress);
        // 草稿箱 存在座数时候 楼层解除禁用
        this.draftDisRule()
        if (draft.videos !== undefined) {
          if (draft.videos[0].defaultImagePath !== '') {
            this.isHidden = false
          }
          this.videos = draft.videos
        }
        if (this.propertyInfo.propertyCategory) {
          // 草稿箱 楼盘类型与子类型 与后台配置不符合 清空选项
          if (!this.diConfig.PropertyCategory.some(obj => obj.dictionaryValue == this.propertyInfo.propertyCategory)) {
            this.propertyInfo.propertyCategory = ''
            this.propertyInfo.subCategory = [];
          }
          this.diConfig.PropertyCategory.forEach(item => {
            if (item.dictionaryValue === this.propertyInfo.propertyCategory) {
              this.diConfig.ChildrenCategory = item.children;
              this.subTypeSel()
            }
          });
          try {
            this.chartEstateID = this.propertyInfo.estateID ?this.propertyInfo.estateID :''
            this.resetID = this.propertyInfo.parentEstateID ? this.propertyInfo.parentEstateID : this.propertyInfo.estateID
            this.chartScopeCode = this.propertyInfo.gscopeCode?this.propertyInfo.gscopeCode :''
            if(this.propertyInfo.propertyCategory == '1' && this.isUseInstantEstateVolume && this.propertyInfo.roomNumber){
              this.isShowChart = true
              if(!this.propertyInfo.estateID){
                this.getChartData('chartOne')
              }else{
                this.getChartData('chartOne')
                this.getChartData('chartTwo')
              }
            }
            if(this.propertyInfo.propertyCategory && this.propertyInfo.subCategory){
              if (this.diConfig.ChildrenCategory && !this.diConfig.ChildrenCategory.some(obj => this.propertyInfo.subCategory.includes(obj.dictionaryValue))) {
                this.propertyInfo.subCategory = [];
              } else {
                this.propertyInfo.subCategory = this.propertyInfo.subCategory.filter(val =>this.diConfig.ChildrenCategory.some(obj => obj.dictionaryValue == val));
              }
            }
          } catch (error) {
            console.log(error)
          }
        }
        this.judSubDis()

        await this.getPhaBuild(this.propertyInfo)
        this.getFloor(this.propertyInfo)
        this.draftDisplayType()

        this.rentLabelSel()
        if (draft.images) {
          this.images = draft.images;
        }
        if(this.mode != 'edit'){
          if (this.isUseStandard && this.mode !== '1') {
            this.propertyInfo.topType = '0';
          } else if (this.isUseSuper) {
            this.propertyInfo.topType = '1';
          } else {
            this.propertyInfo.topType = '3';
          }
        }
        this.changeCoinDia()
        this.showCoupon()
        if(this.isShowAutoRecCount > 1){
          if((this.isUseSuper && this.propertyInfo.topType == '0') || (this.isUseStar && (this.propertyInfo.topType == '0' || this.propertyInfo.topType == '1'))) {
            this.isShowHighTop = true
          }else{
            this.isShowHighTop = false
          }
        }
        // 由于04期改为不存在屋苑也可存入草稿（即无id），应hk验收要求，无estateid情况下优先展示字典输入，故加入以下判断
        // 无id且无name无手动输入的片区code时候，判断其为字典输入。
        if (!this.propertyInfo.estateID && !this.propertyInfo.estateName && !this.propertyInfo.gscopeCode) {
          this.addressSearch = true;
          this.changeAddressSearch = this.addressSearch
        } else if(this.propertyInfo.estateID){
          // 此处解决问题为:修改大湾区楼盘，切换为车位，搜索屋苑后，切换为住宅，刷新页面，“是否恢復最近的草稿”选择确认，此处修改避免getpropertyfullbyid的无estateid数据导致页面显示为非字典输入问题
          this.addressSearch = true

          this.getEstate(this.propertyInfo);
        }
        if(this.propertyInfo.estateID &&  this.propertyInfo.zoneCode){
          this.estateZoneCode = this.propertyInfo.zoneCode
        }
        if(this.propertyInfo.estateID &&  this.propertyInfo.gscopeCode){
          this.estateGscopeCode = this.propertyInfo.gscopeCode
        }
        // 草稿箱楼盘资料回显判断
        // if ((this.propertyInfo.propertyCategory == "1" && this.propertyInfo.buildingType !== 1 && (this.propertyInfo.phaseWithCulture || (!this.propertyInfo.phaseWithCulture && !this.estAdress.phaseEstates.length))) || (this.propertyInfo.propertyCategory !== "1") || (this.propertyInfo.propertyCategory == "1" && this.isCutomadded) || !this.addressSearch) {
        //     this.setOneEstData()
        // }
        // if (this.propertyInfo.propertyCategory == "1" && this.propertyInfo.buildingType == 1) {
        //   if ((this.estAdress.floorList.length && this.propertyInfo.floorName) || (!this.estAdress.floorList.length && this.propertyInfo.unitFloor)) {
        //     this.setEstData('firstEdit')
        //   }
        // }
        await this.addDraft('acquireId')
        if(this.exeDraftInter){
          this.exeDraftInter = false
          this.draftTimer = setInterval(() => {
            this.addDraft()
          }, 60000);
        }
        if (this.propertyUserInfo != null) {
          this.propertyUserInfo.forEach((item, index) => {
            this.agent.push(item.accountID);
          });
        }
        if (this.propertyUserInfo != null) {
          // 利用object对空对象进行判断,空对象时候length为0
          let d = Object.keys(this.propertyUserInfo[0]).length
          if (d === 0) {
            // 接口传递为空,上面新赋值了空对象,但为空对象无法通过校验,所以另设置
            this.draftlen = true
          } else {
            this.draftlen = false
          }
        }
        resolve()
      })
    },
    filterArray(arr) {
      if(this.mode == "edit"){
        return arr
      }
        return arr.filter(item => {
          if (item.isUse) {
            if (item.children) {
                item.children = this.filterArray(item.children);
              }
            return true;
          }
           return false;
        });
      
    },
    changePropertySource(){
      // 其与银住盘为互斥关系
      // 银主盘也在勾选状态，需提示是否需要取消勾选银主盘
      if(this.isPropertySource){
        this.propertyInfo.propertySource = 2
        this.isPropertySource = false
      }else {
        if(this.propertyInfo.isForeclosure){
          this.$confirm('請先取消銀主盤的選中狀態', '提示', {
            confirmButtonText: '確認',
            showCancelButton:false,
            closeOnClickModal: false,
            showClose:false,
            type: 'warning'
          }).then( () => {
            console.log("取消银主盘")
            return
          })
        }else{
          if(!this.isPropertySource){
            this.$confirm('是否確認選擇開啟業主盤', '提示', {
              confirmButtonText: '確認',
              cancelButtonText: '取消',
              closeOnClickModal: false,
              showClose:false,
              type: 'warning'
            }).then( () => {
              this.propertyInfo.propertySource= 1
              this.isPropertySource = true
            }).catch(() => {
              this.propertyInfo.propertySource = 2
              this.isPropertySource = false
            })
          }
        }
      }
    },
    changeClosureAnddesc(type){
      let mes =''
      if(type == 'isShowForeclosureDesc'){
        mes = '是否確認選擇開啟？'
      }else{
        mes = '是否確認選擇開啟銀主盤？'
      }
      // 页面选中状态 取消勾选
      if(this.propertyInfo[type]){
        this.propertyInfo[type] =false
        if(type == 'isForeclosure'){
          this.propertyInfo.isShowForeclosureDesc = false
        }
      }else{
        // 页面非选中状态
        if(!this.propertyInfo[type]){
          if(type == 'isForeclosure' && this.isPropertySource && (this.isOwner || this.isShowOwner)){
            this.$confirm('請先取消業主盤的選中狀態', '提示', {
              confirmButtonText: '確認',
              showCancelButton:false,
              closeOnClickModal: false,
              showClose:false,
              type: 'warning'
            })
            return
          }
          this.$confirm(`${mes}`, '提示', {
            confirmButtonText: '確認',
            cancelButtonText: '取消',
            closeOnClickModal: false,
            showClose:false,
            type: 'warning'
          }).then( () => {
            this.propertyInfo[type]= true
            if(type == 'isForeclosure' && this.isPropertySource){
              this.propertyInfo.propertySource = 2
              this.isPropertySource = false
            }
          }).catch(() => {
            this.propertyInfo[type] =false
            if(type == 'isForeclosure'){
              this.propertyInfo.isShowForeclosureDesc = false
            }
          })
        }
      }
    },
    showCoupon(){
      let data = {
        "rentalType": this.propertyInfo.rentalType,
        "estateID":!this.addressSearch ? 0 : this.propertyInfo.estateID,
      }
      this.axios.post(this.pub.getApi().VerifyCouponEligibility,data).then(res=>{
        this.isUseCoupon = res.data.result
        if(this.isUseCoupon){
          this.propertyInfo.couponKeyword = ''
          // 中原优惠券楼盘自动代入优惠券内容
          if(this.fromZy){
            this.propertyInfo.couponKeyword = this.$route.params.couponKeyword ? this.$route.params.couponKeyword : ''
          }
          this.isDisCoupon = false
          this.isDisCouponMes = ''
        }
      })
    },
    // 验收要求添加取消优惠券功能
    cancelCoupon(){
      this.isDisCoupon = false
      this.isDisCouponMes = ''
      this.propertyInfo.couponKeyword = ''
    },
    couponConInput(){
      let data = 
      {
        "rentalType": this.propertyInfo.rentalType,
        "estateID": !this.addressSearch ? 0 : this.propertyInfo.estateID,
        "buildingID": this.propertyInfo.buildingID  ? this.propertyInfo.buildingID  : '',
        "topType": this.propertyInfo.topType,
        "couponKeyword": this.propertyInfo.couponKeyword, 
      }
      this.axios.post(this.pub.getApi().VerifyCouponKeyword,data).then(res=>{
        this.isDisCoupon = res.data.result.status
        this.isCouponStatus = res.data.result.status
        this.isDisCouponMes = res.data.result.message
        this.couponPro = res.data.result.discountedPriceInfo
        this.couponEffectiveDays = res.data.result.couponEffectiveDays
      })
    },
    changeCoin(type){
      if(this.mode === '1'){return}
      if(type == 'coin'){
        if(this.payCoinDis){return}
        this.propertyInfo.paymentType = 0
        this.disCoin = false;
        this.disDiamond = true
      }else{
        if(this.payDiaDis){return;}
        this.propertyInfo.paymentType = 3
        this.disCoin = true;
        this.disDiamond = false
      }
      this.payWayEmpy = false
    },
    beforeunloadHandler(e){ 
      //只有在刊登页面刷新才可以置为true
      // 存在屋苑名称或者图片 才会存入草稿，存入若为空草稿则删除该草稿
      if((this.propertyInfo.estateName === undefined || this.propertyInfo.estateName === "") && this.images.length == 0){
        if(this.$route.name == 'post'){
          sessionStorage.setItem('refreshpro','false')
          sessionStorage.setItem("refreshID",'')
        }
        let data = {
          'draftID':[this.propertyInfo.draftID],
        };
        fetch(`${this.baseUrl}Property/RemovePropertyDraft?cityen=hk&platform=pc&language=zh-hk&token=${this.token}`, {
          method: 'POST',
          body:JSON.stringify(data),
          headers: {'Content-Type': 'application/json'},
          keepalive: true
        });
      }else{
        // 仅在当前页刷新才存入true值
        if(this.$route.name == 'post'){
          sessionStorage.setItem('refreshpro','true')//是否弹出刷新草稿箱覆盖的弹框
        }
        // if (this.propertyInfo.estateName === undefined || this.propertyInfo.estateName === "") return
        this.dataFormat('post');
        let data = {
          'draftID':this.propertyInfo.draftID,
          ...this.preData,
          videos: this.videos,
          images: [...this.images]
        };
        fetch(`${this.baseUrl}Property/AddPropertyDraft?cityen=hk&platform=pc&language=zh-hk&token=${this.token}`, {
            method: 'POST',
            body:JSON.stringify(data),
            headers: {'Content-Type': 'application/json'},
            keepalive: true
        });

      }

        e = e || window.event
        if (e) {
          e.returnValue = '关闭提示'
        }
        return '关闭提示'
    },
    // 关闭tab页前,刊登存储草稿箱
    unloadHandler(){
      if((this.propertyInfo.estateName === undefined || this.propertyInfo.estateName === "") && this.images.length == 0){
        if(this.$route.name == 'post'){
          sessionStorage.setItem('refreshpro','false')
          sessionStorage.setItem("refreshID",'')
        }
        let data = {
          'draftID':[this.propertyInfo.draftID],
        };
        fetch(`${this.baseUrl}Property/RemovePropertyDraft?cityen=hk&platform=pc&language=zh-hk&token=${this.token}`, {
          method: 'POST',
          body:JSON.stringify(data),
          headers: {'Content-Type': 'application/json'},
          keepalive: true
        });
      }else{
        if(this.$route.name == 'post'){
          sessionStorage.setItem('refreshpro','true')//是否弹出刷新草稿箱覆盖的弹框
        }
        // if (this.propertyInfo.estateName === undefined || this.propertyInfo.estateName === "") return
        this.dataFormat('post');
        let data = {
          'draftID':this.propertyInfo.draftID,
          ...this.preData,
          videos: this.videos,
          images: [...this.images]
        };
        fetch(`${this.baseUrl}Property/AddPropertyDraft?cityen=hk&platform=pc&language=zh-hk&token=${this.token}`, {
            method: 'POST',
            body:JSON.stringify(data),
            headers: {'Content-Type': 'application/json'},
            keepalive: true
        });
        // localStorage.setItem('draunload', JSON.stringify(data))
      }
    },
    geteva(){
      let data = {
        estateID: this.propertyInfo.estateID,
        buildingID:this.propertyInfo.buildingID ,
        floorName: this.propertyInfo.floorName,
        roomNo:this.propertyInfo.roomNo 
      }
      this.axios.post(this.pub.getApi().GetEvaluationApi,data).then(res=>{
        this.showEvaBut = false
        if(res.data.code == 0){
          let date = new Date(res.data.result.evaluationDate*1000)
          let Y = date.getFullYear() + '年'
          let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '月'
          let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + '日'
          this.evaluationDate = Y + M + D 
          this.evaluationValue = this.propertyInfo.rentalType == 1?res.data.result.evaluationValue/10000:res.data.result.evaluationValue 
          this.showAgreeEva = false
        }
        if(res.data.code != 0 || !this.evaluationValue){
          this.showBankEva = false
        }
      })
    },
    
    isShowReaduce(typePrice,firstval,isShowReduce,val){
      // 售盘-已补未补-刊登-存在屋苑id或者屋苑gscope情况下,chart更新
      if(this.mode !== 'edit' && this.propertyInfo.rentalType == 1 && this.propertyInfo.subCategory && (this.propertyInfo.subCategory.includes('6')  || this.propertyInfo.subCategory.includes('7')||this.propertyInfo.subCategory.includes(6) || this.propertyInfo.subCategory.includes(7))  && this.propertyInfo.propertyCategory == 1 && ((this.chartEstateID && this.addressSearch) || (this.chartScopeCode && !this.addressSearch))){
        this.isPassPriceChart().then(suc=>{
          this.changePriceChart('chartOne',suc)
          this.changePriceChart('chartTwo',suc)
        })
      }
      if(this.mode !== 'edit' || this.clearBoc){return;}
      let price = this.propertyInfo.rentalType == 1 ?this.propertyInfo[typePrice]*10000:this.propertyInfo[typePrice]
      let reducePirce = (price - this.propertyInfo[firstval] )/this.propertyInfo[firstval]
      // 公屋
      // let subIndex = this.propertyInfo.subCategory.findIndex(value=>{
      //   return value =='6' || value == '7'
      // });
      // subIndex!=-1
      if(this.propertyInfo.rentalType == 1 && this.propertyInfo.subCategory && (this.propertyInfo.subCategory.includes('6')  || this.propertyInfo.subCategory.includes('7')||this.propertyInfo.subCategory.includes(6) || this.propertyInfo.subCategory.includes(7)) ){
        if(-0.3< reducePirce && reducePirce<0){
          this.showReducePrice = true
          this[isShowReduce] = true
          this.propertyInfo[val] = true
        }else{
          this[isShowReduce] = false
          this.propertyInfo[val] = false
        }
        if(!this.isReduceUnpaid && !this.isReducePaid){
          this.showReducePrice = false
        }
        
      }
      // 非公屋
      if((this.propertyInfo.subCategory && !this.propertyInfo.subCategory.includes('6')  && !this.propertyInfo.subCategory.includes('7') && !this.propertyInfo.subCategory.includes(6) && !this.propertyInfo.subCategory.includes(7) )|| this.propertyInfo.rentalType != 1 ){
        if(-0.3< reducePirce && reducePirce<0){
          this.showReducePrice = true
          this[isShowReduce] = true
          this.propertyInfo[val] = true
        }else{
          this.showReducePrice = false
          this[isShowReduce] = false
          this.propertyInfo[val] = false
        }
      }
    },
    isReducePriceAll(){
      if(this.propertyInfo.rentalType == 1 ){ 
        let reduceUnPaid = (this.propertyInfo.unPaidSalePrice*10000 - this.propertyInfo.firstUnPaidSalePrice )/this.propertyInfo.firstUnPaidSalePrice
        this.isReduceUnpaid = false 
        if(this.propertyInfo.subCategory && (this.propertyInfo.subCategory.includes('6') || this.propertyInfo.subCategory.includes('7')||this.propertyInfo.subCategory.includes(6) || this.propertyInfo.subCategory.includes(7))&& this.propertyInfo.unPaidSalePrice && this.propertyInfo.firstUnPaidSalePrice && -0.3< reduceUnPaid && reduceUnPaid<0){
          this.isReduceUnpaid = true 
          this.showReducePrice =true
          // 展示未补
        }
        let priceType = (this.propertyInfo.subCategory.includes('6')  || this.propertyInfo.subCategory.includes('7')||this.propertyInfo.subCategory.includes(6) || this.propertyInfo.subCategory.includes(7) )?this.propertyInfo.paidSalePrice:this.propertyInfo.salePrice
        let reducePaidPrice =(priceType*10000 - this.propertyInfo.firstPaidSalePrice )/this.propertyInfo.firstPaidSalePrice
        if( -0.3<reducePaidPrice && reducePaidPrice<0){
          // 展示已补
          this.showReducePrice =true
          this.isReducePaid = true
        }else{
          // 关闭已补 或者关闭模块
          if(!this.isReduceUnpaid){
            this.showReducePrice = false
          }
        }
      }else{
        let rentReduce = (this.propertyInfo.rentPrice - this.propertyInfo.firstRentPrice )/this.propertyInfo.firstRentPrice
        if(-0.3<rentReduce && rentReduce <0){
          // 展示租盘
          this.showReducePrice =true
          this.rentReducePrice = true
        }else{
          // 关闭租盘 模块
          this.rentReducePrice = false
          this.showReducePrice =false
        }
      }
    },
    // 草稿箱楼盘资料显示规则
    draftDisplayType() {
      // 屋苑单栋 -- 存在期座楼层 显示资料
      // 屋苑独立屋--当存在已选期数时显示 或 当没有已选期数且期数没有下拉项时.显示楼盘资料
      // 村屋及其他物业类型 存在屋苑名称显示楼盘资料
      let propertyCategory = JSON.stringify(this.propertyInfo.propertyCategory)
      let buildingType = this.propertyInfo.buildingType
      if (propertyCategory !== "1" || (propertyCategory == "1" && this.isCutomadded) || (propertyCategory == "1" && buildingType !== 1 && (this.propertyInfo.phaseWithCulture || (!this.propertyInfo.phaseWithCulture && !this.estAdress.phaseEstates)))) {
        this.setOneEstData()
      }
      // 屋苑单栋 -存在座数楼层才回显
      // (this.estAdress.floorList.length && this.propertyInfo.floorName) || (!this.estAdress.floorList.length && this.propertyInfo.unitFloor)
      if (propertyCategory == "1" && buildingType == 1 && ((this.estAdress.floorList.length && this.propertyInfo.floorName) || (!this.estAdress.floorList.length && this.propertyInfo.unitFloor))) {
        this.setEstData('firstEdit')
      }

    },
    editSelEstateName() {
      this.setOneEstData()
      if(this.mode == 'edit'){
        this.clearBoc = true;
        this.clearBocPro();
      }
      // 中英文全部存在需要全部置空
      if (!this.propertyInfo.estateName && !this.propertyInfo.estateNameEN) {
        if (this.mode == 'edit') {
          this.clearProInfo()
          // this.resetPropertyInfo()
        }
        this.resetPhamore()
      }
    },
    // cateFromEstate(typefrom) {
    //   // 编辑时 可修改楼盘类型
    //   if (typefrom !== 'conditions') {
    //     if (this.propertyInfo.estateName) {
    //       // for (let i = 0; i < this.diConfig.PropertyCategory.length; i++) {
    //       //   this.$set(this.diConfig.PropertyCategory[i], 'disable', true)
    //       // }
    //       // 当屋苑名称和楼盘类型不匹配 置空(复制修改草稿箱)
    //       if (!this.estateSrcList.includes(parseInt(this.propertyInfo.propertyCategory)) && (this.mode == 'edit' || this.mode == 'copy' || this.$route.query.draftID === 0 || this.$route.query.draftID)) {
    //         this.propertyInfo.propertyCategory = ''
    //         this.propertyInfo.subCategory = []
    //       }
    //       // 当海外类型楼盘在禁止修改楼市片区情况下,禁止切换楼盘类型
    //       if(this.mode === 'edit' && !this.editEst && this.propertyInfo.propertyCategory == 6 )return
    //       this.estateSrcList.forEach(it => {
    //         for (let i = 0; i < this.diConfig.PropertyCategory.length; i++) {
    //           if (this.diConfig.PropertyCategory[i].dictionaryValue == String(it)) {
    //             this.$set(this.diConfig.PropertyCategory[i], 'disable', false)
    //           }
    //         }
    //       })
    //     }
    //     if (this.propertyInfo.estateName == '') {
    //       for (let i = 0; i < this.diConfig.PropertyCategory.length; i++) {
    //         this.$set(this.diConfig.PropertyCategory[i], 'disable', false)
    //       }
    //     }
    //   }
    //   // if (typefrom == 'conditions') {
    //   //   for (let i = 0; i < this.diConfig.PropertyCategory.length; i++) {
    //   //     this.$set(this.diConfig.PropertyCategory[i], 'disable', true)
    //   //   }
    //   // }
    // },
    tipService() {
      console.log("tipssss")
    },
    // async watchVerifyChange() {
    //   if (this.mode === 'edit') {
    //     try {
    //       this.dataFormat('post');
    //     } catch (e) {
    //       console.log('数据格式化出错');
    //     }
    //     let data = {
    //       ...this.preData,
    //       videos: this.videos,
    //       PropertyUserInfo: [...this.preUserData],
    //       images: [...this.images]
    //     };
    //     if ((data.topType == 3 || data.topType == 1) && !this.verifyUpdate && (!data.verifyImage || data.verifyImage.length == 0)) {
    //       this.axios.post(this.pub.getApi().PropertyVerify, data).then(res => {
    //         if (res.data.code == 0 && res.data.result) {
    //           this.showPropVerify = true
    //         } else {
    //           this.showPropVerify = false
    //         }
    //       })
    //     }
    //   } else return
    // },
    goBack() {
      if(this.$route.query.type == 'edit'){
        this.$confirm('如果你在頁面上有進行過修改，離開當前頁面會導致所做的修改將丟失', '提示', {
          confirmButtonText: '儲存',
          cancelButtonText: '捨棄',
          closeOnClickModal: false,
          distinguishCancelAndClose:true,
          type: 'warning'
        }).then(async () => {
          this.validation('propertyInfo')
        }).catch(action => {
          if(action == 'cancel'){
            this.butFormSource = true
            this.$router.push({
              name: this.pub.routeNameLists.PropertyIndex,
              params: this.$route.params
            });
          }
        })
        history.pushState(null, null, document.URL);
        window.addEventListener('popstate', this.goBack, false);
      }else{
        if(this.propertyInfo.estateName || ( this.images && this.images.length != 0)){
          this.draftType = 'historyBack'
          this.addDraft('historyBack')
        }
      }
    },

    changePdia(a) {
      if (a == 'plat') {
        this.aPlat = false
      } else {
        this.aFlor = false
      }
    },
    changeF(url, index) {
      this.nFlor = index
      this.aFlor = true
    },
    changeP(url, index) {
      this.nPlat = index
      this.aPlat = true
      // let b = this.prePlaturls(index)
      // document.onclick = function (event) {
      //   var obj = event.target;
      //   if (obj.className == "el-icon-arrow-right") {
      //   }
      // }
      // let b =this.prePlaturls(index)
    },

    changeFloCheck() {
      if (this.planfloChecked.length > 1) {
        this.planfloChecked.shift()
      }
      this.editFloCheck = true

    },
    // 单选只能选一个
    changeCheck() {
      if (this.planChecked.length > 1) {
        this.planChecked.shift()
      }
      this.editCheck = true
    },

    // 管理员走公司账户时,金币和钻石使用公司的
    async getDepartmentById(departmentID) {
      let res = await this.axios.get(this.pub.getApi().GetDepartmentById, {
        params: {
          departmentID
        }
      });
      let { code } = res.data;
      if (code == 0) {
        this.remainderDiamond = res.data.result.remainderDiamond
        this.remainderPropertyCoin = res.data.result.remainderPropertyCoin
        this.remainderStrDiamond = res.data.result.remainderDiamond.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        this.remainderStrPropertyCoin = res.data.result.remainderPropertyCoin.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }

    },
    reMin(a,b,c){
      let min3 = Math.min(a,b,c)
      return min3
    },
    // 钻石提示
    diaTit() {
      if (this.mode == 'post' || this.mode == 'copy') {
        let coinRs = this.propertyInfo.rentalType == 1 ? 'coinSalePrice':'coinRentPrice'
        let diamondRs = this.propertyInfo.rentalType == 1 ? 'diamondSalePrice':'diamondRentPrice'
        let coinRsDis = this.propertyInfo.rentalType == 1 ? 'enableCoinSalePrice':'enableCoinRentPrice'
        let diamondRsDis = this.propertyInfo.rentalType == 1 ? 'enableDiamondSalePrice':'enableDiamondRentPrice'
        let coinMin = this.reMin(this.diConfig.Normal && this.diConfig.Normal[coinRsDis]?this.diConfig.Normal[coinRs]:Infinity,this.diConfig.GoldTop && this.diConfig.GoldTop[coinRsDis]?this.diConfig.GoldTop[coinRs]:Infinity,this.diConfig.Star && this.diConfig.Star[coinRsDis] ? this.diConfig.Star[coinRs]:Infinity)
        let diamondMin = this.reMin(this.diConfig.Normal && this.diConfig.Normal[diamondRsDis]?this.diConfig.Normal[diamondRs]:Infinity,this.diConfig.GoldTop && this.diConfig.GoldTop[diamondRsDis]?this.diConfig.GoldTop[diamondRs]:Infinity,this.diConfig.Star&& this.diConfig.Star[diamondRsDis] ? this.diConfig.Star[diamondRs]:Infinity)
        let standardStr = this.isUseStandard ? '標準：':''
        let superStr = this.isUseSuper?'精選：':''
        let starStr = this.isUseStar?'星級：':''
        if(this.isUsedCoin && this.isUsedDiamond && coinMin >this.remainderPropertyCoin &&  diamondMin>this.remainderDiamond){ 
          let noralertStrCoin = this.diConfig.Normal && this.diConfig.Normal[coinRsDis] ?this.diConfig.Normal[coinRs]+'金幣' +'&nbsp;':""
          let noralertStrDia = this.diConfig.Normal && this.diConfig.Normal[diamondRsDis] ?this.diConfig.Normal[diamondRs]+'鑽石':""
          let golalertStrCoin = this.diConfig.GoldTop && this.diConfig.GoldTop[coinRsDis] ?this.diConfig.GoldTop[coinRs]+'金幣'+'&nbsp;':""
          let golalertStrDia = this.diConfig.GoldTop && this.diConfig.GoldTop[diamondRsDis] ?this.diConfig.GoldTop[diamondRs]+'鑽石':"" 
          let stalertStrCoin = this.diConfig.Star && this.diConfig.Star[coinRsDis] ?this.diConfig.Star[coinRs]+'金幣'+'&nbsp;':""
          let stalertStrDia = this.diConfig.Star && this.diConfig.Star[diamondRsDis] ?this.diConfig.Star[diamondRs]+'鑽石':""
          let mesTitle = this.fromZy ? '由於你現時沒有足夠貨幤，請先分配或購買金幣/鑽石。<br/>你仍可以使用優惠券去刊登樓盤。' :' 由於你現時沒有足夠貨幤，請先分配或購買金幣/鑽石。'
          this.$alert(`${mesTitle}<br/> ${standardStr}${noralertStrCoin}${noralertStrDia}<br/>${superStr}${golalertStrCoin}${golalertStrDia}${this.isUseSuper ? '<br/>' :''}${starStr}${stalertStrCoin}${stalertStrDia}`, '餘額不足', { confirmButtonText: '確認', dangerouslyUseHTMLString: true });
        }else if(this.isUsedCoin && !this.isUsedDiamond  && coinMin >this.remainderPropertyCoin){
          let mesTitle = this.fromZy ? '由於你現時沒有足夠貨幤，請先分配或購買金幣。<br/>你仍可以使用優惠券去刊登樓盤。' :' 由於你現時沒有足夠貨幤，請先分配或購買金幣。'
          this.$alert(`${mesTitle}<br/> ${standardStr ? standardStr + this.diConfig.Normal[coinRs] + '金幣<br/>' : ''}${superStr ? superStr + this.diConfig.GoldTop[coinRs]+ '金幣<br/>' : ''}${starStr ? starStr + this.diConfig.Star[coinRs]+ '金幣' : ''}`, '餘額不足', { confirmButtonText: '確認', dangerouslyUseHTMLString: true });
        }else if(!this.isUsedCoin && this.isUsedDiamond &&  diamondMin>this.remainderDiamond){
          let mesTitle = this.fromZy ? '由於你現時沒有足夠貨幤，請先分配或購買鑽石。<br/>你仍可以使用優惠券去刊登樓盤。' :' 由於你現時沒有足夠貨幤，請先分配或購買鑽石。'
          this.$alert(`${mesTitle}<br/> ${standardStr ? standardStr + this.diConfig.Normal[diamondRs] + '鑽石<br/>' :''} ${superStr ? superStr + this.diConfig.GoldTop[diamondRs] + '鑽石<br/>' :''}${starStr ? starStr + this.diConfig.Star[diamondRs] + '鑽石' :''}`, '餘額不足', { confirmButtonText: '確認', dangerouslyUseHTMLString: true });
        }
        /**1.不金币,可钻石,判断星级售
         * 2.不星级和精选,判断金币是否足够放标准
         * 3.可金币钻石,但金币不足标准盘,钻石不够精选盘
         * 4.可金币,可钻石,但金币不够标准盘
         * 5.可金币,可钻石,但钻石只够精选.
         * 6.可金币,可钻石,但钻石不够精选
         * 7.可金币,不可钻石,金币不足
         * 
         * */ 
        // if (!this.isUsedCoin && this.isUsedDiamond && this.remainderDiamond < 5) {
        //   this.$alert('如卻刊登星級盤，請先分配或購買鑽石', '鑽石餘額不足', { confirmButtonText: '確認' });
        // } else if (this.isUsedCoin && this.remainderPropertyCoin < 100 && this.isUseStandard && !this.isUseSuper && !this.isUseStar) {
        //   this.$alert('金幣余額不足以放盤,請先充值', '金幣餘額不足', { confirmButtonText: '確認', dangerouslyUseHTMLString: true })
        // } else if (this.isUsedCoin && this.remainderPropertyCoin < 100 && (this.isUsedDiamond && this.remainderDiamond < 3)) {
        //   this.$alert('如欲刊登放盤，請先分配或購買金幣或鑽石', '餘額不足', { confirmButtonText: '確認' });
        // } else if (this.isUsedCoin && this.remainderPropertyCoin < 100 && (this.isUsedDiamond && this.remainderDiamond >= 5)) {
          // this.$alert(`${this.accountType == true && (this.userInfo.roleID == 1 || this.userInfo.roleID == 2) ? '公司' : '你的'}賬戶餘額只足夠刊登精選盤或星級盤 <br/> 如欲刊登標準盤，請先分配或購買金幣`, '金幣餘額不足', { confirmButtonText: '確認', dangerouslyUseHTMLString: true })
        // } else if (this.isUsedCoin && this.remainderPropertyCoin < 100 && (this.isUsedDiamond && 3 <= this.remainderDiamond < 5)) {
        //   this.$alert(`${this.accountType == true && (this.userInfo.roleID == 1 || this.userInfo.roleID == 2) ? '公司' : '你的'}賬戶餘額只足夠刊登精選盤<br/>如欲刊登標準盤，請先分配或購買金幣`, '金幣餘額不足', { confirmButtonText: '確認', dangerouslyUseHTMLString: true })
        // } else if (this.isUsedCoin && this.remainderPropertyCoin >= 100 && (this.isUsedDiamond && this.remainderDiamond < 3)) {
        //   this.$alert(`${this.accountType == true && (this.userInfo.roleID == 1 || this.userInfo.roleID == 2) ? '公司' : '你的'}賬戶餘額只足夠刊登標準盤<br/>如欲刊登精選盤或星級盤，請先分配或購買鑽石`, '鑽石餘額不足', { confirmButtonText: '確認', dangerouslyUseHTMLString: true })
        // } else if (this.isUsedCoin && this.remainderPropertyCoin < 100 && !this.isUsedDiamond) {
        //   this.$alert('金幣余額不足以放盤,請先充值', '金幣餘額不足', { confirmButtonText: '確認', dangerouslyUseHTMLString: true })
        // }
      }
    },
    // 刊登页引导 楼盘标签和楼盘视频
    guidePage() {
      let steps = [];
      steps = [
        {
          element: '.guifea',
          stageBackground: '#eee',
          nextBtnText: '下一步',
          popover: {
            className: 'first-guidance',
            title: '現在可以新增標籤，<br/>突顯你的樓盤特色',
            position: 'bottom'
          },
        },
        {
          element: '.vidput',
          stageBackground: '#eee',
          nextBtnText: '下一步',
          popover: {
            className: 'first-guidance',
            title: '亦可新增影片，<br/>讓你的樓盤更具吸引力',
            position: 'bottom'
          },
        },
        {
          element: '.vidputs',
          stageBackground: '#eee',
          doneBtnText: "立即刊登",
          popover: {
            className: 'first-guidance',
            title: '現在可以開始刊登樓盤！',
            position: 'bottom'
          },
          onNext: () => {
            /**
             * 返回顶部
             * 将假页面元素隐藏
             * 显示钻石提示
             * 发送后台该用户已提示过了
             */
            let main = document.querySelector('.el-main');
            main.scroll({
              top: 0,
              left: 0,
            });
            this.isFirst = false
            this.diaTit()
            this.SetAccountResources()
          }
        }
      ];
      setTimeout(() => {
        this.pub.guide(this.Driver, steps);
      }, 500);
    },
    changeParkSubway() {
      let arr = {
        children: null,
        dictionaryNameWithCulture: "近港鐵",
        dictionaryValue: "51",
        itemName: "PropertyTagInfo",
        sequence: 1
      }
      // || (this.subway.length == 0 && this.addressSearch)
      // 屋院没有选择时候不予展示  subway为-1时候不许展示 手动输入时候不许展示
      try {
        if (!Object.keys(this.EstateInfo).length || this.subway == -1 || (this.subway == -1 && this.addressSearch) || !this.addressSearch) {
          // 隐藏近港铁
          // debugger
          if (this.diConfig.ChildrenTag[5].length) {
            for (let i = 0; i < this.diConfig.ChildrenTag[5].length; i++) {
              if (this.diConfig.ChildrenTag[5][i].dictionaryValue == 51) {
                // debugger
                this.diConfig.ChildrenTag[5].splice(i, 1)
              }
            }
            for (let i = 0; i < this.tagsPark.length; i++) {
              if (this.tagsPark[i] == 51) {
                this.tagsPark.splice(i, 1)
              }
            }
            for (let i = 0; i < this.propertyInfo.propertyTags.length; i++) {
              if (this.propertyInfo.propertyTags[i] == 51) {
                this.propertyInfo.propertyTags.splice(i, 1)
              }
            }
            for (let i = 0; i < this.selectedTags.length; i++) {
              if (this.selectedTags[i].key == 51) {
                this.selectedTags.splice(i, 1)
              }
            }
          }
        } else if (this.subway > 15) {
          let flags = false
          this.diConfig.ChildrenTag[5].forEach(item => {
            if (item.dictionaryValue == '51') {
              flags = true
            }
          })
          if (!flags) {
            this.diConfig.ChildrenTag[5].unshift(arr)
          }
          // 大于15时，如果上次选中，这次的需要置空
          for (let i = 0; i < this.tagsPark.length; i++) {
            if (this.tagsPark[i] == 51) {
              this.tagsPark.splice(i, 1)
            }
          }
          for (let i = 0; i < this.propertyInfo.propertyTags.length; i++) {
            if (this.propertyInfo.propertyTags[i] == 51) {
              this.propertyInfo.propertyTags.splice(i, 1)
            }
          }
          for (let i = 0; i < this.selectedTags.length; i++) {
            if (this.selectedTags[i].key == 51) {
              this.selectedTags.splice(i, 1)
            }
          }
        } else {
          let flags = false
          this.diConfig.ChildrenTag[5].forEach(item => {
            if (item.dictionaryValue == '51') {
              flags = true
            }
          })
          if (!flags) {
            this.diConfig.ChildrenTag[5].unshift(arr)
            this.$forceUpdate();
          }
        }
      } catch (error) {
        console.log("parksubwayerror",error)
      }
    },
    // 港铁显示规则  1.>15时禁用 2.屋院为空不予展示 3.返回-1不予展示 4.手动输入屋院不予展示 <15可选
    changesubway() {
      let arr = {
        children: null,
        dictionaryNameWithCulture: "近港鐵",
        dictionaryValue: "23",
        itemName: "PropertyTagInfo",
        sequence: 1
      }
      // || (this.subway.length == 0 && this.addressSearch)
      // 屋院没有选择时候不予展示  subway为-1时候不许展示 手动输入时候不许展示
      try {
        if (!Object.keys(this.EstateInfo).length || this.subway == -1 || (this.subway == -1 && this.addressSearch) || !this.addressSearch) {
          // 隐藏近港铁
          // debugger
          if (this.diConfig.ChildrenTag[3].length) {
            for (let i = 0; i < this.diConfig.ChildrenTag[3].length; i++) {
              if (this.diConfig.ChildrenTag[3][i].dictionaryValue == 23) {
                // debugger
                this.diConfig.ChildrenTag[3].splice(i, 1)
              }
            }
            for (let i = 0; i < this.tagsMat.length; i++) {
              if (this.tagsMat[i] == 23) {
                this.tagsMat.splice(i, 1)
              }
            }
            for (let i = 0; i < this.propertyInfo.propertyTags.length; i++) {
              if (this.propertyInfo.propertyTags[i] == 23) {
                this.propertyInfo.propertyTags.splice(i, 1)
              }
            }
            for (let i = 0; i < this.selectedTags.length; i++) {
              if (this.selectedTags[i].key == 23) {
                this.selectedTags.splice(i, 1)
              }
            }
          }
        } else if (this.subway > 15) {
          let flags = false
          this.diConfig.ChildrenTag[3].forEach(item => {
            if (item.dictionaryValue == '23') {
              flags = true
            }
          })
          if (!flags) {
            this.diConfig.ChildrenTag[3].unshift(arr)
          }
          // 大于15时，如果上次选中，这次的需要置空
          for (let i = 0; i < this.tagsMat.length; i++) {
            if (this.tagsMat[i] == 23) {
              this.tagsMat.splice(i, 1)
            }
          }
          for (let i = 0; i < this.propertyInfo.propertyTags.length; i++) {
            if (this.propertyInfo.propertyTags[i] == 23) {
              this.propertyInfo.propertyTags.splice(i, 1)
            }
          }
          for (let i = 0; i < this.selectedTags.length; i++) {
            if (this.selectedTags[i].key == 23) {
              this.selectedTags.splice(i, 1)
            }
          }
        } else {
          let flags = false
          this.diConfig.ChildrenTag[3].forEach(item => {
            if (item.dictionaryValue == '23') {
              flags = true
            }
          })
          if (!flags) {
            this.diConfig.ChildrenTag[3].unshift(arr)
            this.$forceUpdate();
          }
        }
      } catch (error) {
        console.log("Subwayerror",error)
      }
    },
    // 当修改楼盘或者草稿箱需要回显楼盘标签 对数据进行操作赋值(34是后添的一个楼盘标签)
    editTags(type) {
      if (this.apiData.propertyTags || this.draftTagsData.propertyTags) {
        this.propertyInfo.propertyTags = []
        if (this.$route.query.draftID === 0 || this.$route.query.draftID || type =='draftReview') {
          this.draftTagsData.propertyTags.forEach((ele) => {
            let a = { key: ele.propertyTagValue, val: ele.propertyTagName }
            this.selectedTags.push(a)
            this.propertyInfo.propertyTags.push(ele.propertyTagValue)
          })
        } else {
          this.apiData.propertyTags.forEach((ele) => {
            let a = { key: ele.propertyTagValue, val: ele.propertyTagName }
            this.selectedTags.push(a)
            this.propertyInfo.propertyTags.push(ele.propertyTagValue)
          })
        }
        this.tagsChar = this.diConfig.ChildrenTag[0].filter(item => this.propertyInfo.propertyTags.includes(item.dictionaryValue)).map(item => item.dictionaryValue) 
        this.tagsSce = this.diConfig.ChildrenTag[1].filter(item => this.propertyInfo.propertyTags.includes(item.dictionaryValue)).map(item => item.dictionaryValue) 
        this.tagsRen = this.diConfig.ChildrenTag[2].filter(item => this.propertyInfo.propertyTags.includes(item.dictionaryValue)).map(item => item.dictionaryValue) 
        setTimeout(() => {
          this.tagsMat = this.diConfig.ChildrenTag[3].filter(item => this.propertyInfo.propertyTags.includes(item.dictionaryValue)).map(item => item.dictionaryValue) 
        }, 100);
        this.tagsBus = this.diConfig.ChildrenTag[4].filter(item => this.propertyInfo.propertyTags.includes(item.dictionaryValue)).map(item => item.dictionaryValue) 
        this.tagsPark = this.diConfig.ChildrenTag[5].filter(item => this.propertyInfo.propertyTags.includes(item.dictionaryValue)).map(item => item.dictionaryValue) 
        //住宅由租转售时候 若有连家电复制楼盘时需要将连家电剔除
        if (this.propertyInfo.rentalType == 1 && this.propertyInfo.propertyCategory == '1') {
          for (var i = 0; i < this.selectedTags.length; i++) {
            if (this.selectedTags[i].key == '24') {
              this.selectedTags.splice(i, 1)
            }
          }
          for (var i = 0; i < this.propertyInfo.propertyTags.length; i++) {
            if (this.propertyInfo.propertyTags[i] == '24') {
              this.propertyInfo.propertyTags.splice(i, 1)
            }
          }
          for (var z = 0; z < this.tagsMat.length; z++) {
            if (this.tagsMat[z] == '24') {
              this.tagsMat.splice(z, 1)
              if (this.tagsMat.length == 0) {
                this.tagsMat = []
              }
            }
          }
        }
      }
    },
    //将拖拽后的数组赋propotytags
    tagEnd() {
      // 每次点击拓转时候 打个标识  这也是个办法
      let newArr = this.selectedTags.map(item => item.key)
      this.propertyInfo.propertyTags = newArr
    },
    // 数组去重
    // unique2(arr) {
    //   let obj = {};
    //   let peon = arr.reduce((cur, next) => {
    //     obj[next.area] ? "" : obj[next.area] = true && cur.push(next);
    //     return cur;
    //   }, [])
    //   this.planImgInfo.areaList = peon
    // },
    // 对选中的总tags数组去重
    unique1(arr) {
      var hash = [];
      for (var i = 0; i < arr.length; i++) {
        if (hash.indexOf(arr[i]) == -1) {
          hash.push(arr[i]);
        }
      }
      this.propertyInfo.propertyTags = hash
      return hash;
    },
    // 刊登 楼盘标签
    changeTags(arrtype,targetarr){
      // arrtype的值 this.propertyInfo.propertyTags 筛选出包含在this.diConfig.ChildrenTag[targetarr]存在的值,在与arrtype进行比对,多出的值删掉
      let filterArr = this.diConfig.ChildrenTag[targetarr].filter(item => this.propertyInfo.propertyTags.includes(item.dictionaryValue)).map(item => item.dictionaryValue) 
      if(filterArr.length > arrtype.length){
        filterArr.filter((item,index) => {
          if(!arrtype.includes(item)){
            this.propertyInfo.propertyTags.splice(this.propertyInfo.propertyTags.indexOf(item),1)
          }
        })
      }else{
        arrtype.filter((item,index)=>{
          if(!filterArr.includes(item)){
            this.propertyInfo.propertyTags.push(item)
          }
        })
      }
      if(this.propertyInfo.propertyTags && this.propertyInfo.propertyTags.length != 0){
        this.propertyInfo.propertyTags = this.propertyInfo.propertyTags.toString().split(",")
        this.unique1(this.propertyInfo.propertyTags)
        if (this.propertyInfo.propertyTags.length == 0) {
          this.selectedTags = []
        } else{
          this.selectedTags = JSON.parse(JSON.stringify(this.propertyInfo.propertyTags))
          this.selectedTags.forEach((ele, index) => {
            this.flatTag.forEach(item => {
              if (ele === item.dictionaryValue) {
                let a = { key: ele, val: item.dictionaryNameWithCulture }
                this.selectedTags.splice(index, 1, a)
              }
            })
          })
        }
      }else{
        this.selectedTags = []
      }
    },
    filterTags(tagsArray, propertyCategory, rentalType) {
      return tagsArray.filter(item => {
        const isInCategory = item.applyCategory?item.applyCategory.includes(Number(propertyCategory)):true;
        const isRentalTypeValid = item.rentalType === 0 || item.rentalType === rentalType;
        return isInCategory && isRentalTypeValid;
      });
    }, 
    // 标签相关展示规则
    tagshow() {
      this.diConfig.ChildrenTag = []
      this.selectedTags = []
      this.propertyInfo.propertyTags = []
      this.tagsChar = []
      this.tagsSce = []
      this.tagsRen = []
      this.tagsMat = []
      this.tagsBus = []
      this.tagsPark = []
      this.diConfig.PropertyTag.forEach((item, index) => {
        this.diConfig.ChildrenTag.push(item.children);
      });
      if (this.propertyInfo.propertyCategory) {
        if (this.propertyInfo.rentalType == 1) {
          this.diConfig.ChildrenTag[0] = this.filterTags(this.diConfig.ChildrenTag[0], this.propertyInfo.propertyCategory, 1 );
          this.diConfig.ChildrenTag[1] = this.filterTags(this.diConfig.ChildrenTag[1], this.propertyInfo.propertyCategory, 1 );
          this.diConfig.ChildrenTag[2] = this.filterTags(this.diConfig.ChildrenTag[2], this.propertyInfo.propertyCategory, 1 );
          this.diConfig.ChildrenTag[3] = this.filterTags(this.diConfig.ChildrenTag[3], this.propertyInfo.propertyCategory, 1 );
          this.diConfig.ChildrenTag[4] = this.filterTags(this.diConfig.ChildrenTag[4], this.propertyInfo.propertyCategory, 1 );
          this.diConfig.ChildrenTag[5] = this.filterTags(this.diConfig.ChildrenTag[5], this.propertyInfo.propertyCategory, 1 );
        } else if (this.propertyInfo.rentalType == 2) {
          this.diConfig.ChildrenTag[0] = this.filterTags(this.diConfig.ChildrenTag[0], this.propertyInfo.propertyCategory, 2 );
          this.diConfig.ChildrenTag[1] = this.filterTags(this.diConfig.ChildrenTag[1], this.propertyInfo.propertyCategory, 2 );
          this.diConfig.ChildrenTag[2] = this.filterTags(this.diConfig.ChildrenTag[2], this.propertyInfo.propertyCategory, 2 );
          this.diConfig.ChildrenTag[3] = this.filterTags(this.diConfig.ChildrenTag[3], this.propertyInfo.propertyCategory, 2 );
          this.diConfig.ChildrenTag[4] = this.filterTags(this.diConfig.ChildrenTag[4], this.propertyInfo.propertyCategory, 2 );
          this.diConfig.ChildrenTag[5] = this.filterTags(this.diConfig.ChildrenTag[5], this.propertyInfo.propertyCategory, 2 );
        }
      }
      // 首次是不会进入的 
      // 当切换楼盘类型时，近港铁需要显示(页面初始进入 港铁已经被删除 所以需压入)
      // Object.keys(this.EstateInfo).length: 页面会报错length
      if (this.addressSearch && this.subway > -1 && JSON.stringify(this.EstateInfo) != "{}") {
        // debugger
        let arr = {
          children: null,
          dictionaryNameWithCulture: "近港鐵",
          dictionaryValue: this.propertyInfo.propertyCategory == 4 ? "51" : "23",
          itemName: "PropertyTagInfo",
          sequence: 1
        }
        let flags = false
        if(this.propertyInfo.propertyCategory == "4"){
          this.diConfig.ChildrenTag[5].forEach(item => {
            if (item.dictionaryValue == '51') {
              flags = true
            }
          })
        }else{
          this.diConfig.ChildrenTag[3].forEach(item => {
            if (item.dictionaryValue == '23') {
              flags = true
            }
          })
        }
        if (!flags) {
          let index = this.propertyInfo.propertyCategory == 4 ? 5 : 3
          if (this.diConfig.ChildrenTag[index]) {
            this.diConfig.ChildrenTag[index].unshift(arr)
            this.$forceUpdate();
          }
        }
      } else {
        // 如果港铁时间-1时切换楼盘类型 需要的判断
        // this.diConfig.ChildrenTag[3].length由于3有undefined的情况所以length报错 0708
        let targetIndex = this.propertyInfo.propertyCategory == 4 ? 5 : 3
        let targetValue = this.propertyInfo.propertyCategory == 4 ? "51" : "23"
        if (this.diConfig.ChildrenTag[targetIndex]) {
          for (let i = 0; i < this.diConfig.ChildrenTag[targetIndex].length; i++) {
            if (this.diConfig.ChildrenTag[targetIndex][i].dictionaryValue == targetValue) {
              this.diConfig.ChildrenTag[targetIndex].splice(i, 1)
            }
          }
        }
      }
     
    },
    // 物业编号有时输入不好用,将四种物业编号强制更新
    saleChange(e) {
      this.propertyNoRepeat = false;
      this.propertyInfo.categoryNo = this.propertyInfo.categoryNo
        .replace(/[\u4E00-\u9FA5]/g, '')
        .replace(/\s*/g, '')
        .toUpperCase();
      this.$forceUpdate();
    },
    seaChange(e) {
      this.propertyNoRepeat = false;
      this.propertyInfo.propertyNo = this.propertyInfo.propertyNo.replace(/[\u4E00-\u9FA5]/g, '').replace(/\s*/g, '');
      this.$forceUpdate();
    },
    conChange() {
      this.propertyNoRepeat = false;
      this.propertyInfo.propertyNo = this.propertyInfo.propertyNo
        .replace(/[\u4E00-\u9FA5]/g, '')
        .replace(/\s*/g, '')
        .toUpperCase();
      this.$forceUpdate();
    },
    proChange(e) {
      this.propertyNoRepeat = false;
      this.propertyInfo.propertyNo = this.propertyInfo.propertyNo.replace(/[\u4E00-\u9FA5]/g, '').replace(/\s*/g, '');
      this.$forceUpdate();
    },

    /*校验规则 星级盘 标准盘*/
    validaCustom() {
      /**
       * 1.楼层资料有缺失 没有填写楼层(屋苑单栋)
       * 2.楼层资料不缺失 没有填写楼层(屋苑单栋)
       * 3.非屋苑单栋 楼层没有填写
       * */
      let florStar = false
      if (this.addressSearch && this.propertyInfo.propertyCategory == "1" && this.propertyInfo.buildingType == 1 && this.estAdress.unitFloorList.length && (this.propertyInfo.floorName == '' || !this.propertyInfo.floorName || !this.propertyInfo.unitFloor || this.propertyInfo.unitFloor == '')) {
        florStar = true
      }
      if (this.addressSearch && this.propertyInfo.propertyCategory == "1" && this.propertyInfo.buildingType == 1 && this.estAdress.floorList.length  && this.propertyInfo.floorName == '' && !this.propertyInfo.floorName) {
        florStar = true
      }
      if (this.addressSearch && this.propertyInfo.propertyCategory == "1" && this.propertyInfo.buildingType !== 1 && (!this.propertyInfo.unitFloor || this.propertyInfo.unitFloor == '')) {
        florStar = true
      }
      // if (!this.addressSearch && (!this.propertyInfo.unitFloor || this.propertyInfo.unitFloor == '')) {
      //   florStar = true
      // }
      if(this.addressSearch && this.propertyInfo.propertyCategory == "2" && this.propertyInfo.topType == 3 && (!this.propertyInfo.unitFloor || this.propertyInfo.unitFloor == '') ){
        florStar = true
      }
      const validCount = this.images.filter(item => item.imagePath).length;
      // const defaultCount = this.images.filter(item => item.isDefault).length;
      const defaultCount = this.images.some(item => item.isDefault);
      var rule = [
        {
          verFailed: florStar,
          tip: '選擇樓層',
          attr: 'unitFloor'
        },
        {
          verFailed: !this.propertyInfo.roomNumber || this.propertyInfo.roomNumber == '',
          tip: '選擇房間數目',
          attr: 'roomNumber'
        },
        {
          verFailed: this.propertyInfo.titleCN.trim().length < 8,
          tip: '放盤標題(中文)不少於8個字',
          attr: 'titleCN'
        },
        {
          verFailed: validCount < 3,
          tip: '上載至少3張樓盤圖片',
          attr: 'images'
        },
        {
          verFailed: !defaultCount,
          tip: '請選擇一張圖片為封面圖',
          attr: 'images'
        },
        // {
        //   verFailed: true,
        //   tip: '揀選3個不同的圖片位置',
        //   attr: 'images'
        // },
      ]
      if(this.propertyInfo.topType == 3){
        let tipsArr = []
        // 不同的类型放盘校验不一样 --拣选3个不同的图片位置-->已废除
        if (this.propertyInfo.propertyCategory == 1 || this.propertyInfo.propertyCategory == 6) {
          // -住宅：填写单位楼层、填写房间数目、放盘标题(中文)不少于8个字、上载至少3张图片
          tipsArr = rule.filter(item => item.verFailed)
        } else if (this.propertyInfo.propertyCategory == 2) {
          // -工商厦：填写单位楼层、放盘标题(中文)不少于8个字、上载至少3张图片
          rule.splice(1, 1)
          tipsArr = rule.filter(item => item.verFailed)
        } else {
          // - 车位、店铺、土地：放盘标题(中文)不少于8个字、上载至少3张图片
          tipsArr = rule.slice(2).filter(item => item.verFailed)
        }
        this.ruleInfo = ''
        if (tipsArr.length > 0) {
          tipsArr.forEach(item => {
            this.ruleInfo += '- ' + item.tip + '</br>'
          })
          let main = document.querySelector('.el-main');
          main.scroll({
            top: tipsArr[0].attr == 'images' || tipsArr[0].attr == 'unitFloor' ? this.$refs[tipsArr[0].attr].offsetTop : this.$refs[tipsArr[0].attr].$el.offsetTop,
            left: 0,
          });
          this.showTopImage = true;
          return 'error';
        }
      }else{
        if(this.images.length == 0){
          this.ruleInfo = '- 上載至少1張樓盤圖片'+ (!defaultCount ? '</br>- 請選擇一張圖片為封面圖' : '');
          this.defaultImgTip = !defaultCount;
          let main = document.querySelector('.el-main');
          main.scroll({
            top: this.$refs.images.offsetTop,
            left: 0,
          });
          this.showTopImage = true;
          return 'error';
        }
        if(!defaultCount){
          this.ruleInfo = '- 請選擇一張圖片為封面圖';
          let main = document.querySelector('.el-main');
          main.scroll({
            top: this.$refs.images.offsetTop,
            left: 0,
          });
          this.defaultImgTip = true
          this.showTopImage = true;
          return 'error';
        }
      }
    },
    // 金币钻石仅存在一种 页面不显示支付方式 
    changeCoinDia(source,type){
      let proType = ''
      if(source == 'chooseProType'){
        proType = type
      }else{
        proType = this.propertyInfo.topType == '0' ? 'Normal' :this.propertyInfo.topType == '1'?'GoldTop':'Star'
      }
      let coinRsDis = this.propertyInfo.rentalType == 1 ? 'enableCoinSalePrice':'enableCoinRentPrice'
      let diamondRsDis = this.propertyInfo.rentalType == 1 ? 'enableDiamondSalePrice':'enableDiamondRentPrice'
      let coinRs = this.propertyInfo.rentalType == 1 ? 'coinSalePrice':'coinRentPrice'
      let diamondRs = this.propertyInfo.rentalType == 1 ? 'diamondSalePrice':'diamondRentPrice'
     //是否显示某支付类型
     this.showCoinPay = this.diConfig[proType][coinRsDis] 
     this.showDiamondPay = this.diConfig[proType][diamondRsDis]
    //  双金币类型 某种货币不够时 单独禁用
    this.payCoinDis = false
    this.payDiaDis = false
     if(this.showCoinPay && this.showDiamondPay){
      if(this.remainderPropertyCoin < this.diConfig[proType][coinRs]){
        this.disCoin = true
        this.payCoinDis = true
      }
      if(this.remainderDiamond < this.diConfig[proType][diamondRs]){
        this.disDiamond = true
        this.payDiaDis = true
      }
     }

      if(this.mode !== '1'){
        this.propertyInfo.paymentType = ''
        // 单金币类型 
        if((!this.diConfig[proType][coinRsDis] && this.diConfig[proType][diamondRsDis] ) || (this.diConfig[proType][coinRsDis] && !this.diConfig[proType][diamondRsDis])){
          this.propertyInfo.paymentType = this.diConfig[proType][coinRsDis] ? 0 : 3
          this.payWayEmpy = false
        }
      }
      if(this.propertyInfo.paymentType === 0){
        // 金币高亮
        this.disDiamond = true
        this.disCoin = false
      }else if(this.propertyInfo.paymentType === 3){
        this.disDiamond = false
        this.disCoin = true
      }
    },
    // 切换放盘类型后 判断金币禁用
    chooseProType(type) {
      // 中原优惠券楼盘不支持的楼盘放盘方式禁止切换过去
      if(this.fromZy && ((type == 'Normal' && this.isDisableStand) || (type == 'GoldTop' && this.isDisableSuper) || (type == 'Star' && this.isDisableStar))){return}
      if(this.mode === 'edit' || this.mode === '1' || this.mode === '2'){return}
      if(type == 'Normal'){
        this.propertyInfo.isVerify = false;
        this.propertyInfo.verifyImage = []
      }
      this.disCoin = true;
      this.disDiamond = true;
      // 非中原优惠券的楼盘 需要清空优惠券内容，
      if(!this.fromZy){
        this.propertyInfo.couponKeyword = ''
      }
      this.isDisCoupon = false
      this.isDisCouponMes = ''
      // 升級放盤方式的提示规则 须有更高级的盘才显示
      if(this.isShowAutoRecCount > 1){
        if((this.isUseSuper && type == 'Normal') || (this.isUseStar && (type == 'Normal' || type == 'GoldTop'))) {
          this.isShowHighTop = true
        }else{
          this.isShowHighTop = false
        }
      }
      this.recAutoDia = ''
      this.changeAutoRecList(type)
      this.changeCoinDia('chooseProType',type)
    },
    debounce(func, delay) {
      return function () {
        clearTimeout(func.id);
        func.id = setTimeout(() => {
          func.apply(this, arguments);
        }, delay);
      };
    },
    dragUpdate() {
      this.pushCache();
      // this.sendSocket();
    },
    addSelected(data) {
      var flag = false;
      this.uploadImgStatus = true
      this.images.forEach((item, index) => {
        if (item.imagePath == data.imagePath) {
          flag = index;
        }
      });
      flag || flag === 0 ? this.images.splice(flag, 1) : this.images.push(data);
      if (this.images.length >= 40) {
        this.images = this.images.splice(0, 40);
      }
      this.selList = [];
      this.images.forEach(item => {
        this.selList.push(item.imagePath);
      });
    },
    preview() {
      if (!this.images.length) {
        return;
      }
      this.selList = [];
      this.images.forEach(item => {
        this.selList.push(item.imagePath);
      });
      this.enLarge1 = true;
      this.selectImgShow = false;
    },
    done() {
      // this.file = this.images;

      this.file = []
      for (let i = 0; i < this.images.length; i++) {
        this.file.push(this.images[i])
      }
      this.selectImgShow = false;
      this.pushCache();
      // this.sendSocket();
    },
    closeViewer() {
      this.enLarge1 = false;
      this.selectImgShow = true;
    },
    close() {
      this.selectImgShow = false;
    },
    /*图片属性格式化 && 如果利嘉格和中原拼接了style 去掉*/
    imgFormart(data) {
      if (data && data.length) {
        data.forEach(item => {
          // let src = item.imagePath.split('?')[0];
          // item.imagePath = src;
          if (item.imageType === 0) {
            item.imageType = '';
            // item.imageTypeWithCulture=''
          } else {
            item.imageType = String(item.imageType);
          }
        });
      }
    },
    /*A+获取数据*/
    /*A+获取数据*/
    getConditions(data, mode) {
      this.getConImgae = true;
      this.axios
        .post(this.pub.getApi().PropertyInfoExterna, {
          categoryNo: data,
          rentalType: this.propertyInfo.rentalType,
          category: this.propertyInfo.propertyCategory
        })
        .then(res => {
          if (res.data.code === 0 && res.data.result) {
            let result = res.data.result;
            this.getConImgae = false;
            // 删除为null的属性
            for (var attr in result) {
              if (result[attr] === null) {
                delete result[attr];
                continue;
              }
            }
            if (this.mode === 'post') {
              this.propertyInfo = Object.assign(this.propertyInfo, result);
              this.isHosPrice = result.isHosPrice
              if (result.subCategory && (typeof result.subCategory === 'string' || typeof result.subCategory === 'number') && this.propertyInfo.propertyCategory ==1) {
                this.propertyInfo.subCategory = [String(result.subCategory)];
              }
              // this.estateSrcList = res.data.result.estateSrcList 中利 不存在修改屋苑名称权限
              this.dataFormat('edit', 'conditions');
              this.$set(this.propertyInfo, 'estateAddress', result.estateAddress);
              this.searchRes = true;
              if (this.centaline || this.companyCategory == 1) {
                this.diConfig.agentList = [{ ...this.userInfo }];
                let copyUserInfo=Object.assign({}, this.userInfo);
                this.editcompanyUserInfo.push(copyUserInfo)
                this.editAgentList.push(copyUserInfo)
                this.propertyUserInfo = [{ ...this.userInfo }];
                this.agent.push(this.diConfig.agentList[0].accountID);
              }
                if (this.propertyInfo.propertyCategory == 1 && this.propertyInfo.buildingType == 1) {
                  this.setEstData()
                } else {
                  this.setOneEstData()
                }
              this.propertyInfo.roomNo =this.propertyInfo.roomNo?this.propertyInfo.roomNo:this.roomNoZl
              this.showCoupon()
              // 利嘉阁显示图表
              if(this.propertyInfo.propertyCategory == 1 && this.isUseInstantEstateVolume && this.propertyInfo.roomNumber){
                this.isShowChart = true
                this.chartEstateID = this.propertyInfo.estateID
                this.chartScopeCode = this.propertyInfo.gscopeCode;
                if(!this.propertyInfo.estateID){
                  this.getChartData('chartOne')
                }else{
                  this.getChartData('chartOne')
                  this.getChartData('chartTwo')
                }
              }
            } else {
              this.isHosPrice = result.isHosPrice
              this.existRoomNo = result.roomNo?true:false
              this.propertyInfo.roomNo = result.roomNo?result.roomNo:this.propertyInfo.roomNo
              this.propertyInfo.buildingAge = result.buildingAge?result.buildingAge:this.propertyInfo.buildingAge
              this.propertyInfo.buildingID = result.buildingID?result.buildingID:this.propertyInfo.buildingID
              this.propertyInfo.buildingType = result.buildingType?result.buildingType:this.propertyInfo.buildingType
              this.propertyInfo.buildingName = result.buildingName?result.buildingName:this.propertyInfo.buildingName
              this.propertyInfo.buildingNameWithCulture = result.buildingNameWithCulture?result.buildingNameWithCulture:this.propertyInfo.buildingNameWithCulture
              this.propertyInfo.floorName = result.floorName?result.floorName:this.propertyInfo.floorName
              this.propertyInfo.unitID = result.unitID?result.unitID:this.propertyInfo.unitID
              this.propertyInfo.unitCode = result.unitCode?result.unitCode:this.propertyInfo.unitCode
              this.propertyInfo = Object.assign(this.propertyInfo, {
                estateName: result.estateName,
                estateAddress: result.estateAddress,
                unitFloor: result.unitFloor ? String(result.unitFloor) : '',
                roomNumber: result.roomNumber ?  String(result.roomNumber) : '',
                buildingArea: result.buildingArea,
                saleableArea: result.saleableArea,
                propertyManagementFee: result.propertyManagementFee,
                // isLinkParking: result.isLinkParking,
                priceFoot:result.priceFoot,
                priceTop:result.priceTop,
                isForeclosure:result.isForeclosure,
                isShowForeclosureDesc:result.isShowForeclosureDesc,
                // subCategory: result.subCategory ? String(result.subCategory) : ""
              });
              if ( result.subCategory && (typeof result.subCategory === 'string' || typeof result.subCategory === 'number') && this.propertyInfo.propertyCategory ==1) {
                this.propertyInfo.subCategory = [String(result.subCategory)];
              }
              this.$set(this.propertyInfo, 'imageExternal', result.imageExternal);
              // 编辑时候 默认选中
                if (this.propertyInfo.propertyCategory == 1 && this.propertyInfo.buildingType == 1) {
                  this.setEstData('firstEdit')
                } else {
                  this.setOneEstData()
                }
            }
            this.originEstateName = this.propertyInfo.estateName
            //利嘉阁没有洗手间数据时候 洗手间禁用取消
            if ((this.companyCategory == 2 && this.propertyInfo.toiletNumber) || this.companyCategory == 1) {
              this.disSelToil = true
            }
            this.getPhaBuild(this.propertyInfo)
             // 平面图 利嘉阁接口刊登时候，自己调用平面图搜索，修改时，由于利不传回平面图数据，所以不自主搜索
             //刊登与修改时，propertyDisPlayType为1，平面图都需强制选中，且禁用，为其他，则可修改
             if (this.propertyInfo.floorName) {
               this.getFloor(this.propertyInfo)
                //刊登与(修改且propertyDisPlayType为1 )平面图强制默认选中，其他类型修改时，采用fullbyid接口数据 （reviewplat）
                if(this.mode == 'post' || (this.mode == 'edit' && this.propertyInfo.propertyDisPlayType == 1)){
                  this.selPlatImg('101')
                }
                //为1平面图功能禁用
               if (this.propertyInfo.propertyDisPlayType == 1){
                this.lijiageAco = true
              }else{
                this.lijiageAco = false
              }
            }
            if (this.propertyInfo.roomNo ) {
              if(this.mode == 'post' || (this.mode == 'edit' && this.propertyInfo.propertyDisPlayType == 1)){
                this.selPlatImg('100')
              }
              if (this.propertyInfo.propertyDisPlayType == 1){
                this.lijiageAco = true
              }else{
                this.lijiageAco = false
              }
            }
            //图片格式化
            this.imgFormart(this.propertyInfo.imageExternal);
            if (this.mode == 'post') {
              this.$nextTick(function () {
                this.createQRCode();
              });
            }
            // 利嘉阁显示图表
            if(this.propertyInfo.propertyCategory == 1 && this.isUseInstantEstateVolume && this.propertyInfo.roomNumber){
              this.isShowChart = true
              if(!this.propertyInfo.estateID){
                this.getChartData('chartOne')
              }else{
                this.getChartData('chartOne')
                this.getChartData('chartTwo')
              }
            }
          } else if (res.data.code !== 0) {
            // res.data.code == 4001 || res.data.code == 5003
            //如果搜索不到楼盘 展示上次刊登数据
            this.searchRes = false;
            this.warning(res.data.message);
            // this.warning('未匹配到代理人信息');
            if (this.mode !== 'post') {
              if(this.mode == 'edit'){this.butFormSource = true}
              this.$router.push('index');
            }
          }
          //  else {
          //   // 樓盤匹配失敗
          //   this.searchRes = false;
          //   this.warning('樓盤匹配失敗');
          //   if (this.mode !== 'post') {
          //     this.$router.push('index');
          //   }
          // }
        })
        .catch(err => {
          this.getConImgae = false;
          console.log('接口超时');
        });
    },
    // getConditions (data, mode) {
    //   this.getConImgae = true;
    //   this.axios
    //     .post(this.pub.getApi().PropertyInfoExterna, {
    //       categoryNo: data,
    //       rentalType: this.propertyInfo.rentalType,
    //       category: this.propertyInfo.propertyCategory
    //     })
    //     .then(res => {
    //       if (res.data.code === 0 && res.data.result) {
    //         let result = res.data.result;
    //         this.getConImgae = false;
    //         // 删除为null的属性
    //         for (var attr in result) {
    //           if (result[attr] === null) {
    //             delete result[attr];
    //             continue;
    //           }
    //         }
    //         if (this.mode === 'post') {
    //           this.propertyInfo = Object.assign(this.propertyInfo, result);
    //           this.dataFormat('edit');
    //           this.searchRes = true;
    //           if (this.centaline || this.companyCategory == 1) {
    //             this.diConfig.agentList = [{ ...this.userInfo }];
    //             this.propertyUserInfo = [{ ...this.userInfo }];
    //             this.agent.push(this.diConfig.agentList[0].accountID);
    //           }
    //         } else {
    //           this.$set(this.propertyInfo, 'imageExternal', result.imageExternal);
    //           // if (this.propertyInfo.propertyCategory == 2) {
    //           //     this.propertyInfo.categoryNo = this.propertyInfo.propertyNo;
    //           // }
    //         }
    //         //获取修改价格区间
    //         this.propertyInfo.priceFoot = result.priceFoot;
    //         this.propertyInfo.priceTop = result.priceTop;
    //         //图片格式化
    //         this.imgFormart(this.propertyInfo.imageExternal);
    //         if (this.mode == 'post') {
    //           this.$nextTick(function () {
    //             this.createQRCode();
    //           });
    //         }
    //       } else if (res.data.code == 4001 || res.data.code == 5003) {
    //         //如果搜索不到楼盘 展示上次刊登数据
    //         this.searchRes = false;
    //         this.warning('未匹配到代理人信息');
    //         if (this.mode !== 'post') {
    //           this.$router.push('index');
    //         }
    //       } else {
    //         // 樓盤匹配失敗
    //         this.searchRes = false;
    //         this.warning('樓盤匹配失敗');
    //         if (this.mode !== 'post') {
    //           this.$router.push('index');
    //         }
    //       }
    //     })
    //     .catch(err => {
    //       this.getConImgae = false;
    //       console.log('接口超时');
    //     });
    // },
    /*判断标题是否含有敏感词--防抖 避免多次触发*/
    sensitive(type, value) {
      this.axios.post(this.pub.getApi().GetKeyword, { keywords: [value] }).then(res => {
        if (res.data.code == 0) {
          this.hasSenWrods[type] = res.data.result;
        }
      });
    },
    /**关闭关键词dialog*/
    wordQuit() {
      this.commonWords = false;
      this.wordRest();
    },
    onCopy(data) {
        navigator.clipboard.writeText(data).then(() => {
            this.success('複製成功')
        })
    },
    /**点击选择关键词触法*/
    openCommon(item) {
      this.Words.checkedFacSer = [];
      this.Words.checkedTitle = [];
      this.Words.checkedIntr = [];
      this.Words.dialogTitle = item == 1 ? '請選擇常用詞 - 請最多選擇5句，再自行修改' : '請選擇常用詞 - 請最多選擇10句，再自行修改';
      this.Words.flag = item;
      this.BusinessWords.flag = item;
      this.commonWords = true;
      this.wordRest();
    },
    /**清空选中状态*/
    wordRest() {
      if (this.Words.flag === 1) {
        this.Words.title.forEach(item => {
          item.checked = false;
        });
      }
      if (this.Words.flag === 2) {
        this.Words.Introduction.forEach(item => {
          item.checked = false;
        });
      }
      if (this.Words.flag === 3) {
        this.Words.facilitiesWord.forEach(item => {
          item.checked = false;
        });
        this.Words.serviceWord.forEach(item => {
          item.checked = false;
        });
      }
      if (this.BusinessWords.flag === 1) {
        this.BusinessWords.title.forEach(item => {
          item.checked = false;
        });
      }
      if (this.BusinessWords.flag === 2) {
        this.BusinessWords.Introduction.forEach(item => {
          item.checked = false;
        });
      }
    },
    /**点击选择关键词diaglog确认触法*/
    confirmWord() {
      this.commonWords = false;
      // 标题选中 带入中英文
      let EngWords = '';
      let ChiWords = '';
      if (this.Words.flag === 1 && this.BusinessWords.flag === 1) {
        this.Words.title.forEach(item => {
          if (this.Words.checkedTitle.includes(item.chinese)) {
            ChiWords += item.chinese + ' ';
            EngWords += item.english + ' ';
          }
        });
        this.BusinessWords.title.forEach(item => {
          if (this.Words.checkedTitle.includes(item.chinese)) {
            ChiWords += item.chinese + ' ';
            EngWords += item.english + ' ';
          }
        });
        this.$set(this.propertyInfo, 'titleCN', ((this.propertyInfo.titleCN ? this.propertyInfo.titleCN : '') + ChiWords).slice(0, 30));
        this.$set(this.propertyInfo, 'titleEN', ((this.propertyInfo.titleEN ? this.propertyInfo.titleEN : '') + EngWords).slice(0, 50));
      }
      // 介绍选中 带入英文
      if (this.Words.flag === 2 && this.BusinessWords.flag === 2) {
        this.Words.Introduction.forEach(item => {
          if (this.Words.checkedIntr.includes(item.chinese)) {
            EngWords += item.english + ' ';
            ChiWords += item.chinese + ' ';
          }
        });
        this.BusinessWords.title.forEach(item => {
          if (this.Words.checkedIntr.includes(item.chinese)) {
            ChiWords += item.chinese + ' ';
            EngWords += item.english + ' ';
          }
        });
        this.$set(this.propertyInfo, 'introduceCN', ((this.propertyInfo.introduceCN ? this.propertyInfo.introduceCN : '') + ChiWords).slice(0, 500));
        this.$set(this.propertyInfo, 'introduceEN', ((this.propertyInfo.introduceEN ? this.propertyInfo.introduceEN : '') + EngWords).slice(0, 600));
      }
      if (this.Words.flag === 3) {
        this.Words.facilitiesWord.forEach(item => {
          if (this.Words.checkedFacSer.includes(item.chinese)) {
            EngWords += item.english + ' ';
            ChiWords += item.chinese + ' ';
          }
        });
        this.Words.serviceWord.forEach(item => {
          if (this.Words.checkedFacSer.includes(item.chinese)) {
            EngWords += item.english + ' ';
            ChiWords += item.chinese + ' ';
          }
        });
        this.$set(this.propertyInfo, 'servicesCN', ((this.propertyInfo.servicesCN ? this.propertyInfo.servicesCN : '') + ChiWords).slice(0, 500));
        this.$set(this.propertyInfo, 'servicesEN', ((this.propertyInfo.servicesEN ? this.propertyInfo.servicesEN : '') + EngWords).slice(0, 600));
      }
    },
    /**刊登楼盘获取常用词*/
    GetCommonWord() {
      this.axios.get(this.pub.getApi().GetCommonWord).then(res => {
        if (res.data.code == 0 && res.data.result) {
          res.data.result.words.forEach(item => {
            item.checked = false;
            if (item.type == 1) {
              this.Words.title.push(item);
            } else if(item.type == 2) {
              this.Words.Introduction.push(item);
            }else if(item.type == 3){
              this.Words.facilitiesWord.push(item);
            }else{
              this.Words.serviceWord.push(item);
            }
          });
        }
      });
      // 工商专用常用词
      this.axios.get(this.pub.getApi().GetBusinessCommonWord).then(res => {
        if (res.data.code == 0 && res.data.result) {
          res.data.result.words.forEach(item => {
            item.checked = false;
            if (item.type == 1) {
              this.BusinessWords.title.push(item);
            } else {
              this.BusinessWords.Introduction.push(item);
            }
          });
          this.BusinessWords.Introduction = this.unique(this.BusinessWords.Introduction)
        }
      });
    },
    unique(arr) {
      const res = new Map();
      return arr.filter((item) => !res.has(item.chinese) && res.set(item.chinese, 1));
    },
    /**获取配置来判断可以选择几个代理人*/
    GetCompanyCofig() {
      return this.axios.get(this.pub.getApi().GetCompanyCofig);
    },
    /**切换大图*/
    changeImg(sign) {
      let current = this.selectedImage[0];
      if (sign === 'prev' && current != 0) {
        this.$set(this.selectedImage, 0, current - 1);
      } else if (sign === 'next' && this.images.length - 1 != current) {
        this.$set(this.selectedImage, 0, current + 1);
      }
    },
    /**放大图片*/
    largeImg() {
      this.enLarge = true;
    },
    selAllImg(){
      this.selectedImage = this.images.map((item, index) => index)
    },
    /**点击选中图片*/
    selected(index) {
      let temp = this.selectedImage.indexOf(index);
      if (temp > -1) {
        this.selectedImage.splice(temp, 1);
      } else {
        this.selectedImage.push(index);
      }
    },
    initZipImg() {
      // 若有新增bucket,需要oss到v4
      this.$upload = new $upload({
        // 可选参数
        authorizationV4: true,
        maxWidth: 1920, //最大压缩宽度(仅针对图片文件生效)
        maxHeight: 1920, //可选参数,最大压缩高度(仅针对图片文件生效)
        zipLimit: 3000, //压缩上传阈值，单位KB， 超过此大小则压缩，否则原图上传(仅针件图片文件生效)
        // 必选参数 OSS配置
        region: 'oss-accelerate',
        accessKeyId: 'LTAI4FndXDCKXK4tEMRgRBBv',
        accessKeySecret: 'TKLkHAOMxiDNf1PjoGX7KguYmeqJgx',
        bucket: 'house730-files'
        // bucket: 'house730-uat-files'
      });
    },
    initQr(){
      // this.initScoket()
      this.isinit = true
      // 12小时后加上蒙层
      setTimeout(() => {
        this.isinit = false;
      }, 3600000); 
    },
    // async attemptReconnect(attemptNumber,type){
    //   console.log(attemptNumber <= 6,"attemptNumber:",attemptNumber,"maxRetries:",this.maxRetries);
    //   if(attemptNumber <= this.maxRetries){
    //     if (attemptNumber == 3) {
    //         console.log("重试3次，尝试使用备用方案获取数据");
    //         this.fetchDataAndExecuteReceiveMessage(type);
    //     }
    //     try {
    //       await this.scoket.start()
    //       console.log("重连成功")
    //     } catch (error) {
    //       console.log("重新尝试")
    //       setTimeout(() => this.attemptReconnect(attemptNumber + 1,type), 2000);
    //     }
    //   }else{
    //     console.log("fetch尝试")
    //     this.fetchDataAndExecuteReceiveMessage();
    //   }
    // },
    // async fetchDataAndExecuteReceiveMessage(type){
    //     try {
    //       const response = await fetch(`https://rtc.house730.com/message?identification=${this.identification}`);
    //       if (!response.ok) {
    //           throw new Error(`HTTP error! status: ${response.status}`);
    //       }
    //       //  else {
    //       //     retryCount = 0;
    //       // }
    //       let imagesList = await response.json()
    //       if(type == 'onclose'){
    //         if (this.file.length > this.images.length) {
    //           var temp = this.file.length - this.images.length;
    //         }
    //         this.images = JSON.parse(imagesList);
    //         this.file = JSON.parse(imagesList);
    //         for (var i = 1; i <= temp; i++) {
    //           this.file.push({ file: true });
    //         }
    //         if (this.images.length) {
    //           this.images.forEach(item => {
    //             if (item.imageType === '0') {
    //               item.imageType = '';
    //             }
    //           });
    //         }
    //       };

    //       if (!this.hasPushedException) {
    //         let reconnectData = {
    //           'type': 'fetchDataAndExecuteReceiveMessage',
    //           'msg': '重新获取图片'
    //         };
    //         this.axios.post(this.pub.getApi().PushException, reconnectData);
    //         this.hasPushedException = true; // 标记为已执行
    //       }
    //   } catch (error) {
    //       console.error("Error fetching data from API:", error);
    //   }
    // },
    /**建立连接*/
    // initScoket() {
    //   let _this = this;
    //   // this.scoket = new signalR.HubConnectionBuilder().withUrl(`https://rtc.house730.com/uploadhub?identification=${this.identification}`).build();
    //   this.scoket = new signalR.HubConnectionBuilder().withUrl(`https://rtc.house730.com/uploadhub?identification=${this.identification}`).withAutomaticReconnect({
    //     nextRetryDelayInMilliseconds: retryContext => {
    //       if (retryContext.elapsedMilliseconds < 300000) {
    //         if(_this.reconnectAttempts == 3){
    //           _this.fetchDataAndExecuteReceiveMessage()
    //         }
    //         _this.reconnectAttempts++; 
    //         if (!_this.isReconnecting) {
    //           if(_this.reconnectAttempts == 10){
    //             _this.isReconnecting = true; // 设置标志位为 true
    //           }
    //             let reconnectData = {
    //                 'type': 'reconnectAttempt',
    //                 'msg': `版本:${navigator.userAgent},重连中`
    //             };
    //             _this.axios.post(_this.pub.getApi().PushException, reconnectData);
    //       }              
    //         return 2000;
    //       } else {
    //           return null;
    //       }
    //     }
    //   }).build();
    //   this.scoket.onreconnected(connectionId => {
    //     // 发送重连尝试次数到 pushException
    //     console.log("onReconnect")
    //     let reconnectData = {
    //       'type': 'reconnectSuccess',
    //       'msg': `重连成功，尝试次数: ${_this.reconnectAttempts}`
    //     };
    //     _this.axios.post(_this.pub.getApi().PushException, reconnectData);
    //     _this.reconnectAttempts = 0; // 重置重连尝试次数
    //     _this.isReconnecting = false
    //   });
    //   // this.scoket.onclose(() => {
    //   //   _this.isReconnecting = false; // 重置标志位
    //   // });
    //   this.scoket.start().catch(err => console.error(err.toString()));
    //   this.scoket.on('Online', function (user) {
    //     console.log('pcOnline');
    //     if (_this.mode && _this.images.length) {
    //       _this.sendSocket();
    //     }
    //   });
    //   // // 断联可以被检测到，但socket无法建立成功，发送不了消息
    //   this.scoket.onclose(() => {
    //     // this.initScoket()
    //     console.log('Connection closed. Attempting to reconnect...');
    //     _this.attemptReconnect(1,'onClose');
    //     _this.isReconnecting = false; // 重置标志位
    //     let errData = {
    //       'type':'socket-onclose',
    //       'msg':`链接关闭，自动启动重连尝试，版本:${navigator.userAgent}`
    //     }
    //     _this.axios.post(_this.pub.getApi().PushException,errData);
    //   });
    //   this.scoket.on('ReceiveMessage', message => {
    //     console.log("pc--receiveMessage")
    //     /** 问题：当wap端发送数据过来,此刻还有图片正在上传*/
    //     if (this.file.length > this.images.length) {
    //       var temp = this.file.length - this.images.length;
    //     }
    //     this.images = JSON.parse(message);
    //     this.file = JSON.parse(message);
    //     for (var i = 1; i <= temp; i++) {
    //       this.file.push({ file: true });
    //     }
    //     if (this.images.length) {
    //       this.images.forEach(item => {
    //         if (item.imageType === '0') {
    //           item.imageType = '';
    //         }
    //       });
    //     }
    //   });
    // },

    // /**发送数据*/
    // sendSocket(item) {
    //   let _this = this;
    //   if (this.scoket) {
    //     if(this.scoket.connectionState == 0){
    //       this.initScoket()
    //     }
    //     this.scoket
    //       .invoke('SendMessage', JSON.stringify(this.images))
    //       .then(() => {
    //         // console.log('发送数据 成功', JSON.stringify(this.images));
    //       })
    //       .catch(function (err) {
    //         let errData = {
    //           'type':'catch-PC-SendMessage',
    //           'msg':`版本:${navigator.userAgent},报错:${err.toString()}`
    //         }
    //         _this.axios.post(_this.pub.getApi().PushException,errData);
    //         return err.toString();
    //       });
    //   }
    // },
    /**生成二维码*/
    createQRCode: function () {
      new QRCode(this.$refs.qrCodeDiv, {
        // text: `//localhost:8803/m/scan?token=${this.token}&identification=${this.identification}`,
        text: `${this.pub.config.wapScan}?token=${this.token}&identification=${this.identification}`,
        width: 115,
        height: 115,
        colorDark: '#333333', //二维码颜色
        colorLight: '#ffffff', //二维码背景色
        correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
      });
    },
    /**取消*/
    // quit() {
    //   this.attachVisible = false;
    //   if (this.mode == 'edit') {
    //     this.disablePost = false;
    //   }
    //   if (this.$route.query.draftID) {
    //     this.verifyFile = [];
    //     this.propertyInfo.verifyImage = [];
    //     //bug 点击取消 应该将图片刚刚传入的删除
    //     this.verifyFile = Object.assign(this.verifyFile, this.draftVerifyFile)
    //     this.propertyInfo.verifyImage = Object.assign(this.propertyInfo.verifyImage, this.draftverifyimage)
    //   } else {
    //     this.verifyFile = [];
    //     this.propertyInfo.verifyImage = [];
    //   }
    // },
    /**根据当前楼盘是 搜索录入 || 选择自取录取*/
    entryMethod() {
      this.originEstateName = ''
      this.addressSearch = false;
      this.changeProOversea()
      //  false 表编辑得楼盘为选单输入
      this.changeAddressSearch = this.addressSearch
      this.diConfig.gscope.forEach(item => {
        item.children.forEach(items => {
          if (items.gscopeCode === this.propertyInfo.gscopeCode) {
            this.propertyInfo.gscopeFaCode = item.gscopeCode;
            this.diConfig.ChildrenGscope = item.children;
          }
        });
      });
    },
    /**上传文件格式判断*/
    beforeUpload(file) {
      if (file.size === 0) {
        this.warning('圖片上傳失敗，請重新上傳');
        return false;
      }
      if (file.size > 20971520) {
        this.warning('檔案大小必須20MB以下');
        return false;
      }
      if (!file.name.toLocaleLowerCase().match(/(.*)\.(jpg|jpeg|png)$/)) {
        this.warning('圖片支援格式：JPG, JPEG, PNG');
        return false;
      }
      if (this.images.length >40) {
        this.images = this.images.splice(0, 40);
        this.warning('已超過圖片上傳數量限制');
      }
    },
    /**超出限制时*/
    handleExceed(files, fileList) {
      this.warning('已超過圖片上傳數量限制');
    },
    // /** 图片上传 楼盘验证图片*/
    // upVerifyImage(value) {
    //   if (this.mode == 'edit') {
    //     this.showEditerror = false
    //   }
    //   let _this = this;
    //   // this.verifyFile.push(value.file);
    //   const file = value.file;
    //   if (this.$route.query.draftID) {
    //     // 要回显存在草稿箱的文件图片
    //     this.verifyFile = this.propertyInfo.verifyImage.map(item => {
    //       return {
    //         name: item,
    //         url: item
    //       }
    //     });
    //     this.verifyFile.push(file);
    //   } else {
    //     this.verifyFile.push(file);
    //   }
    //   this.$upload
    //     .go(file)
    //     .then(function (result) {
    //       if (_this.attachVisible) {
    //         result.url = result.url.replace('house730-files.oss-accelerate.aliyuncs.com', 'img.house730.com').replace('http://', 'https://');
    //         _this.propertyInfo.verifyImage.push(result.url);
    //       }
    //     })
    //     .catch(err => {
    //       this.verifyFile = this.propertyInfo.verifyImage;
    //     });

    //   // let data = new FormData();
    //   // data.append('file', file);
    //   // this.axios.post(this.pub.getApi().Upload, data).then(res => {
    //   //   if (res.data.code === 0 && res.data.result) {
    //   //     if (this.attachVisible) {
    //   //       this.propertyInfo.verifyImage.push(res.data.result[0].url);
    //   //     }
    //   //   }
    //   // });
    // },
    // 视频图片上传
    upvideoImage(value) {
      this.isHidden = false
      let file = value.file;
      let _this = this;
      this.vurls = []
      // 此时必须是点击确定上传之后,如果只是点击上传但是没有点击确定的话,别的是没用的
      this.videos[0].defaultImagePath = ''
      this.$upload
        .go(file)
        .then(function (result) {
          result.url = result.url.replace('house730-files.oss-accelerate.aliyuncs.com', 'img.house730.com').replace('http://', 'https://');
          _this.vurls.push(result.url)
          _this.videos[0].defaultImagePath = _this.vurls[0]
        })
        .catch(err => {
          _this.videos[0].defaultImagePath = '...'
        });
      // if (value.constructor === Object && value.hasOwnProperty('file')) {
      //   value = value.file;
      // }
      // let file = value.file;
      // let url = '';
      // if (window.createObjectURL != undefined) {
      //   url = window.createObjectURL(value.raw);
      // } else if (window.URL != undefined) {
      //   url = window.URL.createObjectURL(value.raw);
      // } else if (window.webkitURL != undefined) {
      //   url = window.webkitURL.createObjectURL(value.raw);
      // }
      // this.videos[0].defaultImagePath=url;
      // this.goUp();
    },
    videoLink(val) {
      this.videos[0].videoPath = val
    },
    upcol() {
      this.buttonup = 'primary';
      this.buttondel = '';
    },
    delVideoImage() {
      this.buttonup = '';
      this.buttondel = 'primary';
      this.isHidden = true
      //需要给vurls置空, 因为每次点击上传后dataformat(post)中进行了赋值
      this.vurls = []
      this.videos[0].defaultImagePath = ''
    },
    /** 图片上传 楼盘图片 */
    async upimg(value) {
      // this.newnewRead(value)
      this.newnewReadCopy(value)
      return
      // if (value.constructor === Object && value.hasOwnProperty('file')) {
      //   value = value.file;
      // }
      // /*选择的图片*/
      // let seleLength = this.images.length - Object.keys(this.imgQueue).length;
      // if (seleLength + Object.keys(this.imgQueue).length >= 40) {
      //   return;
      // }
      // //创建字典队列
      // this.imgQueue[value.uid] = value;
      // let file = value;
      // const windowURL = window.URL || window.url || window.webkitURL;
      // const dataimgurl = windowURL.createObjectURL(file);
      // file.localPath = dataimgurl;
      // this.images.push({
      //   localPath: dataimgurl,
      //   imagePath: null,
      //   imageType: '',
      //   imageDesc: '',
      //   // imageTypeWithCulture:''
      // });
      // let _this = this;
      // if (!this.isUpLoading) {
      //   this.file.push(value);
      //   this.goUp();
      // }
    },
    async newnewReadCopy(files) {
      this.uploadImgStatus = true;
      const file = files.file;
      
      // 增加处理计数
      this.processingCount++;
      
      let fileBlob;
      if (file.size < 2 * 1024 * 1024) {
        fileBlob = file;
      } else {
        try {
          // 标记为压缩中状态
          const index = this.images.findIndex(p => p.name === file.name);
          if (index !== -1) {
            this.$set(this.images[index], 'status', 'compressing');
          }
          
          const compressedBlob = await this.compressFileCopy(file);
          if (compressedBlob.size >= file.size) {
            fileBlob = file;
          } else {
            fileBlob = compressedBlob;
          }
        } catch (err) {
          fileBlob = file;
        }
      }
      
      // 处理计数减少（压缩完成）
      this.processingCount--;
      
      // 记录文件信息
      this.failedFiles = this.failedFiles || [];
      this.failedFiles.push({
        name: file.name,
        originalSize: file.size,
        originalType: file.type,
        compressedSize: fileBlob.size,
        compressedType: fileBlob.type,
        compressed: file.size > 2 * 1024 * 1024,
      });
      
      const dataImg = window.URL.createObjectURL(fileBlob);
      
      // 创建文件对象并加入队列
      const compressedFileObject = new File([fileBlob], file.name, { type: file.type });
      compressedFileObject.localPath = dataImg;
      this.imgQueue = this.imgQueue || {};
      this.imgQueue[compressedFileObject.localPath] = compressedFileObject;
      // 更新预览列表
      if (!this.images || this.images.length === 0) {
        this.images = [];
      }
      
      // 添加或更新图片状态(已废弃，会有同名图片只会进行上传一次问题)
      // const existingIndex = this.images.findIndex(img => img.name === file.name);
      // if (existingIndex !== -1) {
      //   this.$set(this.images, existingIndex, {
      //     ...this.images[existingIndex],
      //     localPath: dataImg,
      //     status: 'queue'
      //   });
      // } else {
      //   this.images.push({
      //     name: file.name,
      //     localPath: dataImg,
      //     imagePath: '',
      //     status: 'queue'
      //   });
      // }
      this.images.push({
        name: file.name,
        localPath: dataImg,
        imagePath: '',
        status: 'queue',
        retryCount: 0, 
        maxRetries: 3, 
        isDefault:false,
        isRetrying: false // 新增标志位，防止重复重试
      });
      // 触发上传流程
      this.startUploadCopy();
    },
    
    async compressFileCopy(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        
        reader.onload = function (event) {
          const img = new Image();
          img.src = event.target.result;
          
          img.onload = function () {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            const _width = img.width;
            const _height = img.height;
            const ratio = _width / _height;
            const MAX_WIDTH = 2048;
            const width = _width > MAX_WIDTH ? MAX_WIDTH : _width;
            const height = width / ratio;
            
            canvas.width = width;
            canvas.height = height;
            ctx.drawImage(img, 0, 0, width, height);
            
            let quality = 0.6;
            if (file.size > 10 * 1024 * 1024) {quality = 0.4;}
            else if (file.size > 5 * 1024 * 1024) {quality = 0.5;}
            const mimeType = file.type === 'image/png' ? 'image/png' : 'image/jpeg';
            
            canvas.toBlob(
              blob => blob ? resolve(blob) : reject(new Error('压缩失败')),
              mimeType,
              quality
            );
          };
          
          img.onerror = reject;
        };
        
        reader.onerror = reject;
      });
    },
    
    startUploadCopy() {
      if (this.uploading || Object.keys(this.imgQueue).length === 0) {
        return;
      }
      this.uploading = true;
      this.isUploadComplete = false;
      this.processQueueCopyT();
    },
    
  async processQueueCopyT() {
      const keys = Object.keys(this.imgQueue);
      // 检查所有任务是否完成
      if (keys.length === 0 && this.processingCount === 0) {
          this.uploading = false;
          this.isUploadComplete = true;
          // this.pushCache('uploadImg');
          // 检查是否有失败项
          const failedItems = this.images.filter(item => item.status === 'fail' && !item.isManualRetry);
          // 当用户同意未上传完成图片可直接刊登时 此时无需弹框
          if (failedItems.length > 0 && !this.imgUploadPass) {
            this.cacheOperationPaused = true;
            this.isRetryDialogOpen = true;
            
            try {
              this.errlogCount ++
              // this.imgwarning = false
              await this.$confirm(
                `<div style="font-weight:700;color:#444444;font-size:16px;">圖片上傳失敗</div><div style="color:#444444;font-size:16px;">網絡連接異常，請檢查後重試</div>`, 
                '提示',
                {
                  confirmButtonText: '重新上傳',
                  cancelButtonText: '刪除失敗圖片',
                  closeOnClickModal: false,
                  showClose: false,
                  iconClass:'el-icon-error',
                  dangerouslyUseHTMLString: true,
                  customClass:'imgup_btn',
                }
              );
              // 用户点击确定
              failedItems.forEach(item => {
                item.changeFailText = true
                // item.isManualRetry = true; // 标记为手动重试后，第一次弹出，再次失败后，不在弹出弹框
                item.isManualRetry = false; // 上传失败图片在用户不点击取消上传情况下，不断弹出弹框询问是否重新上传
                this.retryUpload(item)
              });
            } catch (cancel) {
              // 用户点击取消或关闭对话框 删除需重传图片
              failedItems.forEach(item => {
                const index = this.images.indexOf(item);
                if (index !== -1) {
                  // 从图片列表中删除
                  this.images.splice(index, 1);
                  // 从队列中删除（如果有）
                  delete this.imgQueue[item.localPath];
                }
              });
              // 同步状态
              this.isRetryDialogOpen = false;
              this.cacheOperationPaused = false;
              this.pushCache('uploadImg');

            }finally {
              this.isRetryDialogOpen = false;
              this.cacheOperationPaused = false;
              // this.pushCache('uploadImg'); // 恢复后立即同步
            }
          } else {
            this.pushCache('uploadImg');
          }
          return;
      }
  
      if (keys.length === 0) {
          setTimeout(() => this.processQueueCopyT(), 100);
          return;
      }
  
      const key = keys[0];
      const file = this.imgQueue[key];
      const index = this.images.findIndex(p => p.localPath === file.localPath);
  
      try {
          this.processingCount++;
          
          // 更新状态
          if (index !== -1) {
              const status = this.images[index].retryCount > 0 ? 'retrying' : 'uploading';
              this.$set(this.images[index], 'status', status);
          }
  
          const result = await this.uploadSingleFileCopy(file);
          delete this.imgQueue[key];
          
          if (index !== -1) {
              this.$set(this.images[index], 'status', 'success');
              this.$set(this.images[index], 'imagePath', result.url);
              this.$set(this.images[index], 'localPath','');
          }
      } catch (error) {
          if (index !== -1) {
              const currentImage = this.images[index];
              currentImage.retryCount++;
              
              if (currentImage.retryCount <= currentImage.maxRetries) {
                  this.$set(this.images[index], 'status', 'retrying');
                  this.imgQueue[key] = file; // 直接重新加入队列
              } else {
                // 如果是手动重试的图片，失败时直接删除
                if (currentImage.isManualRetry) {
                  // 释放blob URL
                  if (currentImage.localPath) {
                    URL.revokeObjectURL(currentImage.localPath);
                  }
                  this.$set(this.images[index], 'status', 'fail');
                  // 非点击重新上传时的 上传失败， 文字需要显示“上传失败” 验收【PMS06期】
                  this.$set(this.images[index], 'changeFailText', false);

                  // this.images.splice(index, 1);
                } else {
                  this.$set(this.images[index], 'status', 'fail');
                  this.$set(this.images[index], 'changeFailText', false);
                }
                  // this.$set(this.images[index], 'status', 'fail');
                  delete this.imgQueue[key];
              }
          } else {
              delete this.imgQueue[key];
          }
      } finally {
          this.processingCount--;
          setTimeout(() => this.processQueueCopyT(), 100); 
      }
  },
  async retryUpload(item) {
    const index = this.images.indexOf(item);
    if (index === -1) {return;}
    fetch(item.localPath)
    .then(res => res.blob())
    .then(blob => {
      // 正确构造File对象（与正常上传一致）
      const file = new File([blob], item.name, { 
        type: blob.type || 'image/jpeg' // 默认类型
      });
      file.localPath = item.localPath;

      // 更新状态
      this.$set(this.images[index], {
        ...item,
        retryCount: 0,
        isDefault:false,
        status: 'queue',
        showRetryButton: false,
        isManualRetry: true ,// 确保标记为手动重试
        changeFailText:false//点击重新上传后，status为fail也要展示“等待上传”
      });

      // 加入队列
      this.imgQueue[file.localPath] = file;
      if (!this.uploading) {this.startUploadCopy();}
    })
    .catch(() => {
      // this.$set(this.images[index], 'status', 'fail');
      // 手动重试失败时直接删除，不显示弹框
      const currentIndex = this.images.indexOf(item);
      if (currentIndex !== -1) {
        // 释放blob URL
        if (item.localPath) {
          URL.revokeObjectURL(item.localPath);
        }
        this.images.splice(currentIndex, 1);
        delete this.imgQueue[item.localPath];
      }

    });
  },
    
    uploadSingleFileCopy(file) {
      return new Promise((resolve, reject) => {
        const formData = new FormData();
        formData.append('file', file, file.name);
        const CancelToken = this.axios.CancelToken;
        const source = CancelToken.source();
        const timeout = setTimeout(() => {
          source.cancel('Operation canceled due to timeout.');
          if(this.failedFiles && this.failedFiles.length > 0){
            let errData = {
              type: 'ImgMessageLog',
              msg: JSON.stringify(this.failedFiles)
            };
            this.axios.post(this.pub.getApi().PushException, errData);
          }
          let errData = {
            'type':'catch-pc-UploadMessage',
            'msg':'Request timed out'
          }
          this.axios.post(this.pub.getApi().PushException,errData);
          reject(new Error('Request timed out'));
        }, 180000);
        
        this.axios.post(this.pub.getApi().Upload, formData, {
          cancelToken: source.token
        }).then(res => {
          clearTimeout(timeout);
          if (res.data && res.data.code === 0 && res.data.result) {
            resolve({ url: res.data.result[0].url });
          } else {
            reject(new Error('Upload failed'));
          }
        }).catch(err => {
          clearTimeout(timeout);
          reject(err);
        });
      });
    },

    // 新增方法：检查所有任务是否完成
    checkAllDone() {
      if (Object.keys(this.imgQueue).length === 0 && this.processingCount === 0 && !this.isUploadComplete) {
        this.isUploadComplete = true;
        this.pushCache('uploadImg');
      }
    },
    // async processQueueCopy() {
    //   const keys = Object.keys(this.imgQueue);
    //   // 检查所有任务是否完成（队列为空且没有处理中的任务）
    //   if (keys.length === 0 && this.processingCount === 0) {
    //     this.uploading = false;
    //     this.isUploadComplete = true;
    //     this.pushCache('uploadImg');
    //     return;
    //   }
      
    //   // 队列为空但还有处理中的任务，等待后再次检查
    //   if (keys.length === 0) {
    //     setTimeout(() => this.processQueueCopy(), 100);
    //     return;
    //   }
      
    //   const key = keys[0];
    //   const file = this.imgQueue[key];
      
    //   // 更新状态为上传中
    //   const index = this.images.findIndex(p => p.localPath === file.localPath);
    //   if (index !== -1) {
    //     this.$set(this.images, index, {
    //       ...this.images[index],
    //       status: 'uploading'
    //     });
    //   }
      
    //   try {
    //     // 增加处理计数（上传开始）
    //     this.processingCount++;
    //     const result = await this.uploadSingleFileCopy(file);
    //     // 成功上传
    //     delete this.imgQueue[key];
    //     if (index !== -1) {
    //       this.$set(this.images[index], 'imagePath', result.url);
    //       this.$set(this.images[index], 'status', 'success');
    //     }
        
    //     // 减少处理计数（上传完成）
    //     this.processingCount--;
        
    //     // 继续处理下一张
    //     this.processQueueCopy();
    //   } catch (error) {
    //     // 减少处理计数（上传完成）
    //     this.processingCount--;
        
    //     this.uploading = false;
    //     if (index !== -1) {
    //       this.$set(this.images[index], 'status', 'fail');
    //     }
    //     delete this.imgQueue[key];
        
    //     // 继续处理下一张
    //     this.processQueueCopy();
    //   }
    // },
    // async goUp() {
    //   let _this = this;
    //   if (Object.keys(this.imgQueue).length > 0) {
    //     try {
    //       this.curQueue.id = Object.keys(this.imgQueue)[0];
    //       this.curQueue.file = this.imgQueue[this.curQueue.id];
    //       _this.isUpLoading = true;
    //       const result = await _this.$upload.go(_this.curQueue.file);
    //       delete _this.imgQueue[_this.curQueue.id]; //上传成后删除列队中的文件
    //       result.url = result.url.replace('house730-files.oss-accelerate.aliyuncs.com', 'img.house730.com').replace('http://', 'https://');
    //       _this.images.forEach((e, i) => {
    //         if (e.localPath === _this.curQueue.file.localPath) {
    //           delete _this.images[i].localPath;
    //           _this.images[i].imagePath = result.url;
    //         }
    //       });
    //       this.pushCache();
    //       // _this.sendSocket();

    //       _this.goUp();
    //     } catch (err) {
    //       let errData = {
    //         'type':'imgErr',
    //         'msg':err.toString()
    //       }
    //       let count = _this.curQueue.file.count || 0;
    //       count += 1;
    //       if(count<=1)this.axios.post(this.pub.getApi().PushException,errData);
    //       _this.curQueue.file.count = count;
    //       //错误次数小于5次, 继续重试
    //       if (count <= 5) {
    //         _this.goUp();
    //       } else {
    //         delete _this.imgQueue[_this.curQueue.id];
    //         //多次上传失败,删除错误图片,继续上传剩余图片
    //         _this.images.forEach((e, i) => {
    //           if (e.localPath === _this.curQueue.file.localPath) delete _this.images[i].localPath;
    //         });
    //         _this.goUp();
    //       }
    //       // console.log('文件上传失败', err, _this.curQueue.file, _this.imgQueue);
    //       // 上传图片失败清空file文件可继续上传
    //       // console.log('文件上传失败');
    //       // this.file = this.images;
    //       // _this.goUp();
    //     }
    //   } else {
    //     this.isUpLoading = false;
    //     this.curQueue = {};
    //     // this.file = this.images;
    //     this.file = []
    //     for (let i = 0; i < this.images.length; i++) {
    //       this.file.push(this.images[i])
    //     }
    //   }
    //   // this.isClose=true

    // },
    editPic(url){
      let urls = url.indexOf('?x-oss-process') > -1 ? url : url + '?x-oss-process=style/master-nowater';
      this.editImgDialogVisible = true
      this.$nextTick(() => {
        this.instance = new ImageEditor(document.querySelector('#tui-image-editor'), {
            usageStatistics: false,//这个一定要写要不然会报错
            language:'zh-CN',
            includeUI: {
                loadImage: {
                    path: urls,//加载的图片链接
                    name: 'image',//图片名称（不重要）
                },
                menu: [
                  "text", // 添加文本
                  "draw", // 添加绘画
                ],
                initMenu: 'text', 
                menuBarPosition: "bottom",
                locale: locale_zh,//语言
                theme: customTheme,
            },
            cssMaxWidth: 700,//宽
            cssMaxHeight: 700,//高
        })
        // document.getElementsByClassName('tui-image-editor-main')[0].style.top = 0
        // 设置图片编辑其余距离底部90px（就不会被底部展开的工具栏遮挡住了）===>无效
        // document.getElementsByClassName('tui-image-editor-wrap')[0].style.bottom = 150+'px'
   
        //! 修改图片编辑器的顶部导航栏
        // 这个获取到的是tui-image-editor组件默认自带的顶部菜单栏目
        // console.log('顶部工具栏dom')
        // console.log(document.querySelector('.tui-image-editor-help-menu'))
        // 将顶部菜单栏整个隐藏掉
        // document.querySelector('.tui-image-editor-help-menu').style.display = 'none'
   
        // 你也可以指定那个菜单隐藏，留几个有用的菜单
        // document.querySelector('[tooltip-content="Undo"]').style.display = 'none'// 上一步
        // document.querySelector('[tooltip-content="Redo"]').style.display = 'none' // 下一步
        document.querySelector('[tooltip-content="Reset"]').style.display = 'none' // 完全重新编辑
        document.querySelector('[tooltip-content="ZoomIn"]').style.display = 'none' // 放大
        document.querySelector('[tooltip-content="ZoomOut"]').style.display = 'none' // 缩小
        document.querySelector('[tooltip-content="Hand"]').style.display = 'none' // 拖动界面
        // document.querySelector('[tooltip-content="History"]').style.display = 'none'
        document.querySelector('[tooltip-content="Delete"]').style.display = 'none' // 删除选中编辑内容
        // document.querySelector('[tooltip-content="DeleteAll"]').style.display = 'none' // 清空
        // 隐藏分割线
        document.querySelectorAll('.tui-image-editor-icpartition').forEach(item => {
          item.style.display = 'none'
        })
      })
    //   imageEditor.addText('init text', {
    //     styles: {
    //         fill: '#000',
    //         fontSize: 20,
    //         fontWeight: 'bold'
    //     },
    //     position: {
    //         x: 10,
    //         y: 10
    //     }
    // }).then(objectProps => {
    //     console.log("fffff",objectProps.id);
    // });
    },
    async uploadEditImg (index) {
      this.editImgDialogVisible = false

      const base64String = this.instance.toDataURL();
      const data = window.atob(base64String.split(",")[1]);
      const ia = new Uint8Array(data.length);
      for (let i = 0; i < data.length; i++) {
        ia[i] = data.charCodeAt(i);
      }
      const blob = new Blob([ia], { type: "image/png" });
      blob.lastModifiedDate = new Date()
      blob.name = 'spng'
      const windowURL = window.URL || window.url || window.webkitURL;
      const dataimgurl = windowURL.createObjectURL(blob);
      blob.localPath = dataimgurl
      const result = await this.$upload.go(blob);
      result.url = result.url.replace('house730-files.oss-accelerate.aliyuncs.com', 'img.house730.com').replace('http://', 'https://');
      this.images[index].imagePath = result.url;
      this.pushCache();
      // this.sendSocket();
    },
    /** 删除图片 楼盘图片 */
    delPic() {
      this.isDeleting = true;
      let delImages = JSON.parse(JSON.stringify(this.images));
      try {
      this.selectedImage.sort(function (a, b) {
        return b - a;
      });
      this.selectedImage.forEach(async item => {
        // this.images.splice(item, 1);
        // this.file.splice(item, 1);
        delImages.splice(item, 1)
      });
      this.images = JSON.parse(JSON.stringify(delImages)); 
      this.selectedImage.forEach(async item => {
        this.file.splice(item, 1);
      });
      this.pushCache().finally(() => {
          this.isDeleting = false;
      });
        /**重新记录中原利嘉阁选中图*/
        this.selList = [];
        this.images.forEach(item => {
          this.selList.push(item.imagePath);
        });
        this.selectedImage = [];
      } catch (error) {
        this.isDeleting = false;
      }
      // this.sendSocket();
    },
    // /** 删除图片 楼盘验证图片 */
    // delVerifyImage(index) {
    //   this.propertyInfo.verifyImage.splice(index, 1);
    //   this.verifyFile.splice(index, 1);
    // },
    /** 旋转图片多张 楼盘图片 */

    // rotates(urls) {
    //     return this.axios.post(this.pub.getApi().RotateImages, { urls, degrees: 0 });
    // },
    /** 旋转图片单张 楼盘图片 */
    // rotate(index, url, angle) {
    //   //* ?x-oss-process=style/1080xauto_f
    //   let urls = url.indexOf('?x-oss-process') > -1 ? url : url + '?x-oss-process=style/master-nowater';
    //   this.axios
    //     .post(this.pub.getApi().RotateImage, {
    //       url: urls,
    //       degrees: angle
    //     })
    //     .then(res => {
    //       if (res.data.code === 0 && res.data.result) {
    //         this.images[index].imagePath = res.data.result[0].url;
    //         console.log("旧旋转")
    //         this.pushCache();
    //         // this.sendSocket();
    //       }
    //     });
    // },
    async rotate( angle) {
      // 检查是否有选中的图片
      if (this.selectedImage.length === 0) {
        this.$message.warning('请至少选择一张图片');
        return;
      }
      this.isRotating = true
      try {
        // 创建所有旋转请求的Promise数组
        const rotatePromises = this.selectedImage.map(index => {
          const url = this.images[index].imagePath;
          this.$set(this.images[index], 'status', 'rotateing');

          const urls = url.indexOf('?x-oss-process') > -1 ? url : url + '?x-oss-process=style/master-nowater';
          
          return this.axios.post(this.pub.getApi().RotateImage, {
            url: urls,
            degrees: angle
          }).then(res => {
            if (res.data.code === 0 && res.data.result) {
              // 更新对应图片的URL
              this.$set(this.images[index], 'imagePath', res.data.result[0].url);
              this.$set(this.images[index], 'status', 'success');
              return { success: true, index };
            } 
              return { success: false, index, error: res.data.message || '旋转失败' };
            
          }).catch(error => {
            this.$set(this.images[index], 'status', 'success');
            return { success: false, index, error: error.message || '请求失败' };
          });
        });
        const results = await Promise.all(rotatePromises);
        this.$forceUpdate()
        
        // 检查是否有失败的请求
        const failedResults = results.filter(result => !result.success);
        if (failedResults.length > 0) {
          const errorMessage = `部分图片旋转失败: ${failedResults.map(r => `图片${r.index + 1}: ${r.error}`).join('; ')}`;
          this.$message.error(errorMessage);
        } 
        // else {
        //   // 所有图片都旋转成功
        //   this.$message.success('所有图片旋转成功');
        // }
        
        // 无论是否有失败，都执行pushCache
        this.pushCache().finally(()=>{
          this.isRotating = false
        });
        
      } catch (error) {
        this.isRotating = false
        this.$message.error('旋转过程中发生错误');
      }
    },

    /**物业编号重复判断*/
    checkRepeat(data) {
      // 物业编号有修改 减价盘不予展示
      if(this.mode == 'edit' &&  this.compareNo.propertyNo !== this.propertyInfo.propertyNo){
        this.clearBoc = true;
        this.clearBocPro();
      }
      if (data.trim() === '') {
        return;
      }
      this.axios
        .post(this.pub.getApi().IsExistCategoryNo, {
          categoryNo: data,//物业编号
          category: this.propertyInfo.propertyCategory,//住宅等不同类型
          rentalType: this.propertyInfo.rentalType,//租售类型
          propertyId: this.mode === 'edit' ? this.propertyInfo.propertyID : 0//楼盘id
        })
        .then(res => {
          if (res.data.result) {
            this.propertyNoRepeat = true;
            // 提示编号重复
            this.promptinfo = res.data.message
          } else {
            this.propertyNoRepeat = false;
            // 利嘉阁中原账户  从A+ 获取公司信息
            if (this.conditions || this.$route.query.email) {
              this.getConditions(data);
            }
          }
        });
    },
    /**金额提示*/
    Unit(type, price) {
      // this.isReducePrice()
      if(this.mode == 'edit'){
        let typePrice = ''
        let firstval =''
        let isShowReduce = ''
        let val= ''
        if(type == 'sale'){
          typePrice = 'salePrice'
          firstval = 'firstPaidSalePrice'
          isShowReduce = 'isReducePaid'
          val ='isReducePaidSalePrice'
        }else{
          firstval = 'firstRentPrice'
          isShowReduce = 'rentReducePrice'
          val ='isReduceRentPrice'
          typePrice = 'rentPrice'
        }
        this.isShowReaduce(typePrice,firstval,isShowReduce,val)
      }
      if(this.mode == 'post' || this.mode == 'copy'){
        // 价格改变 更新图表数据
        if(this.propertyInfo.propertyCategory == 1 && ((this.chartEstateID && this.addressSearch) || (this.chartScopeCode && !this.addressSearch))){
          this.isPassPriceChart().then(suc=>{
            if(this.addressSearch){
              this.changePriceChart('chartOne',suc)
              this.changePriceChart('chartTwo',suc)
            }else{
              this.changePriceChart('chartOne',suc)
            }
          })
        }
      }
      price = Number(price);
      if (type === 'sale') {price = price * 10000;}
      if(type === 'sale' && (this.mode == 'post' || this.mode == 'copy') &&(this.companyCategory == 3 || (this.companyCategory != 3 && !this.propertyInfo.propertyCategory == 1 && !this.propertyInfo.propertyCategory == 2))){
      // 车位超过1kw 或其余类型超过十亿提示
       let showPriceTip = (this.propertyInfo.propertyCategory == 4 && price >= 10000000) || price >= 1000000000 ? true : false 
       if(showPriceTip ){
         this.$confirm(`目前售價為${this.propertyInfo.propertyCategory == 4 ? (price >= 100000000?(price / 100000000).toFixed(2)+'億元':(price / 10000)+'萬元'):(price / 100000000).toFixed(2)+'億元'}, 請確認或更改你的售價`, '提示', {
           confirmButtonText: '確認',
           cancelButtonText: '更改',
           closeOnClickModal: false,
           type: 'warning'
         }).then(() => {}).catch(() => {
           this.$refs.elsalePrice.focus()
         })
       }
      }
      
      if (this.companyCategory != 3 && price >= 100000000 && type === 'sale' && (this.propertyInfo.propertyCategory == 1 || this.propertyInfo.propertyCategory == 2)) {
        this.$message({
          message: `你的樓盤放售價是${(price / 100000000).toFixed(2)}億元`,
          showClose: true,
          offset: document.body.clientHeight / 2
        });
      }
      if (this.companyCategory != 3 && price >= 100000000 && type === 'rent') {
        this.$message({
          message: `你的樓盤放租價是${(price / 100000000).toFixed(2)}億元`,
          showClose: true,
          offset: document.body.clientHeight / 2
        });
      }
      
       // 价格超过30%提醒
       if (this.companyCategory == 3 && this.mode !== 'copy' && this.mode !== 'post' && type === 'sale' && (price <= (this.orignprice - this.orignprice * 0.3) || price >= (this.orignprice + this.orignprice * 0.3))) {
        this.$alert('請確認售價是否正確', '你所輸入的售價與原本的有很大的差距', {
          confirmButtonText: '知道了',
          showClose: false
        });
      }
      if (this.companyCategory == 3 && this.mode !== 'copy' && this.mode !== 'post' && type === 'rent' && (price <= (this.orignrprice - this.orignrprice * 0.3) || price >= (this.orignrprice + this.orignrprice * 0.3))) {
        this.$alert('請確認租價是否正確', '你所輸入的租價與原本的有很大的差距', {
          confirmButtonText: '知道了',
          showClose: false
        });
      }
    },
    //楼龄限制在199以内
    limitAgeRange(){
      this.propertyInfo.buildingAge = this.propertyInfo.buildingAge > 199 ? 199: this.propertyInfo.buildingAge
    },
    /** 只允许输入数字*/
    onlyNumber(value, key) {
      if (!key) {
        return value.replace(/[^\d]/g, '');
      }
      this.propertyInfo[key] = value.replace(/[^\d]/g, '');
      this.$forceUpdate()
    },
    delCurPic(i, v){
      this.isDeleting = true;
      let delImages = JSON.parse(JSON.stringify(this.images));
      try {
        delImages.splice(i, 1)
        this.images = JSON.parse(JSON.stringify(delImages)); 
        this.file.splice(i, 1);
        this.pushCache().finally(() => {
            this.isDeleting = false;
        });
        /**重新记录中原利嘉阁选中图*/
        this.selList = [];
        this.images.forEach(item => {
          this.selList.push(item.imagePath);
        });
      } catch (error) {
        this.isDeleting = false;
      }
    },
    changeDefaultImg(currentIndex){
      this.modifyDefaulting = true
      try {
        if(this.images[currentIndex].isDefault){
          this.defaultImgTip =false
        }
        // 设置其余项为非默认
        this.images.forEach((item, index) => {
          if (index !== currentIndex && this.images[currentIndex].isDefault) {
            item.isDefault = false; 
          }
        });
        this.pushCache().finally(() => {
          this.modifyDefaulting = false;
        });
      } catch (error) {
        this.modifyDefaulting = false;
      }
    },
    /** 图片交换位置 向下 */
    goNext(i, v) {
      if (i + 1 === this.images.length) {
        return;
      }
      let temp = this.images[i + 1];
      this.$set(this.images, i, temp);
      this.$set(this.images, i + 1, v);
      this.pushCache();
      // this.sendSocket();
      //   this.images[i + 1] = v
      //   this.images[i] = temp;
      //   console.log(this.images[i + 1])
    },
    /** 图片交换位置 向上 */
    goTop(i, v) {
      if (i === 0) {
        return;
      }
      let temp = this.images[i - 1];
      this.$set(this.images, i - 1, v);
      this.$set(this.images, i, temp);
      this.pushCache();
      // this.sendSocket();
    },
    warning(info) {
      this.$message({
        showClose: true,
        message: info,
        type: 'warning',
        offset: document.body.clientHeight / 2
      });
    },
    success(info) {
      this.$message({
        showClose: true,
        message: info,
        type: 'success',
        offset: document.body.clientHeight / 2
      });
    },
    error(info) {
      this.$message({
        showClose: true,
        message: info,
        type: 'error',
        offset: document.body.clientHeight / 2
      });
    },

    /** 保存到草稿箱 获取draftid*/
    async addDraft(type) {
      /**需求：
       * 因socket断链导致的图片丢失问题，做出相关修改，图片存入草稿箱，刷新后用户可选择是否覆盖以回显。
       * qrcode的id更换。
       * 
      */
      return new Promise(async (resolve, reject) => {
        // if (this.propertyInfo.estateName === undefined || this.propertyInfo.estateName === ""){
        //   resolve()
        //   return
        // }
        // this.dataFormat('post');
        try {
          // // if(this.mode != 'copy'){
            this.dataFormat('post');
          // // }
        } catch (e) {
          console.log('数据格式化出错');
        }
        delete this.preData.propertyUserInfo
        if (this.preData.subCategory && (this.preData.subCategory.includes('6') ||this.preData.subCategory.includes('7')||this.preData.subCategory.includes(6) || this.preData.subCategory.includes(7))) {
          delete this.preData.salePrice
          delete this.preData.saleForm
        }
        if((this.preData.subCategory && !this.preData.subCategory.includes('11') && !this.preData.subCategory.includes(11) && !this.preData.subCategory.includes('8') && !this.preData.subCategory.includes(8) && this.propertyInfo.propertyCategory ==1) || ( this.propertyInfo.propertyCategory =='4')){
          this.preData.isVerifyArea = true
        }
        let data = {
          ...this.preData,
          videos: this.videos,
          images: [...this.images]
        }
        await this.axios.post(this.pub.getApi().AddPropertyDraft, data)
        if(type == 'acquireId'){
          let draftres = await this.axios.post(this.pub.getApi().SearchPropertyDraft, {
              pageCount:1,
              pageIndex:1
          })
          this.propertyInfo.draftID = draftres.data.result.data[0].draftID 
          if(this.mode != 'edit'){
            this.identification = this.propertyInfo.draftID;
          }
          sessionStorage.setItem("refreshID",this.propertyInfo.draftID)
          // 刊登，复制时，qrcode的链接唯一标识id为草稿箱id ,修改时的id为楼盘id
          if(this.mode == 'post' || this.mode == 'copy'){
            this.$nextTick(function () {
              if (!this.$refs.qrCodeDiv.hasChildNodes()) {
                this.createQRCode();
              }
            });
          }
          if(this.exeMesInter){
            this.exeMesInter = false
            // 刷新后进入的页面  先get可以在移动端上传图片存在未完成情况下,刷新pc页面，获取移动端图片。
            // 修改或复制初次进入页面时， 需要先将fullbyid返回的图片进行push。避免直接进行get时，会将图片清空。
            // draftidhk想要达成草稿箱wap端上传图片后，pc没有显示退出页面，pc端下次进入该草稿，仍然可以回显上次传好的图片
            if(sessionStorage.getItem('refreshpro') == 'true' || this.$route.query.draftID){
              await this.getCache()
            }
            if((this.mode == 'post' || this.mode == 'copy' || this.mode == 'edit') && this.images && this.images.length){
              await this.pushCache()
            }
            this.messageTimer = setInterval(() => {
              this.getCache()
            }, 10000);
          }
        }
        if(type == 'historyBack'){
          this.$router.push({
            name: this.pub.routeNameLists.PropertyIndex,
            params: this.$route.params
          });
        } 
        resolve()
      })      
    },
    /** 根据状态码提示对应文字*/
    statusCode(res) {
      if (!res || res.data.code == 0) {
        return;
      }
      if (res.data.code == 1202) {
        this.error('刊登樓盤異常');
      } else if (res.data.code == 1207) {
        this.error(res.data.message);
      } else if (res.data.code == 1707) {
        return this.$alert(`付款失敗，你的訂單將保存${this.expireTimeCulture}，充值後可前往訂單管理付款`, `${this.propertyInfo.topType == 0 ? '金幣' : '鑽石'}餘額不足`, {
          confirmButtonText: '確認',
          callback: action => {
            this.$router.push('index');
          }
        });
      } else if (res.data.code == 400) {
        this.error('參數錯誤');
      }else if(res.data.message){
        this.error(res.data.message);
      }
      this.disablePost = false;
    },
    /*通过url转化为file对象
    getFile(url) {
        return new Promise((resolve, reject) => {
            var image = new Image();
            image.src = url;
            image.setAttribute('crossOrigin', 'Anonymous');
            image.onload = function() {
                // 转换为base64
                var canvas = document.createElement('canvas');
                canvas.width = image.width;
                canvas.height = image.height;
                var ctx = canvas.getContext('2d');
                ctx.drawImage(image, 0, 0, image.width, image.height);
                var ext = image.src.substring(image.src.lastIndexOf('.') + 1).toLowerCase();
                var base64 = canvas.toDataURL('image/' + ext);

                //转换base64到file
                const dataArr = base64.split(',');
                const byteString = atob(dataArr[1]);
                const options = {
                    type: 'image/jpeg',
                    endings: 'native'
                };
                const u8Arr = new Uint8Array(byteString.length);
                for (let i = 0; i < byteString.length; i++) {
                    u8Arr[i] = byteString.charCodeAt(i);
                }
                let file = new File([u8Arr], 'test' + '.jpg', options);
                resolve(file);
            };
        });
    },*/
    async sendData() {
      this.disablePost = true;/*刊登按钮禁用*/
      this.tip = false; /*关闭对话框，并且判断是否含有敏感词, 刊登前要判断防止有草稿箱或者历史数据*/
      try {
        this.dataFormat('post');
      } catch (e) {
        console.log('数据格式化出错');
      }
      // 刊登和复制的付款逻辑
      let postAutoRecId = {}
      // if (this.mode === 'post' || this.mode === 'copy') {
      //   let res1 = await this.AddProperty();
      //   postAutoRecId = res1
      //   if (res1 && res1.data.code == 0) {
      //     // 自动置顶与刊登楼盘 是两个订单 所以需要查两次,付两次
      //     var res2 = await this.getOrder(res1.data.result);
      //     if(this.propertyInfo.isAutoRecommend){
      //       var resRec = await this.getOrder(res1.data.result,'autoRecommend');
      //     }
      //     this.expireTimeCulture = res2.data.result.data[0].expireTimeCulture;
      //   } else {
      //     this.statusCode(res1);
      //     return
      //   }
      //   if(this.propertyInfo.isAutoRecommend && resRec && resRec.data.code == 0 && resRec.data.result.data[0].orderID ){
      //     this.OrderPay(resRec.data.result.data[0].orderID)
      //   }
      //   if (res2 && res2.data.code == 0 && res2.data.result.data[0].orderID) {
      //     /*3 1  精选和钻石需用钻石支付  0 标准用金币支付*/
      //     var res3;
      //     //  if (this.propertyInfo.paymentType === 3) {
      //     //   res3 = await this.StarPay(res2.data.result.data[0].orderID);
      //     // } else if (this.propertyInfo.paymentType === 0)  {
      //     //   res3 = await this.CoinPay(res2.data.result.data[0].orderID);
      //     // }
      //     res3 = await this.OrderPay(res2.data.result.data[0].orderID);
      //     // if (this.propertyInfo.topType == 3 || this.propertyInfo.topType == 1) {
      //     //   res3 = await this.StarPay(res2.data.result.data[0].orderID);
      //     // } else {
      //     //   res3 = await this.CoinPay(res2.data.result.data[0].orderID);
      //     // }

      //   }
      //   if (res3 && res3.data.code == 0) {
      //     if (this.propertyInfo.topType == 3) {
      //       this.success('放盤成功，星級盤參考排名將於稍後更新');
      //     } else {
      //       this.success('放盤成功');
      //     }
      //   } else {
      //     return this.statusCode(res3);
      //   }
      // }
      if (this.mode === 'post' || this.mode === 'copy') {
        let res1 = await this.AddProperty();
        postAutoRecId = res1
        if (res1 && res1.data.code == 0) {
          if (this.propertyInfo.topType == 3) {
            this.success('放盤成功，星級盤參考排名將於稍後更新');
          } else {
            this.success('放盤成功');
          }
        } else {
          return this.statusCode(res1);
        }
      } else if (this.mode === 'edit') {
        this.dataFormat('post');
        /**
          * 如1写法,会导致提交验证文件框刚弹出,就直接跳转property/index
         * 1if (this.verifyUpdate){}else{this.UpdateProperty()}
         * 如下写法:如要修改验证文件时候,会导致报错asyncdata 是因为执行了verifyJudge,返回的非promise导致
         * 并没有执行到最后的 return的promise 
         * */
        let res1 = await this.UpdateProperty();
        if (res1.data.code === 0 && res1.data.result) {
          this.success('更改成功');
        } else {
          this.statusCode(res1);
          return;
        }

        // 续期
      } else if (this.mode === '2') {
        this.dataFormat('post');
        let res1 = await this.UpdateProperty();
        this.statusCode(res1);
        let res2 = await this.CreatePropertyOrder();
        this.statusCode(res2);
        // if (this.propertyInfo.paymentType === 3) {
        //   var res3 = await this.StarPay(res2.data.result);
        // } else if (this.propertyInfo.paymentType === 0)  {
        //   var res3 = await this.CoinPay(res2.data.result);
        // }
        res3 = await this.OrderPay(res2.data.result);

        // if (this.propertyInfo.topType == 3 || this.propertyInfo.topType == 1) {
        //   var res3 = await this.StarPay(res2.data.result);
        // } else {
        //   var res3 = await this.CoinPay(res2.data.result);
        // }
        if (res3.data.code == 0) {
          if (this.propertyInfo.topType == 3) {
            this.success('放盤成功，星級盤參考排名將於稍後更新');
          } else {
            this.success('放盤成功');
          }
        } else {
          this.statusCode(res3);
          return
        }
        // 立即付款
      } else if (this.mode === '1') {
        // 立即付款 或 缺少老数据需补回必填项 的立即付款数据
        let res1 = await this.getOrder(this.propertyId);
        if (res1.data.result.data.length === 0) {
          /**放盘查询订单如果为空，创建一个订单 在支付*/
          var resChild1 = await this.CreatePropertyOrder();
          if (resChild1.data.result) {
            // if (this.propertyInfo.paymentType === 3) {
            //   var resChild2 = await this.StarPay(resChild1.data.result);
            // } else if (this.propertyInfo.paymentType === 0)  {
            //   var resChild2 = await this.CoinPay(resChild1.data.result);
            // }
            var resChild2 = await this.OrderPay(resChild1.data.result);
            // if (this.propertyInfo.topType == 3 || this.propertyInfo.topType == 1) {
            //   var resChild2 = await this.StarPay(resChild1.data.result);
            // } else {
            //   var resChild2 = await this.CoinPay(resChild1.data.result);
            // }
          }
          if (resChild2.data.code == 0) {
            if (this.propertyInfo.topType == 3) {
              this.success('放盤成功，星級盤參考排名將於稍後更新');
            } else {
              this.success('放盤成功');
            }
          } else {
            this.statusCode(resChild2);
            this.expireTimeCulture = resChild2.data.result.data[0].expireTimeCulture;
          }
        } else {
          /*如果能查到订单  判断是如果是标准盘或星级盘  标准盘==》金币付款  其余==》钻石付款*/
          // if (this.propertyInfo.paymentType === 3) {
          //   var res2 = await this.StarPay(res1.data.result.data[0].orderID);
          // } else if (this.propertyInfo.paymentType === 0)  {
          //   var res2 = await this.CoinPay(res1.data.result.data[0].orderID);
          // }
          var res2 = await this.OrderPay(res1.data.result.data[0].orderID);

          // if (this.propertyInfo.topType == 3 || this.propertyInfo.topType == 1) {
          //   var res2 = await this.StarPay(res1.data.result.data[0].orderID);
          // } else {
          //   var res2 = await this.CoinPay(res1.data.result.data[0].orderID); //根据订单id进行金幣支付
          // }
          if (res2.data.code == 0) {
            if (this.propertyInfo.topType == 3) {
              this.success('放盤成功，星級盤參考排名將於稍後更新');
            } else {
              this.success('放盤成功');
            }
          } else {
            this.statusCode(res2);
            return
          }
        }
      }
      /*跳转到列表页*/
      setTimeout(() => {
        if (this.$route.query.backUrl) {
          this.postNext = false
          this.$router.push(this.$route.query.backUrl);
        } else {
          // goonStep
          if (this.mode === 'edit' && this.formSource) {
            this.butFormSource = true
            if(this.$route.query.gradeRule == 'starValidate'){
              this.upgradeDiaStep = true
            }else{
              this.$router.push({
                name: this.pub.routeNameLists.PropertyIndex,
                params: this.$route.params
              });
            }
          } else {
            this.postNext = false
            if(this.propertyInfo.isAutoRecommend && Object.keys(postAutoRecId).length &&  postAutoRecId.data.code == 0){
              this.$router.push({
                name: this.pub.routeNameLists.PropertyIndex,
                params: {
                  autoRecId:postAutoRecId.data.result
                }
              });
            }else{
              this.$router.push('index');
            }
          }
        }
        //发送标识code：0 告知wap端扫码结束
        // if (this.scoket) {
        //   this.scoket.invoke('SendMessage', JSON.stringify({ code: 0 }));
        // }
      }, 2000);
    },
    // 升级楼盘成功后 确认 跳转
    goonStep(){
      this.upgradeDiaStep = false
      this.$router.push({
        name: this.pub.routeNameLists.PropertyIndex,
        params: this.$route.params
      });
    },
    /** 代理特别服务点击事件*/
    specialServe(value,type, index) {
      this.$set(this.propertyUserInfo[index], type, !value);
      if(type == 'isShowPmsCompanyTel'){
        this.$set(this.propertyUserInfo[index], 'isHideCompanyTel',  value);
      }
      if(type == 'isUpdateCompanyInfo' && !this.propertyUserInfo[index].isUpdateCompanyInfo){
        if(this.mode == 'edit'){
          // 修改楼盘模式下，取消勾选，复原为agent原资料
          this.$set(this.propertyUserInfo[index], 'companyNameCN', this.editAgentList[index].companyNameCN);
          this.$set(this.propertyUserInfo[index], 'companyNameEN', this.editAgentList[index].companyNameEN);
          this.$set(this.propertyUserInfo[index], 'companyLicenceNumber', this.editAgentList[index].companyLicenceNumber);
          this.$set(this.propertyUserInfo[index], 'companyAddress', this.editAgentList[index].companyAddress);
          this.$set(this.propertyUserInfo[index], 'companyAddressEN', this.editAgentList[index].companyAddressEN);
          this.$set(this.propertyUserInfo[index], 'companyTel', this.editAgentList[index].companyTel);
        }else{
          // 非修改楼盘模式下，复原为修改前
          this.$set(this.propertyUserInfo[index], 'companyNameCN', this.editcompanyUserInfo[index].companyNameCN);
          this.$set(this.propertyUserInfo[index], 'companyNameEN', this.editcompanyUserInfo[index].companyNameEN);
          this.$set(this.propertyUserInfo[index], 'companyLicenceNumber', this.editcompanyUserInfo[index].companyLicenceNumber);
          this.$set(this.propertyUserInfo[index], 'companyAddress', this.editcompanyUserInfo[index].companyAddress);
          this.$set(this.propertyUserInfo[index], 'companyAddressEN', this.editcompanyUserInfo[index].companyAddressEN);
          this.$set(this.propertyUserInfo[index], 'companyTel', this.editcompanyUserInfo[index].companyTel);
        }
        // this.$set(this.propertyUserInfo[index], 'isHideCompanyTel', false);
      }
      this.propertyUserInfo.splice();
    },
    inputlicenceNum(value,type, index){
      this.$forceUpdate()
      // let telephone = value.replace(/[^\d]/g, '').substring(0, 8)
      let telephone = value.substring(0, 8)
      this.$set(this.propertyUserInfo[index], type, telephone);
    },

    /** 其他選項禁用 服務式住宅 商務中心只能二选一*/
    disRentLabel(item) {
      let result = (this.propertyInfo.rentLabel && this.propertyInfo.rentLabel.length && this.propertyInfo.rentLabel.includes('5') && item.dictionaryValue === '6') || (this.propertyInfo.rentLabel && this.propertyInfo.rentLabel.length && this.propertyInfo.rentLabel.includes('6') && item.dictionaryValue === '5');
      return Boolean(result);
    },
    /** 分类禁用 公屋居屋只能二选一*/
    // diSubcate (citem) {
    //   let result = this.propertyInfo.subCategory.length && this.propertyInfo.subCategory.includes('6') && citem.dictionaryValue === '7' || this.propertyInfo.subCategory.length && this.propertyInfo.subCategory.includes('7') && citem.dictionaryValue === '6'
    //   return Boolean(result)
    // },
    /** 搜索房源服务价格*/
    SearchPropertyPriceSet() {
      return new Promise((suc,err)=>{
        this.axios.get(this.pub.getApi().GetCompanyPropertyPriceSet).then((res)=>{
          if (res.data.code === 0 && res.data.result) {
            res.data.result.forEach(item => {
              this.diConfig[item.itemName] = item
            });
            suc()
          }
        })
      })
      // this.axios.get(this.pub.getApi().SearchPropertyPriceSet).then(res => {
      //   if (res.data.code === 0 && res.data.result) {
      //     res.data.result.forEach(item => {
      //       this.diConfig[item.itemName] = item
      //     });
      //     if (this.propertyInfo.rentalType == 2) {
      //       this.diConfig.Star = this.diConfig.Star_Rent
      //     } else {
      //       this.diConfig.Star = this.diConfig.Star_Buy
      //     }
      //     this.diConfig.StarSale = this.diConfig.Star_Buy
      //     this.diConfig.StarRent = this.diConfig.Star_Rent
      //   }
      // });
    },
    /** 获取正在使用中楼盘数量*/
    GetPropertyCount() {
      this.axios.get(this.pub.getApi().GetPropertyCount).then(res => {
        if (res.data.code === 0 && res.data.result) {
          this.diConfig.properUsing = res.data.result;
        }
      });
    },
    /** 获取用户信息拿到金幣数量*/
    GetUserInfo() {
      return this.axios.get(this.pub.getApi().GetUserInfo);
    },
    /** 获取地区*/
    GetGscope() {
      return this.axios.get(this.pub.getApi().GetGscope);
    },
    GetDisSub(){
      return this.axios.get(this.pub.getApi().GetPropertySubCategoryNotAllow)
    },
    /** 获取字典 */
    getDictionary() {
      return this.pub.getDictionary();
    },
    quitPay() {
      this.tip = false;
      this.disablePost = false;
    },
    // 取消更改
    removeEdit() {
      this.$confirm('如果你在頁面上有進行過修改，離開當前頁面會導致所做的修改將丟失', '提示', {
        confirmButtonText: '確認',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        this.butFormSource = true
        this.$router.push({
          name: this.pub.routeNameLists.PropertyIndex,
          params: this.$route.params
        });
      }).catch(() => { })
    },
    goOnEdit(){
      if (this.propertyInfo.topType !== '3' && this.companyCategory == 3 && this.showScoreAgain && this.adRank) {
        this.dataFormat('post');
        let data = {
          ...this.preData,
          videos: this.videos,
          PropertyUserInfo: [...this.preUserData],
          images: [...this.images]
        };
        this.judgeScore(data)
      } else {
        this.sendData();
      }
    },
    scrollImg(){
      const targetDiv = document.querySelector('.pic');
      if (targetDiv) {
          targetDiv.scrollIntoView({ 
              behavior: 'smooth',
              block: 'start'
          });
      }
      this.imgwarning = false
    },
    imgValidation(){
      // 图片未上传完成 仍继续刊登
      this.imgUploadPass = true
      this.imgwarning = false
      for (let i = this.images.length - 1; i >= 0; i--) {
        if (!this.images[i].imagePath || this.images[i].imagePath === '') {
          this.images.splice(i, 1);
        }
      }

      this.validation('propertyInfo')
    },
    /** 立即放盘 点击事件 */
    validation(formName) {
      this.$refs[formName].validate(async (valid,errobj) => {
        // if (this.conditions) {
        //   if (this.mode == 'post' && !this.disCoin && this.totalPrice > this.remainderPropertyCoin) {
        //     return this.error('金幣餘額不足，放盤失敗');
        //   }
        // }
        // 中原优惠券没有支持的放盘方式
        if(this.fromZy && this.propertyInfo.topType == '100' ){
          return this.error("請選擇放盤方式")
        }
        if(this.propertyInfo.propertyCategory && this.addressSearch && !this.propertyInfo.estateID ){
          return this.error("請填寫屋苑或大廈名稱(中文)")
        }
        // 手动报错弹出在组件表单报错之后
        if(Object.keys(errobj).length === 0){
          if(this.addressSearch && !this.propertyInfo.estateID ){
            return this.error("請填寫屋苑或大廈名稱(中文)")
          }
          // 240905 线上出现 选单模式但无gscodecode数据楼盘 补丁
          if (this.mode == 'post' && !this.addressSearch && !this.propertyInfo.estateID && (!this.propertyInfo.gscopeFaCode || !this.propertyInfo.gscopeCode)) {
            return this.error('請選擇屋苑所在地區');
          } 
          if(this.propertyInfo.paymentType !== 0 && this.propertyInfo.paymentType !== 3 && !this.isDisCoupon && (this.mode =='post' || this.mode =='copy')){
            this.payWayEmpy = true
            return this.error('請選擇付款方式');
          }
          if (this.agent.length === 0 || this.draftlen === true) {
            this.isEmpty_agent = true;
            return this.error('必須揀選一位代理人');
          }
          // 代理人中 必填项需要填写校验 
          if(this.agent.length){
            for (let i = 0; i < this.agent.length; i++) {
             if(typeof this.agent[i] == 'string' && this.agent[i].indexOf("已停用") !== -1){
               this.isdis_agent = true;
               return this.error('請選擇其他代理人');
             }
           }
          }
          let err = this.validaCustom()
          if (err) {return}
        }
      //  if(this.propertyUserInfo.length){
      //    for (let i = 0; i < this.propertyUserInfo.length; i++) {
      //     if(this.propertyUserInfo[i].isUpdateCompanyInfo && !this.propertyUserInfo[i].isHideCompanyInfo ){
      //       if(!this.propertyUserInfo[i].companyNameCN || !this.propertyUserInfo[i].companyLicenceNumber){
      //         return this.error('樓盤資料不完整，請根據提示補充資料');
      //       }
      //     }
      //   }
      // }
        if (this.propertyNoRepeat && this.propertyInfo.propertyNo) {
          //已经达到三次刊登上限提示物业编号已存在
          if (this.promptinfo) {
            return this.error(this.promptinfo)
          } 
            return this.error('物業編號已存在');
          
        }
        for (let key in this.hasSenWrods) {
          if (this.hasSenWrods[key]) {
            return this.error('內容不符合會員條款無法刊登');
          }
        }
        let res = await this.axios.post(this.pub.getApi().GetKeyword, { keywords: [this.propertyInfo.titleCN, this.propertyInfo.titleEN, this.propertyInfo.introduceCN, this.propertyInfo.introduceEN,this.propertyInfo.servicesCN,this.propertyInfo.servicesEN] });
        if (res.data.code == 0 && res.data.result) {
          return this.error('內容不符合會員條款無法刊登');
        }
        // this.validatePass = valid
        if (valid) {
          if (this.images.length != 0 && !this.imgUploadPass) {
            this.imgwarning = false
            const nonSuccessImages = this.images.filter(ele => ele.status !== 'success' && !ele.imagePath);
            this.nonSuccessCount = nonSuccessImages.length;
            this.imgwarning = this.nonSuccessCount > 0;
  
            if (this.imgwarning) {return}
          }
          if (this.mode === 'edit') {
            this.showComNo = false
            let breakloop = true
            Object.keys(this.compareNo).forEach(key => {
              if (key in this.propertyInfo) {
                if(this.propertyInfo[key] != this.compareNo[key] && ( this.propertyInfo[key] || this.compareNo[key])){
                  if(key == 'propertyNo' || (key == 'roomNumber' && !this.compareNo[key])){
                    // 当物业编号修改过 或 房數由無變有时  提示弹框不弹出
                    this.showComNo = false;
                    breakloop = false
                  }else if(breakloop){
                    this.showComNo = true
                  }
                }
              }
            });
            this.validatePass = !this.showComNo
            if(this.errlogCount > 0){
              let errData = {
                'type':'web-imgUpload-dialog_errcount',
                'msg':this.errlogCount
              }
              this.axios.post(this.pub.getApi().PushException,errData);
            }
            if(this.showComNo){
              this.$confirm( '<div style="white-space: pre-wrap;">樓盤地址資料有修改，未修改物業編號\n是否確認繼續提交？</div>','提示', {
                confirmButtonText: '確認',
                cancelButtonText: '更改',
                closeOnClickModal: false,
                distinguishCancelAndClose:true,
                dangerouslyUseHTMLString: true,
                type: 'warning'
              }).then(async () => {
                this.butFormSource = true
                this.goOnEdit()
              }).catch(action => {
                if(action == 'cancel'){
                  let main = document.querySelector('.el-main');
                  main.scroll({
                    top: 0,
                    left: 0,
                  });
                  this.$refs.propertyNo.focus()
                }
              })
            }

            if(this.showComNo){return;}
            // this.sendData();
            this.goOnEdit()
            
          } else {
            if(this.errlogCount > 0){
              let errData = {
                'type':'web-imgUpload-dialog_errcount',
                'msg':this.errlogCount
              }
              this.axios.post(this.pub.getApi().PushException,errData);
            }
            // 判斷是否需要彈出分數框 星级盘与中原利嘉阁不需要弹出 管理后台配置弹出
            if (this.propertyInfo.topType !== '3' && this.companyCategory == 3 && this.showScoreAgain && this.adRank) {
              this.dataFormat('post');
              let data = {
                ...this.preData,
                videos: this.videos,
                PropertyUserInfo: [...this.preUserData],
                images: [...this.images]
              };
              this.judgeScore(data)
            } else {
              if(this.propertyInfo.isAutoRecommend){
                this.autoRecBalance()
              }else{
                this.disConfirm = false
              }
              this.tip = true;
            }
          }
        } else {
          let fail = [];
          for (let key in errobj) {
            fail.push(errobj[key][0].message);
          }
          // let result = fail.map(item => item).join('<br/>');
          this.error(`${fail[0]}`);
         
          // this.error('樓盤資料不完整，請根據提示補充資料');
          return false;
        }
      });
    },
    autoRecBalance(){
      let postDia = this.propertyInfo.paymentType === 3 && !this.isDisCoupon ? this.recAutoDia + this.restMoney : this.recAutoDia
       if(postDia > this.remainderDiamond){
        this.disConfirm = true
       }else{
        this.disConfirm = false
       }
      
    },
    // 刊登,复制,过期续期 - 弹出等级分数提示框判断
    judgeScore(data) {
      this.axios.post(this.pub.getApi().PropertyScore, data).then(res => {
        if (res.data.code == 0 && res.data.result.score < 251) {
          this.postScoreVisible = true
          let { result } = res.data;
          this.postScore.scoreAdRank = result.adRankWithCulture
          this.postScore.scoreReason = result.reason
          this.postScore.score = result.score
          this.postScore.scoreStar = result.star
        } else {
          // 滿分情況直接刊登
          if (this.mode == 'edit') {
            // 修改楼盘 判断是否需要重新提交楼盘验证
            this.sendData()
          } else {
            // 开启自动置顶后,判断钻石是否足够置顶,不够按钮禁用
            if(this.propertyInfo.isAutoRecommend){
              this.autoRecBalance()
            }else{
              this.disConfirm = false
            }
            this.tip = true;
          }
        }
      })
    },
    quitSub() {
      this.postScoreVisible = false
      this.disablePost = false
      this.showScoreAgain = false
    },
    // 分數框 之 繼續放盤
    goonSub() {
      this.postScoreVisible = false
      this.showScoreAgain = false
      if (this.mode == 'edit') {
        // 編輯時繼續要判斷是否要上傳驗證文件
        this.$confirm('確認提交樓盤資料', '提示', {
          confirmButtonText: '確認',
          cancelButtonText: '取消',
          customClass: 'postMes',
          type: 'warning'
        }).then(() => {
          this.verifyUpdate = true
          this.sendData()
        }).catch(() => {
          // 取消修改楼盘 提交中=>提交
          this.disablePost = false;
        })
        // this.sendData()
      } else {
        if(this.propertyInfo.isAutoRecommend){
          this.autoRecBalance()
        }else{
          this.disConfirm = false
        }
        this.tip = true;
      }
      // this.goPost = true
    },
    /** 新增房源 */
    AddProperty() {
      return new Promise((suc, reject) => {
        /**如果当前不允许放精选盘 强制修改topTop为标准盘*/
        // if (this.preData.topType == 1 && this.isProhibitPublishGoldTop) {
        //   this.preData.topType = '0';
        // }
        if (this.videos && this.videos[0].videoPath == "" && this.goPost) {
          // this.videos[0].defaultImagePath=""
          this.videos = null
          // this.videos=[{}]
        }
        // 后台根据saleForm判断新老版本(修改或复制 后台会自动将saleForm重新传回) 为避免新版本出现问题 故需saleForm删除
        if (this.preData.subCategory && (this.preData.subCategory.includes('6') ||this.preData.subCategory.includes('7') ||this.preData.subCategory.includes(6) ||this.preData.subCategory.includes(7))) {
          delete this.preData.salePrice
          delete this.preData.saleForm
        }
        if((this.preData.subCategory && !this.preData.subCategory.includes('11')&& !this.preData.subCategory.includes(11) &&  !this.preData.subCategory.includes('8') && !this.preData.subCategory.includes(8) && this.propertyInfo.propertyCategory ==1) || ( this.propertyInfo.propertyCategory =='4')){
          this.preData.isVerifyArea = true
        }
        let data = {
          ...this.preData,
          videos: this.videos,
          PropertyUserInfo: [...this.preUserData],
          images: [...this.images]
        };
        if (this.propertyInfo.topType == 0) {
          data.isVerify = false
        }
        if (!(this.bankVal && this.isShowBoc && this.propertyInfo.rentalType == 1) && this.propertyInfo.isBoc) {
          data.isBoc = false
        }     
        try {
          if(!data.hasOwnProperty('paymentType') && !this.isDisCoupon){
            let proType = this.propertyInfo.topType == '0' ? 'Normal' :this.propertyInfo.topType == '1'?'GoldTop':'Star'
            let coinRsDis = this.propertyInfo.rentalType == 1 ? 'enableCoinSalePrice':'enableCoinRentPrice'
            let diamondRsDis = this.propertyInfo.rentalType == 1 ? 'enableDiamondSalePrice':'enableDiamondRentPrice'
            if((!this.diConfig[proType][coinRsDis] && this.diConfig[proType][diamondRsDis] ) || (this.diConfig[proType][coinRsDis] && !this.diConfig[proType][diamondRsDis])){
              data.paymentType = this.diConfig[proType][coinRsDis] ? 0 : 3
            }
          }
        } catch (err) {}
        this.axios.post(this.pub.getApi().AddProperty, data, { timeout: 7000 })
          .then(res => {
            suc(res)
          })
          .catch((failed) => {
            if (failed.message.includes('timeout')) {
              this.disablePost = false
              this.warning('網絡連接不穩定，請再點擊「立即放盤」')
              reject(failed)
            }
          })
      })
    },
    // 驗證文件是否需要重新提交
    conVerify() {
      this.verifyVisible = false
      this.showVerifyAgain = false
      // 彈出另一個確認框
      // 1.確定 樓盤資料已更新 updateproperty 
      // 2.取消 就停留在刊登頁 是否要立即打開樓盤驗證文件彈窗，還是說用戶重頭操作一遍？？
      this.$confirm('確認提交樓盤資料', '提示', {
        confirmButtonText: '確認',
        cancelButtonText: '取消',
        customClass: 'postMes',
        type: 'warning'
      }).then(() => {
        this.verifyUpdate = true
        this.sendData()
      }).catch(() => {
        // 取消修改楼盘 提交中=>提交
        this.disablePost = false;
      })
    },
    closePostbut() {
      this.disablePost = false;
    },
    goonVeify() {
      this.verifyVisible = false
      this.showVerifyAgain = false
      // 彈出上傳驗證文件框
      this.attachVisible = true;
      this.showEditerror = false
    },
    // conVerifyImage() {
    //   // 编辑楼盘 必须上传了验证图片直接可以提交修改 
    //   if (this.mode == 'edit' && this.propertyInfo.verifyImage.length >= 1) {
    //     this.attachVisible = false
    //     this.verifyUpdate = true//上传了文件 不可以再次访问propertyverify接口
    //     this.sendData()
    //   } else if (this.mode == 'edit' && this.propertyInfo.verifyImage.length == 0) {
    //     this.showEditerror = true
    //   } else {
    //     this.attachVisible = false
    //   }
    // },
    // // 修改 是否重新填寫驗證文件
    // verifyJudge(data) {
    //   return this.axios.post(this.pub.getApi().PropertyVerify, data)
    // },
    /** 修改房源 */
    async UpdateProperty() {
      // && this.verifyUpdate
      if (this.videos && this.videos[0].videoPath == "") {
        // this.videos[0].defaultImagePath=''
        this.videos = null
      }
      if((this.preData.subCategory&&!this.preData.subCategory.includes('11')&&!this.preData.subCategory.includes(11)&&  !this.preData.subCategory.includes('8') && !this.preData.subCategory.includes(8) && this.propertyInfo.propertyCategory ==1) || ( this.propertyInfo.propertyCategory =='4')){
        this.preData.isVerifyArea = true
      }
      if (this.preData.subCategory && (this.preData.subCategory.includes('6') ||this.preData.subCategory.includes('7') || this.preData.subCategory.includes(6) ||this.preData.subCategory.includes(7))) {
        delete this.preData.salePrice
        delete this.preData.saleForm
      }
      let data = {
        ...this.preData,
        videos: this.videos,
        PropertyUserInfo: [...this.preUserData],
        images: [...this.images]
      };
      if (!(this.bankVal && this.isShowBoc && this.propertyInfo.rentalType == 1) && this.propertyInfo.isBoc) {
        data.isBoc = false
      }
      // 修改的楼盘需要符合 星级盘且有验证文件时候
      // if ((data.topType == 3 || data.topType == 1) && !this.verifyUpdate && (!data.verifyImage || data.verifyImage.length == 0)) {
      //   let res = await this.verifyJudge(data)
      //     this.disablePost = false
      //     if (this.showVerifyAgain && res.data.code == 0 && res.data.result) {
      //       this.verifyVisible = true
      //     } else {
      //       // 如果什么都没更改 就可以直接提交更该楼盘
      //       this.verifyUpdate = true
      //     }
      // }
      // if (this.verifyUpdate) 
      return this.axios.post(this.pub.getApi().UpdateProperty, data);
      // }

    },
    /** 获取订单 */
    getOrder(propertyID,type) {
      let data = {
        sourceID: propertyID,
        accountID: this.userInfo.accountID,
        sourceType: type ? type : 'property',
        orderStatus: 'notPaid',
        pageIndex: 1,
        pageCount: 10
      }
      return this.axios.post(this.pub.getApi().SearchOrderRecord, data);
    },
    OrderPay(orderId){
      return this.axios.post(this.pub.getApi().PaymentOrder, {orderId});
    },
    // /** 金幣支付 */
    // CoinPay(orderId) {
    //   return this.axios.post(this.pub.getApi().PropertyCoinPaymentOrder, {
    //     orderId
    //   });
    // },
    // /*钻石支付*/
    // StarPay(orderId) {
    //   return this.axios.post(this.pub.getApi().DiamondPaymentOrder, {
    //     orderId
    //   });
    // },
    /** 创建房源订单--续期 */
    CreatePropertyOrder() {
      return this.axios.post(this.pub.getApi().CreatePropertyOrder, {
        propertyId: this.propertyId,
        topType: this.propertyInfo.topType,
        isVerify: this.propertyInfo.isVerify,
        paymentType:this.propertyInfo.paymentType,
        verifyImage: this.propertyInfo.verifyImage
      });
    },
    handleEstateInput(val){
      if(val != this.originEstateName && !this.estateStep){
          this.estateZoneCode = ''
          this.estateGscopeCode = ''
      }
    },
    /** 搜索楼盘 */
    search(queryString, callback) {
      // 进入搜索筛选 清空id 避免用户没有选择直接提交刊登无报错问题
      if(this.originEstateName != '' && this.originEstateName != this.propertyInfo.estateName.trim()){
        // 屋苑名称修改了 清空id
        this.propertyInfo.estateID = ''
        this.estAdress.phaseEstates = [];
        this.estAdress.buildings = [];

        this.resetPhamore()
      }
      // 当屋苑置空的时候 楼盘类型不能有禁用
      if (!queryString && this.propertyInfo.estateName == '') {
        this.isShowChart = false
        if(!this.estateStep){
          this.estateZoneCode = ''
          this.estateGscopeCode = ''
        }
        this.showSubTxt = ''
        this.propertyInfo.subCategorySuggestText = ''
        this.resetPhamore()
        // this.cateFromEstate()
      }
      // if ((this.mode == 'edit') && !queryString && this.propertyInfo.estateName == '') {
      //   this.cateFromEstate()
      // }
      if (!queryString) {
        this.dynamicClass = ''
        callback([{value: '請輸入屋苑或大廈名稱' }]);
        return;
      }
      let zoneCode = []
      if(this.estateZoneCode){
        zoneCode.push(this.estateZoneCode)
      }else{
        zoneCode = []
      }
      this.axios
        .post(this.pub.getApi().SearchEstate, {
          keywords: queryString,
          zoneCode:zoneCode,
          pageIndex: 1,
          pageCount: 50,
          parentEstateId: 0,
          estateSrc: this.propertyInfo.propertyCategory
        })
        .then(res => {
          if (res.data.code === 0 && res.data.result) {
            this.estate = res.data.result.data;
            // for (let i of this.estate) {
            //   // zoneNameWithCulture 十八区地址
            //   // gscopeNameWithCulture 板块名
            //   let phaseWithCulture = i.phaseWithCulture ? i.phaseWithCulture : ''
            //   i.value = i.gscopeNameWithCulture + ' ' + i.estateNameWithCulture + ' ' + phaseWithCulture
            // }
            // this.estate = [{value}]
            this.dynamicClass = 'autolist'
            this.estate.sort((a, b) => {
              if (!a.phaseWithCulture && b.phaseWithCulture) {
                return -1;
              } else if (a.phaseWithCulture && !b.phaseWithCulture) {
                return 1;
              }
              return 0;
            }).map((item,index) => {
              const { gscopeNameWithCulture, estateNameWithCulture, phaseWithCulture } = item;
              item.value = gscopeNameWithCulture + ' ' + estateNameWithCulture + ' ' + (phaseWithCulture ? phaseWithCulture : '');
              return item;
            });

            // 存在autocompleteName，代表当前搜索为选择了地区后，进行的搜索 && this.autocompleteName
            if (!this.estate.length) {
              const noDataResponse = [{ value: '暫無數據' }];
              if (this.isEditMode) {
                noDataResponse.push({ id: -1, is_add: this.manualAdd, acc_title: '' });
              }
              callback(noDataResponse);
            } else {
              if (this.isEditMode) {
                this.estate.push({ id: -1, is_add: this.manualAdd, acc_title: '' });
              }
              callback(this.estate);
            }
          }
        });
    },
    /**获取楼盘信息对比 当前数据 是否可更改*/
    getEstate(item) {
      /**
       * 修改楼盘 没有期数使用estateID  选择过 期数使用parentid
       */
      this.axios
        .get(this.pub.getApi().GetEstate, {
          // params: { estateId: item.estateID }
          params: { estateId: this.mode == 'edit' && this.propertyInfo.phaseWithCulture ? this.propertyInfo.parentEstateID : item.estateID }
        })
        .then(res => {
          if (res.data.code === 0 && res.data.result) {
            this.EstateInfo = res.data.result;
            //* 编辑楼盘-期数可修改-中原李嘉格期数规则不变依然不可修改
            this.propertyInfo.estateType = this.EstateInfo.estateType;
            this.isCutomadded = this.EstateInfo.isCutomadded;
            if (this.propertyInfo.estateType === 'bigest') {
              let phaseID = this.mode == 'edit' && this.propertyInfo.phaseWithCulture ? this.propertyInfo.parentEstateID : this.propertyInfo.estateID
              this.getPhase(phaseID);
            }
          }
        });
      this.axios
        .post(this.pub.getApi().GetStationDuration, {
          estateID: item.estateID
        })
        .then(res => {
          this.subway = res.data.result
          this.changesubway()
          this.changeParkSubway()
        })
    },
    clearProInfo(){
      this.showClearDia = false
      // 修改楼盘屋苑名称 切换输入方式时
      this.$confirm('是否保留價錢，面積，標題，介紹，標籤，圖片，影片，VR的資料？', '提示', {
        confirmButtonText: '保留',
        cancelButtonText: '清空',
        showClose:false,
        closeOnClickModal: false,
        distinguishCancelAndClose:true,
        type: 'warning'
      }).then(async () => {
      }).catch(action => {
        if(action == 'cancel'){
          this.resetPropertyInfo()
        }
      })
    },
    resetPropertyInfo() {
      // 物业编号需置空--HOUSEMIS-2317改为屋苑名称更改时物业编号无须置空
      // this.propertyInfo.propertyNo = '';
      // this.propertyInfo.categoryNo = '';
      // this.$refs.propertyInfo.validateField('categoryNo');
      // this.$refs.propertyInfo.validateField('propertyNo');
      // 编辑时修改了屋苑 放盘资料需要置空
      this.propertyInfo.salePrice = ''
      this.propertyInfo.rentPrice = ''
      this.propertyInfo.unPaidSalePrice = ''
      this.propertyInfo.paidSalePrice = ''
      this.propertyInfo.saleableArea = ''
      this.propertyInfo.isForeclosure=false,
      this.propertyInfo.isShowForeclosureDesc=false,
      this.propertyInfo.buildingArea = ''
      this.propertyInfo.beginRentTime = ''
      this.propertyInfo.rentLabel = []
      this.propertyInfo.propertyManagementFee = ''
      // 放盘资料 
      if (this.Words.flag == 1 && this.BusinessWords.flag == 1) {
        this.Words.checkedTitle = []
      }
      if (this.Words.flag == 2 && this.BusinessWords.flag == 2) {
        this.Words.checkedIntr = []
      }
      if (this.Words.flag == 3 ) {
        this.Words.checkedIntr = []
      }
      this.propertyInfo.titleCN = ''
      this.propertyInfo.titleEN = ''
      this.propertyInfo.introduceCN = ''
      this.propertyInfo.introduceEN = ''
      // 楼盘标签
      this.selectedTags = []
      this.tagsChar = []
      this.tagsSce = []
      this.tagsRen = []
      this.tagsMat = []
      this.tagsBus = []
      this.tagsPark = []
      // 楼盘图片
      this.images = []
      this.selectedImage = [];
      this.imgQueue = {}
      this.curQueue = {}
      // 楼盘影片
      this.videos = [{ defaultImagePath: '', videoPath: "" }]
      this.isHidden = true
      // 楼盘vr
      if (this.isaddVR) {this.propertyInfo.addVR = ''}
      if (this.InputVR) {this.propertyInfo.inputVRURL = ''}
      // 备注
      this.propertyInfo.propertyRemark = ''
      // 楼盘平面图

    },
    //点击开启地区下拉框后，若关键字有值（代表起先输入了关键字，后开启地区），需要赋值propertyInfo.estateName，一起搜寻屋苑名称api
    handleVisibleChange(status){
      // if(this.autocompleteName){
      //   this.propertyInfo.estateName = this.autocompleteName
      // }
      if(!status){
        if(this.propertyInfo.estateName){
          // 调出搜索的下拉框
          this.$refs.autocomplete.activated = true
          // 将光标定位到输入框，方便失焦后调用cancelsearch清空相关数据
          this.$refs.autocomplete.focus()
          // 调用getData，等同 search 搜索屋苑事件调用
          this.$refs.autocomplete.getData(this.propertyInfo.estateName)
        }
        // else{
        //   this.cateFromEstate()
        // }
      }
    },
    changeZoneCode(type,step){
      this.estateStep = step
      this.resetPhamore('zonecode')
    },
    // 刊登修改屋苑名称置空
    resetPhamore(type) {
      // let recoverId = this.propertyInfo.parentEstateID ? this.propertyInfo.parentEstateID : this.propertyInfo.estateID
      let recoverId =  this.resetID
      this.propertyInfo.buildingType = ''
      this.propertyInfo.phaseWithCulture = ''
      this.propertyInfo.phaseEstateId = ''
      this.propertyInfo.parentEstateID = ''
      this.propertyInfo.buildingAge = ''
      // 选单模式下 切换楼盘类型需保留楼盘地址
      this.addressSearch ? this.propertyInfo.estateAddress = '':this.propertyInfo.estateAddress
      this.addressSearch ? this.propertyInfo.estateAddressEN = '':this.propertyInfo.estateAddressEN
      this.propertyInfo.buildingID = ''
      this.propertyInfo.buildingNameWithCulture = ''
      this.propertyInfo.buildingName = ''
      this.propertyInfo.buildingNameEN = ''
      this.propertyInfo.floorName = ''
      this.propertyInfo.floorNameEN = ''
      this.propertyInfo.unitFloorWithCulture = ''
      this.propertyInfo.roomNo = ''
      this.propertyInfo.roomNoEN = ''
      this.propertyDisPlayList = []
      this.propertyInfo.propertyDisPlayType = ''
      this.propertyInfo.unitFloor = ''
      this.propertyInfo.roomNumber = ''
      this.propertyInfo.toiletNumber = ''
      this.propertyInfo.toiletNumberWithCulture = ''
      if(type == 'zonecode' || type == 'backSpaceName'){
        this.estateSrcList = ''
        this.propertyInfo.estateType = ''
        this.propertyInfo.regionNameWithCulture = ''
        this.isCutomadded = false
        this.propertyInfo.gscopeCode = ''
        this.propertyInfo.estateID = ''
        this.propertyInfo.chartEstateID = ''
        if(type != 'backSpaceName'){
          this.propertyInfo.estateName = ''
          this.propertyInfo.estateNameEN = '';
        }
      }else if (type !== 'category') {
        this.propertyInfo.gscopeNameWithCulture = ''
      } else {
        // 楼盘标签 同类型联动 类型修改-楼盘标签置空
        this.selectedTags = []
        this.tagsChar = []
        this.tagsSce = []
        this.tagsRen = []
        this.tagsMat = []
        this.tagsBus = []
        this.tagsPark = []
        //修改楼盘类型清空期座后 楼龄与楼盘地址 须和当前屋苑数据一致
        this.recoverAdrAge(recoverId)
      }
      // 选中的要删除, 展示的也要删除
      this.floUrls = []
      this.platUrls = []
      this.planfloChecked = []
      this.propertyInfo.planImages = []
      this.planChecked = []
    },
    async recoverAdrAge(item) {
      if(!this.propertyInfo.estateName || !item || !this.addressSearch){return} 
      await this.axios
        .get(this.pub.getApi().GetEstate, {
          params: { estateId: item }
        })
        .then(res => {
          if (res.data.code === 0 && res.data.result) {
            this.propertyInfo.buildingAge = res.data.result.buildingAge ? res.data.result.buildingAge : '';
            this.propertyInfo.estateAddress = res.data.result.detailAddressWithCulture;
            this.propertyInfo.estateAddressEN = res.data.result.detailAddressEN ? res.data.result.detailAddressEN:'';
          }
        });
    },
    getPhaBuild(item) {
      return new Promise((suc, err) => {
        this.axios
          .get(this.pub.getApi().GetPhasesAndBuildingForPublish, {
            params: { estateId: item.parentEstateID ? item.parentEstateID : item.estateID }
          }).then(res => {
            if (res.data.result.estate) {
              this.isCutomadded = res.data.result.estate.isCutomadded
            }
            this.estAdress.phaseEstates = res.data.result.estatePhases
            this.buildingsList = res.data.result.buildingResponses
            this.estAdress.buildings = res.data.result.buildingResponses
            // 存在期数时 筛选座数筛选项
            if (item.phaseWithCulture) {
              this.estAdress.buildings = this.buildingsList.filter(it => {
                return it.estateID == item.estateID
              })
            }
            this.showEstAdressbui = this.estAdress.buildings.length ? true : false
            // 老数据 复制,草稿,续期时其座数单位置空,修改时 保留
            if (!this.propertyInfo.propertyDisPlayType) {
              // if(this.propertyInfo.phaseWithCulture && !this.estAdress.phaseEstates){
              //   this.propertyInfo.phaseWithCulture =''
              // }
              if (this.mode == 'copy' || this.$route.query.draftID || (this.mode == 'edit' && (this.$route.query.editRule == 'renew' || this.$route.query.gradeRule == 'starValidate'))) {
                let resetbuildingNameWithCulture = true
                for (let i = 0; i < this.estAdress.buildings.length; i++) {
                  if (this.estAdress.buildings[i].buildingNameWithCulture == this.propertyInfo.buildingNameWithCulture) {
                    resetbuildingNameWithCulture = false
                  }
                }
                if (resetbuildingNameWithCulture) {
                  this.propertyInfo.buildingNameWithCulture = ''
                  if (this.estAdress.buildings.length == 1 && this.propertyInfo.propertyCategory == 1 && !this.isCutomadded && this.showEstAdressbui && this.editNewDataRule) {
                    this.propertyInfo.buildingNameWithCulture = this.estAdress.buildings[0].buildingNameWithCulture
                    this.setBuild(this.estAdress.buildings[0])
                  }
                }
                this.propertyInfo.roomNo = ''
                this.propertyInfo.roomNoEN = ''
              }
            }
            // 楼盘子类型是否匹配 提示问题 
            if(this.propertyInfo.propertyCategory == 1 &&  res.data.result.estate && res.data.result.estate.suggestSubCategory && this.diConfig.ChildrenCategory.length && this.mode != 'edit'){
              this.suggestSubCategory = res.data.result.estate.suggestSubCategory
              // 筛选出与b值对应的name的值，并赋值给c（字符串形式）
              let matchedItems = this.diConfig.ChildrenCategory.filter(itemChild => itemChild.dictionaryValue == this.suggestSubCategory);
              this.matchSubText = '';
              if (matchedItems.length > 0) {
                this.matchSubText = matchedItems[0].dictionaryNameWithCulture;
              } else {
                this.matchSubText = ''; 
              }
              this.matchSubTypeTit()
            }
            suc()
          })
      }
      )
    },
    matchSubTypeTit(){
      if(!this.suggestSubCategory || !this.matchSubText || this.mode == 'edit' || this.propertyInfo.propertyCategory != 1){return} 
      this.showSubTxt = ''
      if (this.propertyInfo.subCategory.length === 2) {
          if (!this.propertyInfo.subCategory.includes(String(this.suggestSubCategory))) {
            this.showSubTxt = 'suc';
            this.propertyInfo.subCategorySuggestText = '最多選擇2項，推薦更改為【'+this.matchSubText+'】子類型'
          }else{
            this.showSubTxt = '';
          }
      } else if (this.propertyInfo.subCategory.length === 1) {
          const val = this.propertyInfo.subCategory[0];
          if (val != this.suggestSubCategory) {
            let arraySub = []
            for (let i = 0; i < this.diConfig.ChildrenCategory.length; i++) {
              if(this.diConfig.ChildrenCategory[i].disable) {
                arraySub.push(this.diConfig.ChildrenCategory[i].dictionaryValue)
              }
            }
            let strCate = String(this.suggestSubCategory)
            if (arraySub.includes(strCate)) {
              this.showSubTxt = 'fail';
              this.propertyInfo.subCategorySuggestText = '建議重新選擇子類型，推薦更改為【'+this.matchSubText+'】子類型'
            } else {
              // 与推荐类型有冲突fail
              this.showSubTxt = 'pass';
              this.propertyInfo.subCategorySuggestText = '建議選住宅子類型：【'+this.matchSubText+'】'
            }
          }
      } else if (this.propertyInfo.subCategory.length === 0) {
        this.showSubTxt = 'pass';
        this.propertyInfo.subCategorySuggestText = '建議選住宅子類型：【'+this.matchSubText+'】'
      }
    },

    onlyOneSel() {
      if (this.mode !== 'edit' || (this.mode == 'edit' && this.editNewDataRule)) {
        if (this.estAdress.phaseEstates.length == 1 && this.propertyInfo.propertyCategory == '1') {
          this.propertyInfo.phaseWithCulture = this.estAdress.phaseEstates[0].phaseWithCulture
          this.setPhaBuild('phase', this.estAdress.phaseEstates[0])
        }
        if (this.estAdress.buildings.length == 1 && this.propertyInfo.propertyCategory == 1 && !this.isCutomadded && this.showEstAdressbui && this.editNewDataRule) {
          this.propertyInfo.buildingNameWithCulture = this.estAdress.buildings[0].buildingNameWithCulture
          this.setPhaBuild('build', this.estAdress.buildings[0])
        }
      }
    },
    /** 设置楼盘信息 */
    /**
     * *避免异步数据 导致estateid出现错误
     * */
    async setEstate(item) {
      // 选中了暂无数据时 将屋苑名清空
      if(!item.estateNameWithCulture){
          this.propertyInfo.estateName = ''
          this.propertyInfo.estateNameEN = ''
          // this.autocompleteName = ''
          // this.autocompleteNameEN =''
          return
      }
      this.propertyInfo.estateName = item.estateNameWithCulture
      // 根据楼盘id搜索楼盘获取详细信息
      this.axios
        .post(this.pub.getApi().GetStationDuration, {
          estateID: (this.fromZy && item.parentEstateID) ? item.parentEstateID : item.estateID
        })
        .then(res => {
          this.subway = res.data.result
          this.changesubway()
          this.changeParkSubway()
        })
      // 楼盘地址栏 置空
      this.resetPhamore()
      await this.axios
        .get(this.pub.getApi().GetEstate, {
          params: { estateId:(this.fromZy && item.parentEstateID) ? item.parentEstateID : item.estateID }
        })
        .then(res => {
          if (res.data.code === 0 && res.data.result) {
            this.EstateInfo = res.data.result;
            this.estateSrcList = this.EstateInfo.estateSrcList
            this.propertyInfo.estateID = this.EstateInfo.estateID;
            this.propertyInfo.estateType = this.EstateInfo.estateType; //bigest
            this.propertyInfo.gscopeCode = this.EstateInfo.gscopeCode;
            this.chartEstateID = this.EstateInfo.estateID//画图所需id
            this.resetID = this.EstateInfo.estateID
            this.chartScopeCode = this.EstateInfo.gscopeCode;//画图所需板块
            this.propertyInfo.regionNameWithCulture = this.EstateInfo.regionNameWithCulture; /*获取区域 草稿箱列表展示使用*/
            this.propertyInfo.gscopeNameWithCulture = this.EstateInfo.gscopeNameWithCulture; /*获取板块 草稿箱列表展示使用*/
            this.propertyInfo.buildingAge = this.EstateInfo.buildingAge ? this.EstateInfo.buildingAge : '';
            this.propertyInfo.estateAddressEN = this.EstateInfo.detailAddressEN ? this.EstateInfo.detailAddressEN:'';
            this.propertyInfo.estateAddress = this.EstateInfo.detailAddressWithCulture;
            this.propertyInfo.estateName = this.EstateInfo.estateNameWithCulture;
            this.originEstateName = this.propertyInfo.estateName
            this.estateZoneCode = this.EstateInfo.zoneCode;
            this.estateGscopeCode = this.EstateInfo.gscopeCode;
            this.propertyInfo.estateNameEN = this.EstateInfo.estateNameEN
            // this.autocompleteNameEN = this.EstateInfo.estateNameEN;
            // this.autocompleteName = this.EstateInfo.estateNameWithCulture;
            this.isCutomadded = this.EstateInfo.isCutomadded;
            this.showCoupon()
            if(this.propertyInfo.propertyCategory == 1 && this.isUseInstantEstateVolume && this.propertyInfo.roomNumber){
              this.getChartData('chartOne')
              this.getChartData('chartTwo')
              this.isShowChart = true
            }
            if (this.propertyInfo.estateType === 'bigest') {
              this.getPhase(this.propertyInfo.estateID);
            }
          }
        });
        this.addDraft('acquireId')//存入草稿箱
        if(this.exeDraftInter){
          this.exeDraftInter = false
          this.draftTimer = setInterval(() => {
            this.addDraft()
          }, 60000);
        }
      // 当选中屋苑+期数时,期数自动补充
      if(item.parentEstateID){
        this.propertyInfo.phaseWithCulture = item.phaseWithCulture
      }
      // 获取期/座 筛选项
      await this.getPhaBuild(item)
      // 修改时楼盘相关资料置空
      if (this.mode == 'edit') {
        this.clearBoc = true
        this.clearBocPro()
        this.clearProInfo()
      }

      // 获取当前楼盘资料
      if (this.propertyInfo.propertyCategory != "1") {
        this.setOneEstData()
      } else {
        // 楼层单位回归禁用状态
        this.startFloDis = true
        this.startBuilRoom = true
        this.oneBuilRoom = false
      }
      // 期 座 只存在一个的时候, 默认选中第一个
      this.onlyOneSel()
      // 在住宅筛选项下,存在楼层数据仅有屋苑单栋(1)和独立屋(2)
      if (!this.showEstAdressbui) {
        this.propertyInfo.buildingType = 2
        this.norBuilTypeOne()
      }
      // this.cateFromEstate()
    },
    draftDisRule() {
      // 草稿箱 屋苑单栋存在座数 需解除楼层禁用
      if (this.propertyInfo.propertyCategory == "1" && this.propertyInfo.buildingType == 1) {
        if (this.propertyInfo.buildingNameWithCulture) {
          this.startFloDis = false
        }
        if (this.propertyInfo.floorName) {
          this.startBuilRoom = false
          this.geteditRoomNo()
        }
      }else if(this.propertyInfo.propertyCategory !== "1"){
           this.startFloDis = false
      }
    },
    // 重新选择屋苑后-座数不是单栋后-解封
    norBuilTypeOne(type) {
      if ((this.propertyInfo.propertyCategory == "1" && this.propertyInfo.buildingType !== 1) || this.mode == 'edit') {
        this.oneBuilRoom = false
        this.startBuilRoom = false
        this.startFloDis = false

        this.oneBuilFlo = false
        // 楼盘初次回显 楼盘资料不进行处理
        if (type !== 'firstEdit') {
          this.setOneEstData()
        }
      }
      // 0803 修改线上->复制工商厦店铺 但楼层禁用问题
      if(this.mode == 'copy' && (this.propertyInfo.propertyCategory == '2' )|| (this.propertyInfo.propertyCategory == '3')){
        this.startFloDis = false
      }
    },
    setBuild(item) {
      this.propertyInfo.buildingNameEN = item.buildingNameEN
      this.propertyInfo.buildingName = item.buildingName
      if (this.propertyInfo.propertyCategory == '1') {
        this.propertyInfo.buildingType = item.buildingType
      }
      if(this.fromZy){
        this.propertyInfo.buildingNameWithCulture = item.buildingNameWithCulture
      }
      this.propertyInfo.buildingID = item.buildingID
      this.getFloor(item)
      // 先选座数 期数被反选
      if (this.estAdress.phaseEstates) {
        this.estAdress.phaseEstates.forEach(it => {
          if (item.estateID == it.estateID) {
            if(!this.propertyInfo.phaseWithCulture){
              this.showCoupon()
            }
            this.propertyInfo.phaseWithCulture = it.phaseWithCulture
            // this.propertyInfo.buildingAge = it.buildingAge ? it.buildingAge : 0;
            this.propertyInfo.estateID = it.estateID;
            this.propertyInfo.phaseEstateId = it.estateID
            this.propertyInfo.parentEstateID = it.parentEstateID;
            this.propertyInfo.regionNameWithCulture = it.regionNameWithCulture;
            this.propertyInfo.gscopeCode = it.gscopeCode;
            this.propertyInfo.gscopeNameWithCulture = it.gscopeNameWithCulture;
            this.chartEstateID = this.propertyInfo.estateID//画图所需id
            this.chartScopeCode =  this.propertyInfo.gscopeCode;//画图所需板块
            if(this.propertyInfo.propertyCategory == 1 && this.isUseInstantEstateVolume && this.propertyInfo.roomNumber){
              this.getChartData('chartOne')
              this.getChartData('chartTwo')
            }
          }
        })
      }
      this.propertyInfo.gscopeNameWithCulture = item.gscopeNameWithCulture ? item.gscopeNameWithCulture :this.propertyInfo.gscopeNameWithCulture ;
      this.propertyInfo.gscopeCode = item.gscopeCode ? item.gscopeCode :this.propertyInfo.gscopeCode ;
      if ((this.propertyInfo.propertyCategory == "1" && this.propertyInfo.buildingType == 1) || (this.propertyInfo.propertyCategory == '2' && this.showEstAdressbui && !this.isCutomadded)) {
        this.propertyInfo.estateAddress = item.buildingAddress
        this.propertyInfo.estateAddressEN = item.buildingAddressEN
        this.propertyInfo.buildingAge = item.buildingAge ? item.buildingAge : 0;
      }

      // 将楼层和单位恢复禁用
      this.norBuilTypeOne()
      // 楼层是否禁用
      if (this.propertyInfo.propertyCategory == "1" && this.propertyInfo.buildingType == 1) {
        if (!this.propertyInfo.buildingNameWithCulture || this.propertyInfo.buildingNameWithCulture == '') {
          this.oneBuilFlo = true
        } else {
          this.startFloDis = false
          this.oneBuilFlo = false
        }
        // 座数重新选择 楼层平面图置空
        this.floUrls = []
        this.planfloChecked = []
      }
    },
    setPhaBuild(type, item) {
      // 选择了座数后可知类型 (村屋-客制除外,其在获取屋苑时就可得知)
      // 清空楼层 单位
      this.propertyInfo.floorNameWithCulture = ''
      this.propertyInfo.floorName = ''
      this.propertyInfo.floorNameEN = ''
      this.propertyInfo.unitFloorWithCulture = ''
      this.estAdress.floorList = []
      this.estAdress.unitFloorList = []
      this.propertyInfo.roomNo = ''
      this.propertyInfo.roomNoEN = ''
      this.estAdress.unitList = []
      this.propertyInfo.unitFloor = ''
      this.propertyDisPlayList = []
      if (type == "build") {
        this.setBuild(item)
        // 楼层是否禁用
      } else if (type == 'phase') {
        // 更新期数之后 座数置空
        this.propertyInfo.estateID = item.estateID;
        this.propertyInfo.buildingName = ''
        this.propertyInfo.buildingID = ''
        this.propertyInfo.buildingNameWithCulture = ''
        this.propertyInfo.buildingNameEN = ''
        this.propertyInfo.phaseEstateId = item.estateID
        this.propertyInfo.parentEstateID = item.parentEstateID;
        this.propertyInfo.estateAddress = item.detailAddressWithCulture
        this.propertyInfo.estateAddressEN = item.detailAddressEN
        this.propertyInfo.buildingAge = item.buildingAge ? item.buildingAge : 0;
        this.propertyInfo.gscopeCode = item.gscopeCode;
        this.propertyInfo.regionNameWithCulture = item.regionNameWithCulture;
        this.propertyInfo.gscopeNameWithCulture = item.gscopeNameWithCulture;
        this.showCoupon()
        this.chartEstateID = this.propertyInfo.estateID//画图所需id
        this.chartScopeCode =  this.propertyInfo.gscopeCode;//画图所需板块
        if(this.propertyInfo.propertyCategory == 1 && this.isUseInstantEstateVolume && this.propertyInfo.roomNumber){
          this.getChartData('chartOne')
          this.getChartData('chartTwo')
        }
        // 根据期数筛选座数
        this.estAdress.buildings = this.buildingsList.filter(it => {
          return it.estateID == item.estateID
        })
        if (!this.fromZy && this.estAdress.buildings.length == 1 && this.propertyInfo.propertyCategory == 1 && !this.isCutomadded && this.showEstAdressbui && this.editNewDataRule) {
          this.propertyInfo.buildingNameWithCulture = this.estAdress.buildings[0].buildingNameWithCulture
          this.setPhaBuild('build', this.estAdress.buildings[0])
        }
        this.showEstAdressbui = this.estAdress.buildings.length ? true : false
        if (!this.showEstAdressbui) {
          this.propertyInfo.buildingType = 2
          this.norBuilTypeOne()
        }
      }
      if (type == 'isCusbuild') {
        this.propertyInfo.buildingNameEN = ''
        this.propertyInfo.buildingNameWithCulture = ''
        this.propertyInfo.buildingType = ''
        this.propertyInfo.buildingID = ''
        if(this.propertyInfo.buildingName){
          this.setOneEstData()
        }
      }
      if (this.propertyInfo.propertyCategory !== '1') {
        this.setOneEstData()
      }
    },
    // 设置单位
    setRoomNo(item) {
      this.propertyInfo.roomNoEN = item ? item.roomNoEN :'';
      // 只要是非车位和土地 就需要调用楼盘资料
      if ((this.propertyInfo.propertyCategory == "1" && this.propertyInfo.buildingType !== 1) || (this.propertyInfo.propertyCategory !== "1")) {
        this.setOneEstData()
      }
      if (this.propertyInfo.propertyCategory == "1" && this.propertyInfo.buildingType == 1) {
        this.setEstData()
        // 搜索平面图
        this.selPlatImg('100')
      }
    },
    changeToilet(item) {
      this.propertyInfo.toiletNumberWithCulture = item.dictionaryNameWithCulture
      this.$forceUpdate()
    },
    setFlo(item) {
      this.propertyInfo.roomNo = ''
      this.propertyInfo.roomNoEN = ''
      if (item.unitFloor) {
        if (this.propertyInfo.buildingType == '1') {
          this.propertyInfo.unitFloor = String(item.unitFloor)
        } else {
          this.propertyInfo.unitFloor = item.unitFloor
        }
      }
      this.platfloorName = item.floorName
      this.propertyInfo.floorNameEN = item.floorNameEN
      this.propertyInfo.unitFloorWithCulture = item.unitFloorWithCulture
      if (item.roomResponses) {
        this.estAdress.unitList = item.roomResponses
      }
      if ((this.propertyInfo.propertyCategory == "1" && this.propertyInfo.buildingType !== 1) || (this.propertyInfo.propertyCategory !== "1")) {
        this.setOneEstData()
      }
      if (this.propertyInfo.propertyCategory == "1" && this.propertyInfo.buildingType == 1) {
        this.setEstData()
        this.selPlatImg('101')
      }
      // 单位是否禁用
      if (this.propertyInfo.propertyCategory == "1" && this.propertyInfo.buildingType == 1) {
        // 当第一个楼层缺失 单位一定禁用
        if (this.propertyInfo.floorName == '' || !this.propertyInfo.floorName) {
          this.oneBuilRoom = true
        } else {
          // 楼盘资料缺失的情况下-判断第二个楼层选择框
          if (this.estAdress.unitFloorList.length && (!this.propertyInfo.unitFloor || this.propertyInfo.unitFloor == '')) {
            this.oneBuilRoom = true
          } else {
            this.oneBuilRoom = false
            this.startBuilRoom = false
          }
        }
        // 楼层重新选择 单位平面图需置空
        this.platUrls = []
        this.planChecked = []
      } else {
        this.oneBuilRoom = false
        this.startBuilRoom = false
      }
    },
    setFloExt() {
      this.propertyInfo.roomNo = ''
      this.propertyInfo.roomNoEN = ''
      if ((this.propertyInfo.propertyCategory == "1" && this.propertyInfo.buildingType !== 1) || (this.propertyInfo.propertyCategory !== "1")) {
        this.setOneEstData()
      }
      if (this.propertyInfo.propertyCategory == "1" && this.propertyInfo.buildingType == 1) {
        this.setEstData()
      }

      // 单位是否禁用
      if (this.propertyInfo.propertyCategory == "1" && this.propertyInfo.buildingType == 1) {
        // 当第一个楼层缺失 单位一定禁用
        if (this.propertyInfo.floorName == '' || !this.propertyInfo.floorName) {
          this.oneBuilRoom = true
        } else {
          // 楼盘资料缺失的情况下-判断第二个楼层选择框
          if (this.estAdress.unitFloorList.length && (!this.propertyInfo.unitFloor || this.propertyInfo.unitFloor == '')) {
            this.oneBuilRoom = true
          } else {
            this.oneBuilRoom = false
            this.startBuilRoom = false
          }
        }
        this.selPlatImg('101')
      } else {
        this.startBuilRoom = false
        this.oneBuilRoom = false
      }
    },
    setOneEstData() {
      // if (this.companyCategory == 1) return
      // 仅存在一条楼盘资料(即非屋苑单栋)
      let { gscopeNameWithCulture, estateName, estateNameEN, phaseWithCulture, buildingName, roomNo, unitFloor } = this.propertyInfo
      let unitFloorNameWithCulture = ''
      this.diConfig.UnitFloor.forEach(item => {
        if (item.dictionaryValue == unitFloor) {
          unitFloorNameWithCulture = item.dictionaryNameWithCulture
        }
      })
      let PropertyDisPlayTypeNumber = ''
      let estDataStrO = []
      let estDataStrT = []
      let propCategory = this.propertyInfo.propertyCategory//当前选中楼盘的类型
      // 选单模式下 不输入中文 仅输入英文 楼盘资料联动
      let estateNameSel = ''
      estateNameSel = estateName
      if (!this.addressSearch && !estateName) {
        estateNameSel = estateNameEN
      }
      // 座数与屋苑名称相同时 座数不予显示
      if (this.propertyInfo.estateType == 'single' && this.propertyInfo.buildingName == this.propertyInfo.estateName) {
        buildingName = ''
      }
      // 工商厦,店铺
      if (propCategory == "2" || propCategory == "3") {
        // propCategory == "2"? buildingNameWithCulture: buildingName
        estDataStrO = [gscopeNameWithCulture, estateNameSel, phaseWithCulture, buildingName, unitFloorNameWithCulture, roomNo].filter(item => item)
        PropertyDisPlayTypeNumber = 1
      }
      // 车位
      if (propCategory == "4") {
        estDataStrO = [gscopeNameWithCulture, estateNameSel, phaseWithCulture, unitFloorNameWithCulture].filter(item => item)
        // estDataStrO = [gscopeNameWithCulture, estateNameSel, phaseWithCulture, unitFloorNameWithCulture].filter(item => item)
        PropertyDisPlayTypeNumber = 7
      }
      // 土地 或 利嘉阁非屋苑单栋的住宅类型楼盘
      if (propCategory == "5") {
        estDataStrO = [gscopeNameWithCulture, estateNameSel].filter(item => item)
        PropertyDisPlayTypeNumber = 8
      }
      if (propCategory == "1") {
        // 村屋-客製 5 isCutomadded判断
        if (this.isCutomadded) {
          estDataStrO = [gscopeNameWithCulture, estateNameSel, buildingName, unitFloorNameWithCulture, roomNo].filter(item => item)
          PropertyDisPlayTypeNumber = 6
        } else if (this.propertyInfo.buildingType !== 1 && this.propertyInfo.buildingType !== 5) {
          // 屋苑-獨立屋、街道號數-獨立屋、村屋
          if(this.companyCategory == '2'){
            // 利嘉阁 为5和9 在高中低与单位缺失，仅有9
            estDataStrT = [gscopeNameWithCulture, estateNameSel, phaseWithCulture].filter(item => item)
            if(unitFloorNameWithCulture || roomNo){
              estDataStrO = [gscopeNameWithCulture, estateNameSel, phaseWithCulture, unitFloorNameWithCulture, roomNo].filter(item => item)
              PropertyDisPlayTypeNumber = 5
            }
          }else{
            estDataStrO = [gscopeNameWithCulture, estateNameSel, phaseWithCulture, unitFloorNameWithCulture, roomNo].filter(item => item)
            PropertyDisPlayTypeNumber = 5
          }
        }
      }
      if ((propCategory == '1' || propCategory == '6') && !this.addressSearch) {
        // this.propertyInfo.buildingType == '2'?buildingName:buildingNameWithCulture
        estDataStrO = [gscopeNameWithCulture, estateNameSel, phaseWithCulture, buildingName, unitFloorNameWithCulture, roomNo].filter(item => item)
        PropertyDisPlayTypeNumber = 1
      }
      if(this.companyCategory == '2' && propCategory == "1"){
        if( estDataStrO.length){
          let parkEstData = [
            { 'estDatawithCulture': estDataStrO.join(' '), 'PropertyDisPlayType': 5 },
            { 'estDatawithCulture': estDataStrT.join(' '), 'PropertyDisPlayType': 9 }
          ]
          this.propertyDisPlayList = parkEstData
          // 编辑回显时 不使用默认选中
          if (this.mode != 'edit') {
            this.propertyInfo.propertyDisPlayType = parkEstData[0].PropertyDisPlayType
          }
        }else{
          // 利嘉阁 不存在高中低单位的 buildingtype234，楼层资料仅有9
          let parkEstData = [{ 'estDatawithCulture': estDataStrT.join(' '), 'PropertyDisPlayType': 9 }]
          this.propertyDisPlayList = parkEstData
          this.propertyInfo.propertyDisPlayType = parkEstData[0].PropertyDisPlayType
        }
      }else{
        let parkEstData = [{ 'estDatawithCulture': estDataStrO.join(' '), 'PropertyDisPlayType': PropertyDisPlayTypeNumber }]
        this.propertyDisPlayList = parkEstData
        this.propertyInfo.propertyDisPlayType = parkEstData[0].PropertyDisPlayType
      }
    },

    selPlatImg(imageType, fromMode) {
      // 没有具体楼层
      if(fromMode == 'floSel' && !this.estAdress.floorList.length){
        this.setFloExt()
      }
      // fromMode : 传入edit 会默认勾选平面图，不为edit,则不默认勾选
      if (this.propertyInfo.propertyCategory == "1" && this.propertyInfo.buildingType == 1) {
        let floorNameplat = this.propertyInfo.floorName
        // floorNameplat.indexOf('(') == -1 ? floorNameplat : floorNameplat.match(/(\S*)\(/)[1]
        this.axios
          .post(this.pub.getApi().SearchPropertyPlanImage, {
            estateID: this.propertyInfo.estateID,
            phaseEstateId: this.propertyInfo.phaseEstateId,
            buildingId: this.propertyInfo.buildingID,
            roomNo: this.propertyInfo.roomNo,
            floorName: floorNameplat,
            pageCount: 20,
            pageIndex: 1,
            imageType: imageType
          }).then(res => {
            if (res.data.code == 0 && res.data.result.count) {
              // 如果有數據
              if (imageType == 100) {
                // 单位平面图
                this.platUrls = res.data.result.data
                this.planChecked = []
                if (fromMode != 'edit' && this.platUrls.length) {
                  this.planChecked.push(this.platUrls[0])
                }
              }
              if (imageType == 101) {
                this.floUrls = res.data.result.data
                this.planfloChecked = []
                if (fromMode != 'edit' && this.floUrls.length) {
                  this.planfloChecked.push(this.floUrls[0])
                }
              }
            }
            if (!this.platUrls.length && !this.floUrls.length) {
              this.alreaSel = true
            } else {
              this.alreaSel = false
            }
          })
      } else { return }
    },
    setEstData(type) {
      // if (this.companyCategory == 1) return
      let { gscopeNameWithCulture, estateName, phaseWithCulture, buildingName,  unitFloorWithCulture, roomNo, unitFloor } = this.propertyInfo
      // this.diConfig.UnitFloor.forEach(item => {
      //   if (item.dictionaryValue == unitFloor) {
      //     unitFloor = item.dictionaryNameWithCulture
      //   }
      // })
      if(!this.propertyInfo.unitFloorWithCulture && this.propertyInfo.unitFloor){
        this.diConfig.UnitFloor.forEach(item => {
          if (item.dictionaryValue == unitFloor) {
            unitFloorWithCulture = item.dictionaryNameWithCulture
          }
        })
      }
      gscopeNameWithCulture = gscopeNameWithCulture ? gscopeNameWithCulture : ''
      estateName = estateName ? estateName : ''
      phaseWithCulture = phaseWithCulture ? phaseWithCulture : ''
      unitFloorWithCulture = unitFloorWithCulture ? unitFloorWithCulture : ''
      buildingName = buildingName ? buildingName : ''
      // 座数与屋苑名称相同时 座数不予显示
      if (this.propertyInfo.estateType == 'single' && this.propertyInfo.buildingName == this.propertyInfo.estateName) {
        buildingName = ''
      }
      // if (!this.estAdress.unitFloorList.length && this.companyCategory == 3) {
      //   unitFloor = ''
      // } else {
      //   unitFloor = unitFloor ? unitFloor : ''
      // }
      roomNo = roomNo ? roomNo : ''
      // unitFloor
      let estDataStrO = [gscopeNameWithCulture, estateName, phaseWithCulture, buildingName, unitFloorWithCulture, roomNo]
      let estDataStrThr = [gscopeNameWithCulture, estateName, phaseWithCulture, buildingName, roomNo]
      let propCategory = this.propertyInfo.propertyCategory//当前选中楼盘的类型
      // , unitFloor
      let estDataStrT = [gscopeNameWithCulture, estateName, phaseWithCulture, buildingName, unitFloorWithCulture]
      let estDataStrF = [gscopeNameWithCulture, estateName, phaseWithCulture, buildingName]
      // 屋苑
      if (propCategory == "1") {
        if (this.propertyInfo.buildingType == 1) {
          let pavilions = []
          if (this.propertyInfo.roomNo) {
            //单栋有单位
            pavilions = [
              { 'estDatawithCulture': estDataStrO.join(' '), 'PropertyDisPlayType': 1 },
              { 'estDatawithCulture': estDataStrT.join(' '), 'PropertyDisPlayType': 2 },
              { 'estDatawithCulture': estDataStrThr.join(' '), 'PropertyDisPlayType': 3 },
              { 'estDatawithCulture': estDataStrF.join(' '), 'PropertyDisPlayType': 4 }
            ]
          } else {
            // 单栋无单位
            pavilions = [
              { 'estDatawithCulture': estDataStrT.join(' '), 'PropertyDisPlayType': 2 },
              { 'estDatawithCulture': estDataStrF.join(' '), 'PropertyDisPlayType': 4 }
            ]
          }
          this.propertyDisPlayList = pavilions
        }
      }
      // 编辑回显时 不使用默认选中
      if (type !== 'firstEdit') {
        this.propertyInfo.propertyDisPlayType = this.propertyDisPlayList[0].PropertyDisPlayType
      }
      if(this.companyCategory == 1 && !this.existRoomNo){
        this.propertyInfo.propertyDisPlayType = 2
      }
    },
    geteditRoomNo() {
      for (let index = 0; index < this.estAdress.floorList.length; index++) {
        if (this.propertyInfo.floorName == this.estAdress.floorList[index].floorName) {
          this.estAdress.unitList = this.estAdress.floorList[index].roomResponses
        }
      }

    },
    // 获取楼层 
    getFloor(item) {
      return new Promise((suc, err) => {
        this.axios
          .get(this.pub.getApi().GetBuildingFloorPublish, {
            params: { buildingId: item.buildingID }
          })
          .then(res => {
            this.estAdress.floorList = res.data.result
            // 仅有一个楼层的时候 默认选中
            if (this.mode !== 'edit' || (this.mode == 'edit' && this.editNewDataRule)) {
              if (this.propertyInfo.buildingType == '1' && this.estAdress.floorList.length == 1 && this.propertyInfo.propertyCategory == '1' && this.propertyInfo.buildingType == 1) {
                this.setFlo(this.estAdress.floorList[0])
              }
            }
            if (this.mode == 'edit' || this.mode == 'copy' || this.$route.query.draftID || (this.companyCategory == 2 && this.propertyInfo.propertyCategory == 1)) {
              this.geteditRoomNo()
            }
            if (res.data.result[0] && !res.data.result[0].floorDisplay) {
              this.axios.get(this.pub.getApi().SearchDictionaryInfo, {
                params: { itemName: 'UnitFloor' }
              }).then(response => {
                this.estAdress.unitFloorList = response.data.result
              })
            } else {
              this.estAdress.unitFloorList = []
            }
            suc()
          })
      })
    },
    /** 期数盘请求 */
    getPhase(EstateId) {
      this.axios
        .post(this.pub.getApi().SearchEstate, {
          parentEstateId: EstateId,
          order: 'PhaseSequenceAsc', // 按期数排序
          pageIndex: 1,
          pageCount: 20,
          estateSrc: this.propertyInfo.propertyCategory
        })
        .then(res => {
          if (res.data.code == 0 && res.data.result) {
            this.diConfig.phaseList = res.data.result.data;
            if (this.diConfig.phaseList.length) {
              this.$set(this.propertyInfo, 'estateType', 'bigest');
              this.diConfig.phaseList.unshift({
                phaseWithCulture: '請選擇期數',
                estateID: this.mode == 'edit' && this.propertyInfo.parentEstateID ? this.propertyInfo.parentEstateID : this.propertyInfo.estateID
              });
            }
          }
        });
    },
    /** 数据类型格式转换 */
    dataFormat(type, typefrom) {
      let typeList = {
        subCategory: 'ArrayInt', //小分类In32
        rentLabel: 'ArrayInt', //租房-其他In32
        propertyCategory: 'int', // 放盘分类Int32
        salePrice: 'int', //售价
        rentPrice: 'int', // 租价
        paidSalePrice: 'int',// 绿白表
        unPaidSalePrice: 'int',
        buildingArea: 'int', //建筑面积
        saleableArea: 'int', //使用面积
        beginRentTime: 'int', //起租日
        buildingAge: 'int', //楼龄
        roomNumber: 'int', //房间数目
        unitFloor: 'int', //单位楼层
        propertyManagementFee: 'int', //管理费
        rentalType: 'int',
        topType: 'int',
        PageIndex: 'int',
        PageCount: 'int',
        ToiletNumber: 'int',
      };
      if (type === 'post') {
        // 视频上传时,当vurls中有值,赋值给videos数组preData
        // if(this.vurls[0]){
        //   this.videos[0].defaultImagePath=this.vurls[0]
        // }else{
        //   this.videos[0].defaultImagePath=""
        // }
        if (this.vurls[0]) {
          this.videos[0].defaultImagePath = this.vurls[0]
        } else if (this.videos && this.videos[0] && this.videos[0].defaultImagePath) {
          // 为了解决回显时点击直接点击更改时候vurls中没有数据,但是图片依旧要显示的bug
          this.videos[0].defaultImagePath = this.videos[0].defaultImagePath
        } else {
          if (this.videos && this.videos[0]) {
            this.videos[0].defaultImagePath = ""
          }
        }
        // 草稿箱
        if (typeList.PageIndex === 'int') {
          this.PageIndex = parseInt(this.PageIndex);
        }
        if (typeList.PageCount === 'int') {
          this.PageCount = parseInt(this.PageCount);
        }
        // 将选中的平面图 进行赋值
        this.propertyInfo.planImages = []
        if (this.planChecked.length) {
          for (let i = 0; i < this.planChecked.length; i++) {
            this.propertyInfo.planImages.push(this.planChecked[i])
          }
        }
        if (this.planfloChecked.length) {
          for (let i = 0; i < this.planfloChecked.length; i++) {
            this.propertyInfo.planImages.push(this.planfloChecked[i])
          }
        }
        let newFilterUserInfo = this.propertyUserInfo.filter(item => 
            item.hasOwnProperty('name') && 
            item.hasOwnProperty('accountID') &&
            item.name != null && 
            item.name !== '' &&
            item.accountID != null
        );
        this.preData = JSON.parse(JSON.stringify(this.propertyInfo));
        this.preUserData = JSON.parse(JSON.stringify(newFilterUserInfo));
        if (this.preData.toiletNumber == undefined || this.preData.toiletNumber == 'undefined' || this.preData.toiletNumber == -1) {
          this.preData.toiletNumber = 0
        }
        if (typeof this.preData.subCategory === 'string') {
          this.preData.subCategory = [this.preData.subCategory];
        }
        /** 代理资料格式换 */
        this.preUserData = this.preUserData.filter(value => Object.keys(value).length !== 0);
        for (let i = 0; i < this.preUserData.length; i++) {
          this.preUserData[i].IsShowTel = true;
          for (let k in this.preUserData[i]) {
            if (k === 'name') {
              this.preUserData[i].contactNameCN = this.preUserData[i][k];
              delete this.preUserData[i][k];
            }
            if (k === 'telephone') {
              this.preUserData[i].telphone = this.preUserData[i][k];
              delete this.preUserData[i][k];
            }
            if (k === 'license') {
              this.preUserData[i].agentLicenceNumber = this.preUserData[i][k];
              delete this.preUserData[i][k];
            }
            if (k === 'roleList' || k === 'remainderPropertyCoin') {
              delete this.preUserData[i][k];
            }
          }
        }
        // if (this.images.length) {
        //   /** 处理图片 设置第一张为默认图 */
        //   this.images.forEach((item, index) => {
        //     if (index === 0) {
        //       item.isDefault = true;
        //     }else{
        //       item.isDefault = false;
        //     }
        //     for (let key in item) {
        //       if (item[key] == '') {
        //         delete item[key]; /** 删除为空字段 */
        //       }
        //     }
        //   });
        // }
        /**处理楼盘验证文件400 替换*/
        // if (this.preData.verifyImage.length) {
        //     this.preData.verifyImage.forEach((item, index) => {
        //         this.preData.verifyImage[index] = item.replace('house730-files.oss-accelerate.aliyuncs.com', 'img.house730.com').replace("http://","https://");
        //     });
        // }
        // 楼盘图片 格式整理
        // 楼盘图片 格式整理
        this.images.forEach((item, index) => {
          for (let key in item) {
            if (item[key] == '') {
              delete item[key]; /** 删除为空字段 */
            }
          }
        });
        /** 楼盘资料格式化 */
        if (this.propertyInfo.topType == 2 && this.mode !== 'edit') {
          this.propertyInfo.topType = '0';
        }
        if (this.propertyInfo.rentalType == 1) {
          delete this.preData.rentPrice;
          delete this.preData.beginRentTime;
          delete this.preData.rentLabel;
        } else {
          delete this.preData.salePrice;
          delete this.preData.paidSalePrice;
          delete this.preData.unPaidSalePrice;
        }
        if (this.isaddVR == false) {
          delete this.preData.addVR;
        }
        for (let key in this.preData) {
          if (this.conditions) {
            delete this.preData.imageExternal;
          }
          if (typeList[key] === 'int') {
            this.preData[key] = Number(this.preData[key]);
          }

          if (typeList[key] === 'ArrayInt' && this.preData[key].length) {
            this.preData[key] = this.preData[key].map(Number);
          }
          if (key === 'beginRentTime' && this.preData[key]) {
            this.preData[key] = parseInt(this.preData[key] / 1000);
          }
          if ((key === 'salePrice' || key === 'paidSalePrice' || key === 'unPaidSalePrice') && this.preData[key]) {
            this.preData[key] = parseInt(this.preData[key] * 10000);
          }
          // if (this.preData.isVerify.length === 0) {
          //   delete this.preData.verifyImage;
          // }
          /** 处理相似楼盘 */
          /** 删除空字段 */
          
          if ((this.preData[key] === 0 && key != 'topType' && key != 'paymentType') || this.preData[key] === '' || JSON.stringify(this.preData[key]) === '[]' || this.preData[key] === null || JSON.stringify(this.preData[key]) === '{}') {
            delete this.preData[key];
            continue;
          }

        }
      }
      /** 如果为修改-复制获取代码时的格式化 */
      if (type === 'edit') {
        // 草稿箱
        if (typeList.PageIndex === 'int') {
          this.PageIndex = parseInt(this.PageIndex);
        }

        if (typeList.PageCount === 'int') {
          this.PageCount = parseInt(this.PageCount);
        }
        if (typeList.ToiletNumber === 'int') {
          this.propertyInfo.toiletNumber = String(this.propertyInfo.toiletNumber);
        }
        if (typeof this.propertyInfo.subCategory === 'number') {
          this.propertyInfo.subCategory = String(this.propertyInfo.subCategory);
        }
        
        if(typeof this.propertyInfo.paymentType === 'string'){
          this.propertyInfo.paymentType = parseInt(this.propertyInfo.paymentType)
        }
        // if (typeof this.propertyInfo.subCategory === 'object' && JSON.stringify(this.propertyInfo.subCategory) != '{}') {
        if (!Array.isArray(this.propertyInfo.subCategory) && JSON.stringify(this.propertyInfo.subCategory) != '{}') {
          // if (this.propertyInfo.propertyCategory == '5' && this.$route.query.draftID) {
          //   this.propertyInfo.subCategory = Object.values(this.propertyInfo.subCategory).map(String);
          // } else if (this.propertyInfo.propertyCategory == '5') {
          //   this.propertyInfo.subCategory = Object.keys(this.propertyInfo.subCategory);
          // } else {
          //   this.propertyInfo.subCategory = Object.keys(this.propertyInfo.subCategory)[0];
          // }
          // if (this.$route.query.draftID || (sessionStorage.getItem('refreshpro') == 'true' && sessionStorage.getItem('refreshID'))) {
            // this.propertyInfo.subCategory = Object.values(this.propertyInfo.subCategory).map(String);
          // } else if( typefrom != 'conditions'){
          //   this.propertyInfo.subCategory = Object.keys(this.propertyInfo.subCategory);
          // }
          this.propertyInfo.subCategory = Object.keys(this.propertyInfo.subCategory);
        }
        if(Array.isArray(this.propertyInfo.subCategory)){
          this.propertyInfo.subCategory = Object.values(this.propertyInfo.subCategory).map(String);
        }
        if (JSON.stringify(this.propertyInfo.subCategory) == '{}') {
          this.propertyInfo.subCategory = []
        }
        /**  分类格式化处理 */
        /**类型5 值为数组*/
        // if (!this.conditions) {
        //     try {
        //         if (this.propertyInfo.propertyCategory === '5') {
        //             this.propertyInfo.subCategory = Object.keys(this.propertyInfo.subCategory);
        //         }
        //     } catch (err) {}
        // }
        this.propertyInfo.agree = '';
        if (this.mode == 'edit') {
          this.propertyInfo.agree = true;
        }
        /** 判断是否是期数盘 phaseWithCulture*/
        this.getEstate(this.propertyInfo);
        /** estateID为零 说明是手动录入信息 */
        if (this.propertyInfo.estateID === 0) {
          this.entryMethod();
        }
        /** 图片格式化 */
        this.images = this.propertyInfo.images || [];
        this.imgFormart(this.images);
        // if (this.images.length) {
        //     this.images.forEach(item => {
        //         if (item.imageType === 0) {
        //             item.imageType = '';
        //         } else {
        //             item.imageType = String(item.imageType);
        //         }
        //     });
        // }
        if (this.propertyInfo.propertyCategory == "1" && this.propertyInfo.buildingType == '1') {
          this.propertyInfo.unitFloor = parseInt(this.propertyInfo.unitFloor)
        }
        if (this.propertyInfo.toiletNumber == -1) {
          this.propertyInfo.toiletNumber = '0';
        }
        // this.propertyInfo[key] ==&&
        /**  楼盘信息格式化 */
        let keysToDelete = [];
        for (let key in this.propertyInfo) {
          //  && key != 'propertyCategory'
          if (typeList[key] === 'int') {
            this.propertyInfo[key] = String(this.propertyInfo[key]);
          }
          // 草稿箱 和 续期老数据修改页 和 复制及修改页 的空座数和空期数 不进行删除空值(会影响校验) 
          // 单位不进行删除 --避免computed失效 || key == 'roomNo'
          let notdelPro = true
          if ((typefrom == 'draft' ||  this.$route.query.gradeRule == 'starValidate' ||this.$route.query.editRule == 'renew' || this.mode == 'copy' || this.mode == 'edit') && (key == 'buildingNameWithCulture' || key == 'phaseWithCulture' || key == 'roomNo') && (this.propertyInfo[key] === '' || this.propertyInfo[key] === null)) {
            notdelPro = false
          }
          if (
            (this.propertyInfo[key] === '0' && key != 'topType' && key != 'propertyCategory')
            || (this.propertyInfo[key] === '' && notdelPro)
            || (this.propertyInfo[key] === null && notdelPro)
          ) {
            keysToDelete.push(key);
          }
          // if ((this.propertyInfo[key] === '0' && key != 'topType') || this.propertyInfo[key] === '' || this.propertyInfo[key] === null) {
          //   delete this.propertyInfo[key];
          //   continue;
          // }
          if (key === 'beginRentTime') {
            if (this.propertyInfo[key] <= 0) {this.propertyInfo[key] = '';}
            else {
              this.propertyInfo[key] = parseInt(this.propertyInfo[key] * 1000);
            }
          }
          if (key === 'salePrice' || key === 'paidSalePrice' || key === 'unPaidSalePrice') {
            this.propertyInfo[key] = parseInt(this.propertyInfo[key] / 10000);
          }
        }
        for (let key of keysToDelete) {
          delete this.propertyInfo[key];
        }

        // 接口为兼容老版本 会对公屋类型赋售价和saleForm等无关字段 需清除
        if(this.propertyInfo.subCategory && (this.propertyInfo.subCategory.includes('6') || this.propertyInfo.subCategory.includes('7') || this.propertyInfo.subCategory.includes(6) || this.propertyInfo.subCategory.includes(7))){
          if(this.propertyInfo.paidSalePrice == 0 ){
            this.propertyInfo.paidSalePrice = ''
          }
          if(this.propertyInfo.unPaidSalePrice == 0){
            this.propertyInfo.unPaidSalePrice = ''
          }
          this.propertyInfo.salePrice = ''
        }
        // // 编辑楼盘回显限制
        // this.cateFromEstate(typefrom)
        this.diConfig.PropertyCategory.forEach(item => {
          if (item.dictionaryValue === this.propertyInfo.propertyCategory) {
            this.diConfig.ChildrenCategory = item.children;
            this.subTypeSel()
          }
        });
        if (this.isaddVR == false) {
          delete this.preData.addVR;
        }
        /**  租房-其他分类处理 rentLabel */
        // if (this.$route.query.draftID) {
        //   this.propertyInfo.rentLabel = Object.values(this.propertyInfo.rentLabel).map(String)
        // } else {
        //   this.propertyInfo.rentLabel = Object.keys(this.propertyInfo.rentLabel);
        // }
        if(!Array.isArray(this.propertyInfo.rentLabel) && JSON.stringify(this.propertyInfo.rentLabel) != '{}' && this.propertyInfo.rentLabel){
          this.propertyInfo.rentLabel = Object.keys(this.propertyInfo.rentLabel);
        }
        if(Array.isArray(this.propertyInfo.rentLabel) && this.propertyInfo.rentLabel){
          this.propertyInfo.rentLabel = Object.values(this.propertyInfo.rentLabel).map(String);
        }
        if (JSON.stringify(this.propertyInfo.rentLabel) == '{}') {
          this.propertyInfo.rentLabel = []
        }
        this.$set(this.propertyInfo, 'estateAddress', this.propertyInfo.estateAddressWithCulture);
      }

    },
    getAppConfig() {
      return this.axios.get(this.pub.getApi().GetAppConfig, { params: { version: 'config' } });
    },
    /** 获取代理列表 */
    SearchStaffUser() {
      return this.axios.get(this.pub.getApi().SearchStaffUser);
    },
    // 获取是否是初次进入刊登引导
    GetAccountResource() {
      return this.axios.post(this.pub.getApi().GetAccountResource + '?resource=PictureIntroductionPC');
    },
    SetAccountResources() {
      this.axios.post(this.pub.getApi().SetAccountResources, {
        resource: 'PictureIntroductionPC',
        resourceValue: 2
      });
    },
    /** 复制修改 - 根据楼盘id获取放盘人信息 */
    GetPropertyUserInfoFullById() {
      let isCopy = this.$route.query.type == 'copy' ? true:false
      let propertyUser = this.axios
        .get(this.pub.getApi().GetPropertyUserInfoFullById, {
          params: { propertyId: this.propertyId,isCopy: isCopy}
        })
        .then(res => {
          if (res.data.code === 0 && res.data.result) {
            // 代理信息格式化
            res.data.result.forEach((item, index) => {
            if(item.userStatus == 'Disable'){
              let str = item.contactNameCN+'(已停用)'
              this.agent.push(str);
            }else{
              this.agent.push(item.accountID);
            }
              for (let k in item) {
                if (k === 'contactNameCN') {
                  item.name = item.contactNameCN;
                }
                if (k === 'telphone') {
                  item.telephone = item.telphone;
                }
                if (k === 'agentLicenceNumber') {
                  item.license = item.agentLicenceNumber;
                }
                if (k === 'agentIntroduce') {
                  item.signature = item.agentIntroduce;
                }
                // 复制楼盘 后台隐藏了开关，但刊登时选择了隐藏，复制时要变为显示
                if(k == 'isHideCompanyTel'){
                  item.isShowPmsCompanyTel = !item.isHideCompanyTel;
                }
              }
              let copyUserInfo=Object.assign({}, item);
              this.editcompanyUserInfo.push(copyUserInfo)
              this.propertyUserInfo[index] = item
            });
          }
        }).then(() => {
          // 付款页后台配置代理人3改1时候不可以变
          if (this.publicAgentNumber == 1 && this.$route.query.type != 1) {
            this.diConfig.agentList = [{ ...this.userInfo }];
            let copyUserInfo=Object.assign({}, this.userInfo);
            this.editcompanyUserInfo.push(copyUserInfo)
            this.editAgentList.push(copyUserInfo)
            this.propertyUserInfo = [{ ...this.userInfo }];
            this.agent.push(this.diConfig.agentList[0].accountID);
          }
          // else if(this.publicAgentNumber !== 1 && this.$route.query.type != 1){
          //   if(this.propertyUserInfo.length === 1 &&  this.$route.query.type != 1){
          //     // 放盘人是作为唯一代理人进行了放盘
          //     if(this.propertyUserInfo[0].accountID == this.userInfo.accountID){
          //       let flag=true
          //       this.diConfig.agentList.forEach((items,index)=>{
          //         if(items.accountID == this.userInfo.accountID){
          //           flag=false
          //           throw new Error("放盘人是代理人")
          //         }
          //       })
          //       if(flag && this.$route.query.type != 1){
          //         this.propertyUserInfo=[{}]
          //         this.agent=[]
          //       }else{
          //         this.propertyUserInfo[index] = item
          //         console.log("放盘为代理",this.propertyUserInfo)
          //       }
          //     }
          //   }
          // }
        });
    },
    reviewPlat() {
      if(this.companyCategory == 2 && this.propertyInfo.propertyDisPlayType == '1' && this.mode == 'edit'){
        return
      }
      if (this.propertyInfo.planImages && this.propertyInfo.planImages.length) {
        if (this.propertyInfo.planImages.length == 1) {
          if (this.propertyInfo.planImages[0].imageType == '100') {
            if (this.propertyInfo.floorName) {
              this.selPlatImg('101', 'edit')
            }
          } else {
            if (this.propertyInfo.roomNo) {
              this.selPlatImg('100', 'edit')
            }
          }
        }
        for (let i = 0; i < this.propertyInfo.planImages.length; i++) {
          if (this.propertyInfo.planImages[i].imageType == '100') {
            this.platUrls.push(this.propertyInfo.planImages[i])
            this.planChecked.push(this.propertyInfo.planImages[i])
          } else {
            this.floUrls.push(this.propertyInfo.planImages[i])
            this.planfloChecked.push(this.propertyInfo.planImages[i])
          }
        }
      } else {
        if (this.propertyInfo.floorName) {
          this.selPlatImg('101', 'edit')
        }
        if (this.propertyInfo.roomNo) {
          this.selPlatImg('100', 'edit')
        }
      }
      if (this.mode == 'copy') {
        this.propertyInfo.planImages = []
        this.planChecked = []
        this.planfloChecked = []
        return
      }
    },
    updateCompareNo(compareNo, apiData) {
      for (let key in compareNo) {
        if (apiData.hasOwnProperty(key)) {
          compareNo[key] = apiData[key];
        }
      }
    },
    /** 复制修改 - 根据当前楼盘ID获取当前楼盘信息 */
    GetPropertyFullById() {
      this.axios
        .get(this.pub.getApi().GetPropertyFullById, {
          params: { propertyId: this.propertyId }
        })
        .then(async res => {
          if (res.data.code === 0 && res.data.result) {
            this.apiData = res.data.result;
            this.updateCompareNo(this.compareNo,this.apiData)
            this.estateSrcList = this.apiData.estateSrcList
            this.propertyInfo = Object.assign(this.propertyInfo, this.apiData);
            if(this.propertyInfo.estateID &&  this.propertyInfo.zoneCode){
              this.estateZoneCode = this.propertyInfo.zoneCode
            }
            if(this.propertyInfo.estateID &&  this.propertyInfo.gscopeCode){
              this.estateGscopeCode = this.propertyInfo.gscopeCode
            }
            this.reviewPlat()
            // 续期跳入修改页 数据必填规则
            let renewDataRule = false
            if (this.$route.query.editRule) {
              renewDataRule = true
            } else {
              renewDataRule = false
            }
            // // 非中利 老数据修改时候 不需要填写必填 
            // if (this.mode == 'edit' && !this.propertyInfo.propertyDisPlayType && !renewDataRule && this.companyCategory == 3) {
            //   this.editNewDataRule = false
            // }
            //非中利 续期的老数据 需要补回必填
            if (this.mode == 'edit' && !this.propertyInfo.propertyDisPlayType && renewDataRule && this.companyCategory == 3) {
              this.editNewDataRule = true
            }
            this.orignprice = this.apiData.salePrice
            this.orignrprice = this.apiData.rentPrice
            this.$nextTick(async function () {  //页面加载完成后执行
              this.editTags()
              if(this.mode == 'copy'){
                // 首次进入复制页面，生成一个新的草稿id
                if(sessionStorage.getItem('refreshpro') == 'false' || !sessionStorage.getItem('refreshpro')){
                  this.addDraft('acquireId')
                }
                if(this.exeDraftInter){
                  this.exeDraftInter = false
                  this.draftTimer = setInterval(() => {
                    this.addDraft()
                  }, 60000);
                }
              }
            })
            this.isPropertySource = this.propertyInfo.propertySource == '1' ? true : false
            // 修改编辑视频回显问题
            if (this.apiData.videos[0]) {
              if (this.apiData.videos[0].defaultImagePath !== '' && this.apiData.videos[0].defaultImagePath !== null) {
                this.isHidden = false
              }
              if (this.apiData.videos[0].defaultImagePath) {
                this.videos[0].defaultImagePath = this.apiData.videos[0].defaultImagePath
              }
              this.videos[0].videoPath = this.apiData.videos[0].videoPath
            } else {
              this.videos = this.videos
            }
            // 老数据超出长度的 回显需要截取
            if(this.propertyInfo.titleCN && this.propertyInfo.titleCN.length > 30){
              this.propertyInfo.titleCN = this.propertyInfo.titleCN.slice(0,30)
            }
            if(this.propertyInfo.titleEN && this.propertyInfo.titleEN.length > 50){
              this.propertyInfo.titleEN = this.propertyInfo.titleEN.slice(0,50)
            }
            if(this.propertyInfo.introduceCN && this.propertyInfo.introduceCN.length > 500){
              this.propertyInfo.introduceCN = this.propertyInfo.introduceCN.slice(0,500)
            }
            if(this.propertyInfo.introduceEN && this.propertyInfo.introduceEN.length > 600){
              this.propertyInfo.introduceEN = this.propertyInfo.introduceEN.slice(0,600)
            }
            // [ normal：0, goldTop：1, top：2, star：3 ]
            /*获取星级盘对应的租售价格展示*/
            // if (this.propertyInfo.rentalType == 2 && (this.mode == '2' || this.mode == '1' || this.mode == 'edit')) {
            //   this.diConfig.Star = this.diConfig.Star_Rent
            // }
            // if (this.propertyInfo.rentalType == 1 && (this.mode == '2' || this.mode == '1' || this.mode == 'edit')) {
            //   this.diConfig.Star = this.diConfig.Star_Buy
            // }
            if (this.propertyInfo.topType == 2) {
              this.propertyInfo.topType = '0';
            }
            /*不允许使用钻石的情况下 默认定位标准盘*/
            // if (!this.isUsedDiamond && this.mode !== 'edit') {
            //   this.propertyInfo.topType = '0';
            // }
            if(this.$route.query.gradeRule == 'starValidate'){
              this.starUpgradeObj = JSON.parse(sessionStorage.getItem('upgradeData'));
              this.propertyInfo.targetUpTopType = this.starUpgradeObj.targetType == 'Star' ? '3' : this.starUpgradeObj.targetType == 'Super' ? '1' :'0'
              this.propertyInfo.topType = this.propertyInfo.targetUpTopType
              this.getPorpertyUpgradeOrder(this.$route.query.propertyId)
            }
            if (this.mode === "1" && this.propertyInfo.topType == '0' && this.isUseStandard) {
              this.propertyInfo.topType = '0';
            } else if (this.mode === "1" && this.propertyInfo.topType == '1' && this.isUseSuper) {
              this.propertyInfo.topType = '1';
            } else if (this.mode === "1" && this.propertyInfo.topType == '3' && this.isUseStar) {
              this.propertyInfo.topType = '3';
            } else if (this.mode !== "edit") {
              if (this.isUseStandard) {
                this.propertyInfo.topType = '0';
              } else if (this.isUseSuper) {
                this.propertyInfo.topType = '1';
              } else {
                this.propertyInfo.topType = '3';
              }
            };
            if (this.mode == 'copy') {
              /**复制精选盘默认 && 当前精选盘是禁止放盘的时候 强制修改为标准盘*/
              this.propertyInfo.rentalType = this.$route.query.rentalType;
              this.changeCoinDia()
              if(this.isShowAutoRecCount > 1){
                if((this.isUseSuper && this.propertyInfo.topType == '0') || (this.isUseStar && (this.propertyInfo.topType == '0' || this.propertyInfo.topType == '1'))) {
                  this.isShowHighTop = true
                }else{
                  this.isShowHighTop = false
                }
              }
              this.isShowRecAuto('isShowAutoRecCount',this.propertyInfo.topType)
              // 复制 当后台业主盘按钮关闭，将业主盘变更为代理盘
              if(!this.isOwner && this.propertyInfo.propertySource == '1'){
                this.propertyInfo.propertySource = 2
              }
              if(this.propertyInfo.rentalType == 2 && this.propertyInfo.isForeclosure){
                this.propertyInfo.isForeclosure = false
                this.propertyInfo.isShowForeclosureDesc = false
              }
            }
            let proCatStr= this.propertyInfo.rentalType == 1 ? 'propertyCategorySale':'propertyCategoryRent'
            this.diConfig.PropertyCategory = this.filterArray(this.arrCat[proCatStr])
            // 当没有选择座数数据 银行估价默认为true
            if (!this.propertyInfo.roomNo) {
              this.propertyInfo.isBoc = true
            }
            this.originEstateName = this.propertyInfo.estateName
            this.dataFormat('edit');
            if(this.mode == 'edit'){
              this.identification = this.propertyId;
              this.$nextTick(function () {
                this.createQRCode();
              });
              if(sessionStorage.getItem('refreshpro') == 'false' || !sessionStorage.getItem('refreshpro')){
                this.addDraft('acquireId')
              }
              if(this.exeDraftInter){
                this.exeDraftInter = false
                this.draftTimer = setInterval(() => {
                  this.addDraft()
                }, 60000);
              }
              this.fromZy = this.apiData.iszyCoupon
              if(this.fromZy){
                this.couponPhase = Boolean(this.propertyInfo.phaseWithCulture);
                this.couponBuild = Boolean(this.propertyInfo.buildingID);

                if(this.apiData.estateAllowUpdateUpdateTime && this.editEst){
                  let timestamp = parseInt(this.apiData.estateAllowUpdateUpdateTime) * 1000;
                  let dateObj = new Date(timestamp);
                  let year = dateObj.getFullYear();
                  let month = dateObj.getMonth() + 1; 
                  let day = dateObj.getDate();
                  month = month < 10 ? '0' + month : month;
                  day = day < 10 ? '0' + day : day;
    
                  this.formattedZyDate = `${year}/${month}/${day}`;
                  this.showZyAdress = parseInt(this.apiData.estateAllowUpdateUpdateTime) * 1000 > Date.now() ? true : false
                }
              }
              // 减价盘仅可以显示在修改楼盘中
              this.isReducePriceAll()
              if(!this.isOwner && this.propertyInfo.propertySource == 1) {
                this.isShowOwner = true
              }
            }else{
              this.clearBocPro()
            }
            this.initializeEditMode()
            if (this.conditions) {
              this.roomNoZl = this.propertyInfo.roomNo
              /**是中原||利嘉阁的工商铺  获取A+数据时使用ibsNo覆盖categoryNo*/
              if (this.propertyInfo.propertyCategory == '2') {
                this.propertyInfo.categoryNo = this.propertyInfo.ibsNo;
                this.getConditions(this.propertyInfo.categoryNo, 'edit');
              } else {
                this.getConditions(this.propertyInfo.propertyNo, 'edit');
              }
            }
            this.showCoupon()
            // 立即付款 展示订单所用的金币金额
            if(this.mode === '1'){
              let resOrder = await this.getOrder(this.propertyId);
              this.orderInfo = resOrder.data.result.data
              if(resOrder.data.result.data.length){
                this.payOrderMoney = resOrder.data.result.data[0].propertyCoin
                this.payOrderDia = resOrder.data.result.data[0].diamond
              }
              this.changeCoinDia()
            }
            /**  续期或者立即付款 滑动到最底部 rentLabel */
            this.$nextTick(function () {
              if (this.mode === '1') {
                let main = document.querySelector('.el-main');
                main.scroll({
                  top: document.querySelector('.post_main').offsetHeight,
                  left: 0,
                  behavior: 'smooth'
                });
              }
            });
            // 楼盘子类型禁用,租盘服务式住宅隐藏共居
            this.judSubDis()
            this.rentLabelSel()
            // 标准盘与无验证文件楼盘 不提示验证文件修改框
            if ((this.propertyInfo.topType == '0' || !this.propertyInfo.isVerify) && this.mode === "edit") {
              this.verifyUpdate = true
            }
            await this.getPhaBuild(this.propertyInfo)
            await this.getFloor(this.propertyInfo)
            this.norBuilTypeOne('firstEdit')//针对编辑和非屋苑单栋解除禁用
            if (this.mode == 'copy') {
              // 服务式住宅版本
              if(this.propertyInfo.rentalType == 1 && (this.propertyInfo.subCategory.includes('19') || this.propertyInfo.subCategory.includes(19))){
                this.propertyInfo.subCategory.splice(this.propertyInfo.subCategory.indexOf('19'), 1)
                this.Words.checkedFacSer = []
              }
              this.chartEstateID = this.propertyInfo.estateID ?this.propertyInfo.estateID :'' ;
              this.chartScopeCode = this.propertyInfo.gscopeCode ?this.propertyInfo.gscopeCode :'' ;
              if(this.propertyInfo.propertyCategory == "1" && this.isUseInstantEstateVolume && this.propertyInfo.roomNumber){
                this.isShowChart = true
                if(!this.propertyInfo.estateID){
                  this.getChartData('chartOne')
                }else{
                  this.getChartData('chartOne')
                  this.getChartData('chartTwo')
                }
              }
              this.draftDisRule()//针对复制的屋苑单栋解除禁用
            }
            if(!Boolean(this.propertyInfo.estateID) && this.mode !== 'post' && this.mode !== 'copy' && this.propertyInfo.estateAddress){
              this.disableAddress = true
            }
            if(this.propertyInfo.propertyCategory == "6"){
              this.isDaWanQu = true//是否为大湾区海外
            }
            // sessionStorage.getItem('refreshpro') 判断 校验弹框 与 草稿箱数据回显弹框 俩个弹出的先后问题
            if(this.$route.query.gradeRule == 'starValidate' && sessionStorage.getItem('refreshpro') == 'false' ){
              // 存在必填资料缺乏
              this.validaCustom()
            }
            // 切换楼盘类型时，由于期数座数清空，所以需要保存屋苑的id,用于重置楼盘地址信息
            this.resetID = this.propertyInfo.parentEstateID ? this.propertyInfo.parentEstateID : this.propertyInfo.estateID
            // 编辑楼盘 需要回显非屋苑单栋住宅 存在座数才回显  
            if ((this.propertyInfo.propertyCategory == "1" && this.propertyInfo.buildingType !== 1 && (this.propertyInfo.phaseWithCulture || (!this.propertyInfo.phaseWithCulture && !this.estAdress.phaseEstates.length))) || (this.propertyInfo.propertyCategory !== "1") || (this.propertyInfo.propertyCategory == "1" && this.isCutomadded) || !this.addressSearch) {
            // if ((this.propertyInfo.propertyCategory == "1" && this.propertyInfo.buildingType !== 1 && this.propertyInfo.buildingType !== 0 && this.propertyInfo.buildingNameWithCulture) || (this.propertyInfo.propertyCategory !== "1") || (this.propertyInfo.propertyCategory == "1" && this.isCutomadded) || !this.addressSearch) {
              this.setOneEstData()
            }
            // 屋苑单栋 -存在座数楼层才回显
            if (this.propertyInfo.propertyCategory == "1" && this.propertyInfo.buildingType == 1) {
              if (this.mode == 'edit') {
                this.setEstData('firstEdit')
              } else if ((this.estAdress.floorList.length && this.propertyInfo.floorName) || (!this.estAdress.floorList.length && this.propertyInfo.unitFloor)) {
                this.setEstData()
              }
            }
          }
      })
    },
    /** 租售切换 */
    // typeChange() {
    //   if (this.propertyInfo.rentalType == 2) {
    //     this.propertyInfo.salePrice = '';
    //     this.propertyInfo.paidSalePrice = '';
    //     this.propertyInfo.unPaidSalePrice = '';
    //     // this.propertyInfo.isLinkParking = false;
    //   } else {
    //     this.propertyInfo.rentPrice = '';
    //     this.propertyInfo.beginRentTime = '';
    //     this.propertyInfo.rentLabel = [];
    //   }
    // },
    /** 区域切换 */
    setGscope(value) {
      if (this.$route.query.draftID) {
        // 草稿箱通过校验要用$set
        this.$set(this.propertyInfo, "gscopeCode", '');
      } else {
        this.propertyInfo.gscopeCode = '';//给小板块置空
      }
      this.propertyInfo.gscopeFaCode = value.gscopeCode;//value是item 大板块名字 这个值index用
      this.propertyInfo.regionNameWithCulture = value.gscopeNameWithCulture;//给大板块 这个传数据用真字
      this.diConfig.ChildrenGscope = value.children;//他的子集是小区域 
      // 切换片区 存在楼层时 楼市片区已清空
      this.propertyInfo.gscopeNameWithCulture = ''
      this.chartScopeCode = ''
      if(this.propertyInfo.unitFloor){
        this.setOneEstData()
      }
    },
    setChType(item) {
      this.propertyInfo.gscopeNameWithCulture = item.gscopeNameWithCulture
      this.propertyInfo.gscopeCode = item.gscopeCode
      this.chartScopeCode = item.gscopeCode
      if (this.$route.query.draftID) {
        // 草稿箱实时显示需要强制刷新
        this.$forceUpdate();
      }
      if(this.propertyInfo.propertyCategory == 1 && this.isUseInstantEstateVolume && this.propertyInfo.roomNumber){
        this.isShowChart = true
        this.getChartData('chartOne')
      }
      this.setOneEstData()
    },
    /** 樓盤驗證 */
    // Verify(value) {
    //   if (value) {
    //     this.attachVisible = true;
    //   }
    // },
    clearBocPro(){
      // 关闭减价盘模块
      this.showReducePrice = false
      this.propertyInfo.isReducePaidSalePrice = false;
      this.propertyInfo.isReduceRentPrice = false;
      this.propertyInfo.isReduceUnPaidSalePrice =false;
    },
    // 子类型初始取消禁用
    cateDisSub(){
      if(this.diConfig.ChildrenCategory){
        for (let i = 0; i < this.diConfig.ChildrenCategory.length; i++) {
          this.$set(this.diConfig.ChildrenCategory[i], 'disable', false)
        }
      }
    },
    // 子类型结合冲突与禁用
    judSubDis(){
      // 租盘服务式住宅复制为售时,清空物业编号,取消服务式住宅
      if(this.propertyInfo.rentalType == '1' && this.propertyInfo.subCategory && (this.propertyInfo.subCategory.includes('19') || this.propertyInfo.subCategory.includes(19))){
        this.propertyInfo.subCategory = this.propertyInfo.subCategory.filter(item=>item!='19')
        if(this.mode == 'copy'){
          this.propertyInfo.propertyNo = ''
        }
      }
      if(this.propertyInfo.subCategory && this.propertyInfo.subCategory.length == 1){
        for (let key of this.propertyInfo.subCategory) {
            if (this.disSub[key]) {
              for (let obj of this.diConfig.ChildrenCategory) {
                if (this.disSub[key].includes(parseInt(obj.dictionaryValue))) {
                  obj.disable = true;
                } else{
                  obj.disable = false;
                }
              }
            }else{
              this.cateDisSub()
            }
          }
      }else if(!this.propertyInfo.subCategory || this.propertyInfo.subCategory.length == 0){
        this.cateDisSub()
      }

    },
    // 子类型根据当前租售与子类型租售匹配,不匹配则删除
    subTypeSel(){
      if(this.diConfig.ChildrenCategory){
        for (let i = 0; i < this.diConfig.ChildrenCategory.length; i++) {
          if(this.diConfig.ChildrenCategory[i].rentalType != 0 && this.propertyInfo.rentalType != this.diConfig.ChildrenCategory[i].rentalType){
            this.diConfig.ChildrenCategory.splice(i,1)
          }
        }
      }
    },
    changeCategoryDia(item){
      // 在 修改时，禁止修改屋苑名称 且楼盘选单输入情况下，大湾区与其余楼盘类型 不可互选，需弹出弹框
      if(this.mode === 'edit' && !this.editEst && !this.addressSearch){
        this.estateSrcList = []
        if(this.propertyInfo.propertyCategory != 6){
          this.estateSrcList = this.diConfig.PropertyCategory
            .filter(categoryItem => typeof categoryItem.dictionaryValue === 'number' || (typeof categoryItem.dictionaryValue === 'string' && categoryItem.dictionaryValue != '6'))
            .map(mapItem => {
              // 将所有 val 值转换为数字类型
              return typeof mapItem.dictionaryValue === 'string' ? parseInt(mapItem.dictionaryValue, 10) : mapItem.dictionaryValue;
            });
        }
      }
      return new Promise((resolve, reject) => {
        // 不存在屋苑类型或者不存在屋苑名称时，屋苑类型可随意切换
        // if((!this.propertyInfo.propertyCategory && !this.propertyInfo.estateName) || !this.propertyInfo.estateName){
        if(!this.propertyInfo.propertyCategory || !this.propertyInfo.estateName){
          this.propertyInfo.propertyCategory= item.dictionaryValue
          resolve()
        }else{
          // 前提：修改 & 禁止修改屋苑名称
          if(this.mode == 'edit' && !this.editEst) {
            // （存在estateSrcList前提）切换到禁止切换类型，提示无法切换
            if( !this.estateSrcList.includes(parseInt(item.dictionaryValue))){
              this.$confirm(`<div style="font-weight:700;color:#444444;">[${item.dictionaryNameWithCulture}]不支援[${this.propertyInfo.estateName}]</div>將無法切換至[${item.dictionaryNameWithCulture}]`,  '提示',{
                confirmButtonText: '確認',
                showCancelButton: false,
                type: 'warning',
                dangerouslyUseHTMLString: true,
              })
              reject()
            }else{
              // 切换到可切换类型
              this.propertyInfo.propertyCategory = item.dictionaryValue;
              resolve()
            }
          }else{
            // 非修改 | 可修改屋苑名称 切换到禁止切换类型 提示是否确认切换
            if(!this.estateSrcList.includes(parseInt(item.dictionaryValue))){
              this.$confirm(`<div style="font-weight:700;color:#444444;">[${item.dictionaryNameWithCulture}]不支援[${this.propertyInfo.estateName}]</div>是否清除[${this.propertyInfo.estateName}]樓盤地址內的可填入資料？`,  '提示',{
                confirmButtonText: '確認',
                cancelButtonText: '取消',
                type: 'warning',
                dangerouslyUseHTMLString: true,
              }).then(() => {
                // 确认切换
                this.propertyInfo.propertyCategory = item.dictionaryValue;
                this.propertyInfo.estateName = ''
                this.propertyInfo.estateNameEN = '';
                this.estateZoneCode = ''
                this.estateGscopeCode = ''
                this.propertyInfo.gscopeFaCode = ''
                this.propertyInfo.gscopeCode = ''
                this.propertyInfo.gscopeNameWithCulture = ''
                // this.autocompleteName = ''
                // this.autocompleteNameEN = ''
                this.propertyInfo.estateID = ''
                this.resetID = ''
                this.isShowChart = false
                this.showSubTxt = ''
                this.propertyInfo.subCategorySuggestText = ''
                // this.resetPhamore() setchildtype中已处理
                resolve()
              }).catch(() => {
                // 取消切换
                reject()
              })
            }else{
              // 切换到可切换类型
              this.propertyInfo.propertyCategory = item.dictionaryValue;
              if(this.propertyInfo.propertyCategory == "1"){
                this.matchSubTypeTit()
              }else{
                this.showSubTxt = ''
                this.propertyInfo.subCategorySuggestText = ''
              }
              resolve()
            }
          }
        }
      })
    },
    /** 类型切换 */
    async setChildType(value) {
      const item = this.diConfig.PropertyCategory.find(el => el.dictionaryValue === value);
      try {
        // 判断当前类型与屋苑是否匹配 resolve走后续，reject则保持原样。
        await this.changeCategoryDia(item)

        if(this.mode == 'edit'){
          this.clearBoc = true
          this.clearBocPro();
        }
        this.$refs.propertyInfo.clearValidate('paidSalePrice')
        this.diConfig.ChildrenCategory = item.children;
        this.subTypeSel()
        this.propertyInfo.subCategory = [];
        this.propertyInfo.propertyCategoryWithCulture = item.dictionaryNameWithCulture;
        this.tagshow()
        // QRCode不存在 创建
        // try {
        //   if (!this.$refs.qrCodeDiv.hasChildNodes()) {
        //     console.log("///--00")
        //     this.createQRCode();
        //   }
        // } catch (e) { }
        if (this.conditions) {
          this.searchRes = false;
        }
        if (item.dictionaryValue === '4') {
          this.propertyInfo.rentLabel = []
          this.propertyInfo.buildingName = '';
          this.propertyInfo.buildingNameWithCulture = ''
          this.propertyInfo.buildingID = ''
          this.propertyInfo.buildingNameEN = ''

          this.propertyInfo.roomNumber = '';
          this.propertyInfo.unPaidSalePrice = ''
          this.propertyInfo.paidSalePrice = ''
          // this.propertyInfo.isLinkParking = '';
          this.propertyInfo.propertyManagementFee = '';
          this.propertyInfo.buildingArea = '';
          this.propertyInfo.saleableArea = '';
        }
        if (item.dictionaryValue === '5') {
            // 清除租房其它选项
          this.propertyInfo.rentLabel = []
          this.propertyInfo.buildingName = '';
          this.propertyInfo.buildingNameWithCulture = ''
          this.propertyInfo.buildingID = ''
          this.propertyInfo.buildingNameEN = ''

          this.propertyInfo.buildingAge = '';
          this.propertyInfo.roomNumber = '';
          this.propertyInfo.unitFloor = '';
        }
        if(item.dictionaryValue == '6'){
          this.isDaWanQu = true
          this.resetID = ''
          this.changeSearch()
          // this.addressSearch = false
          this.propertyInfo.gscopeFaCode = ''
          this.propertyInfo.gscopeCode = ''
          this.propertyInfo.gscopeNameWithCulture = ''
          this.changeProOversea()
        }else if(item.dictionaryValue != '6' && !this.addressSearch){
          // isDaWanQu:由大湾区切换至其余楼盘类型 默认为搜索录入 ,其余楼盘类型间互相切换 默认不改动
          if(this.isDaWanQu){
            this.addressSearch = true
            this.propertyInfo.estateName = ''
            this.propertyInfo.gscopeNameWithCulture = ''
          }
          this.isDaWanQu = false
          this.diConfig.gscope = this.hkGscope
          // 大湾区海外 切换至了其余楼盘类型  屋苑地区,名称置空,改为字典输入
          if(this.propertyInfo.gscopeFaCode == 'HKP1001' || this.propertyInfo.gscopeFaCode == 'HKP1002'){
            this.propertyInfo.gscopeFaCode = ''
            this.propertyInfo.gscopeCode = ''
          }
        }
        // 当不为住宅 解除单位禁用
        if (item.dictionaryValue !== '1') {
          this.startFloDis = false
          this.startBuilRoom = false
        } else {
          this.cateDisSub()
          // 切换楼盘类型后 存在屋苑名称情况下 高中低楼层是否禁用
          if(this.propertyInfo.estateID){
            this.startFloDis = this.showEstAdressbui ? true :false
          }else{
            this.startFloDis = true
          }

          this.startBuilRoom = true
        }
        this.resetPhamore('category')
        // if (((this.propertyInfo.propertyCategory !== "1" && this.propertyInfo.buildingType !== 1) || this.propertyInfo.propertyCategory !== "1" || (this.propertyInfo.propertyCategory == "1" && this.isCutomadded)) && this.propertyInfo.estateName) {
        //   this.setOneEstData()
        // }
        const isNotResidential = this.propertyInfo.propertyCategory !== "1";
        const isNotBuildingType1 = this.propertyInfo.buildingType !== 1;
        const isResidentialWithCustom = this.propertyInfo.propertyCategory == "1" && this.isCutomadded;
        const hasEstateName = this.propertyInfo.estateName;

        if (((isNotResidential && isNotBuildingType1) || isNotResidential || isResidentialWithCustom) && hasEstateName) {
          this.setOneEstData();
        }
        //! 切换会住宅时应该只控制显隐 重新请求数据仅适用于 刷新和改变了屋苑
        if(this.propertyInfo.propertyCategory == "1" && this.propertyInfo.roomNumber && ((this.chartEstateID && this.addressSearch) || (this.chartScopeCode && !this.addressSearch))){
          this.isShowChart = true
        }else{
          this.isShowChart = false
        }
      } catch (error) {
          console.log("not change propertycategory")
      }
    },

    changeSub() {
      if(this.mode == 'edit'){
        this.clearBoc = true
        this.clearBocPro();
      }
      this.propertyInfo.unPaidSalePrice = ''
      this.propertyInfo.paidSalePrice = ''
      this.judSubDis()
      if (this.propertyInfo.subCategory && (this.propertyInfo.subCategory.includes('6') ||this.propertyInfo.subCategory.includes('7') ||this.propertyInfo.subCategory.includes(6) ||this.propertyInfo.subCategory.includes(7))) {
        this.propertyInfo.salePrice = ''
      }
      // 套房 面积未核实默认未勾选
      if((this.propertyInfo.subCategory.includes('8') || this.propertyInfo.subCategory.includes(8) )&& this.propertyInfo.propertyCategory ==1){
        this.isArea = true
      }
      // 服務式住宅 --共居删除,物业编号自动填写--
      this.rentLabelSel()
      if(this.propertyInfo.subCategory.includes('19') || this.propertyInfo.subCategory.includes(19)){
        this.propertyInfo.propertyNo = '--'
      }
      if(this.propertyInfo.propertyCategory == 1 && this.isUseInstantEstateVolume && this.propertyInfo.roomNumber){
        if(!this.propertyInfo.estateID){
          this.getChartData('chartOne')
        }else{
          this.getChartData('chartOne')
          this.getChartData('chartTwo')
        }
      }
      // 楼盘子类型推荐提示
      if(this.suggestSubCategory){
        this.matchSubTypeTit()
      }

      this.$nextTick(() => {
        this.$refs.propertyInfo.clearValidate('paidSalePrice')
      });
    },
    // 选中服务式住宅时共居隐藏
    rentLabelSel(){
      if(this.propertyInfo.subCategory &&(this.propertyInfo.subCategory.includes('19') || this.propertyInfo.subCategory.includes(19))){
        this.propertyInfo.rentLabel = this.propertyInfo.rentLabel.filter(element => element != 8)
        this.diConfig.RentLabel = this.dRentLabel.filter(element => element.dictionaryValue != 8)
      }else{
        this.diConfig.RentLabel = this.dRentLabel
        this.propertyInfo.servicesCN = ''
        this.propertyInfo.servicesEN = ''
      }
    },
    /** 代理选择 */
    setAgent(index) {
      if (this.agent.length) {
        this.isEmpty_agent = false;
        // this.isdis_agent = false
        // 草稿箱中添加了后端若返回user为null,赋值一个空对象的操作,所以对[0]进行判断
        if (this.$route.query.draftID || (this.mode == 'post' && sessionStorage.getItem('refreshpro') == 'true' && sessionStorage.getItem('refreshID'))) {
          let d = Object.keys(this.propertyUserInfo[0]).length
          if (d === 0) {
            this.draftlen = true
            // 当页面选中了某个值之后
            if (this.agent[0]) {
              this.draftlen = false
            }
          } else {
            this.draftlen = false
          }
        }
      }
      this.diConfig.agentList.forEach(item => {
        if (item.accountID === this.agent[index]) {
          let copyUserInfo=Object.assign({}, item);
          this.editcompanyUserInfo.push(copyUserInfo)
          this.propertyUserInfo[index] = item;
          this.propertyUserInfo.isJoinAgentIntroduce = false; //是否加入代理人介绍
        }
      });
      // 初始代理人分行电话要默认选中
      this.specialServe(false,'isShowPmsCompanyTel', index)
    },
    /** 代理新增 */
    addProxy() {
      if (this.propertyUserInfo.length >= this.publicAgentNumber) {
        this.propertyUserInfo = this.propertyUserInfo.slice(0, this.publicAgentNumber);
        this.warning(`最多選擇 ${this.publicAgentNumber} 位代理人`);
        return;
      } 
        this.propertyUserInfo.push({});
      
    },
    /** 代理删除 */
    delProxy(i) {
      this.propertyUserInfo.splice(i, 1);
      this.agent.splice(i, 1);
    },
    changeDisplayType(){
      this.$forceUpdate()
      // 利嘉阁账户 propertyDisPlayType为1时，强制勾选平面图
      if(this.companyCategory == 2){
        if(this.propertyInfo.propertyDisPlayType != 1){
          this.lijiageAco = false
        }else{
          this.selPlatImg('101')
          this.selPlatImg('100')
          this.lijiageAco = true
        }
      }
    },
    /** 切换地址搜索方式 */
    changeSearch() {
      if(this.fromZy){return}
      this.changesubway()
      this.changeParkSubway()
      /**
       * 由原 :编辑楼盘不可切换屋苑输入方式 --改为 -- .
       * 现:字典输入的屋苑 编辑楼盘 禁止改为手动输入, 手动输入 且 开启可搜索屋苑权限时候 可转为字典输入
       * 250520 -->  hk将规则改为“编辑楼盘时，字典可切换为手动” (this.mode === 'edit' && this.changeAddressSearch && this.propertyInfo.propertyCategory != 6) || 
       * */ 
      if ((this.mode === 'edit' && !this.editEst) || this.mode === '2' || this.conditions) {
        return;
      }
      this.matchSubText = ''
      this.propertyInfo.subCategorySuggestText = ''
      this.showSubTxt = ''
       // 选单情况下，大湾区切换至其他楼盘类型弹出提示，其他楼盘类型可互相切换
      if(this.propertyInfo.propertyCategory == 6){
        this.estateSrcList = []
      }
      // 大湾区海外禁止切换为字典输入
      if(this.propertyInfo.propertyCategory == 6 && !this.addressSearch){return}
      this.addressSearch = !this.addressSearch;
      this.isShowChart = false
      if (!this.addressSearch) {
        this.chartEstateID = ''
        this.chartScopeCode = ''
        // this.propertyInfo.couponKeyword = ''
        // this.isDisCoupon = false
        if(!this.propertyInfo.estateAddress){
          this.disableAddress = false
        }
        this.showCoupon()
        this.estateSrcList = []
        if(this.propertyInfo.propertyCategory != 6){
          this.diConfig.PropertyCategory.forEach(item => {
            this.estateSrcList.push(parseInt(item.dictionaryValue, 10)); 
          });
        }
        // for (let i = 0; i < this.diConfig.PropertyCategory.length; i++) {
        //   this.$set(this.diConfig.PropertyCategory[i], 'disable', false)
        // }
      }else{
        this.isUseCoupon = false
        this.isDisCoupon = false
        this.propertyInfo.couponKeyword = ''
      }
      this.EstateInfo = {}
      this.propertyInfo.regionNameWithCulture = '';
      this.propertyInfo.gscopeNameWithCulture = '';
      this.propertyInfo.estateID = '';
      this.propertyInfo.estateType = '';
      this.propertyInfo.gscopeCode = '';
      this.propertyInfo.estateAddress = '';
      this.propertyInfo.estateAddressEN = '';
      this.estAdress.phaseEstates = []//期数下拉项清空
      // let type = this.addressSearch ? '' :'fromSearch'
      // console.log("进行切换")
      this.resetPhamore()
      // 字典切换为手动输入时，'地区 屋苑名称 座数'保留带入至手输
      if(!this.addressSearch){
        this.propertyInfo.gscopeFaCode = this.estateZoneCode;
        this.propertyInfo.gscopeCode = this.estateGscopeCode;
        // this.propertyInfo.estateName = this.autocompleteName;
        // this.propertyInfo.estateNameEN = this.autocompleteNameEN;

        // this.propertyInfo.buildingName = this.autocompletebuild
        // this.propertyInfo.buildingNameWithCulture = this.autocompletebuild
        // 地区 及 片区数据赋值
        for (let index = 0; index <  this.diConfig.gscope.length; index++) {
          if(this.diConfig.gscope[index].gscopeCode == this.estateZoneCode){
            this.setGscope(this.diConfig.gscope[index])
            break;
          }
        }
        for (let i = 0; i < this.diConfig.ChildrenGscope.length; i++) {
          if(this.diConfig.ChildrenGscope[i].gscopeCode == this.estateGscopeCode){
            this.setChType(this.diConfig.ChildrenGscope[i])
            break;
          }
        }
      }else{
        this.propertyInfo.gscopeFaCode = '';
        this.propertyInfo.estateName = '';
        this.propertyInfo.estateNameEN = '';
        this.estateZoneCode = ''
        this.estateGscopeCode = ''
        // this.autocompleteName = ''
        // this.autocompleteNameEN = ''
      }
      this.planfloChecked = []
      this.propertyInfo.planImages = []
      this.planChecked = []
    },
    /** 失去焦点 取消搜索 */
    cancelSearch() {
      //当先输入关键字，后选地区时候，需要保留关键字进行搜索
      // this.autocompleteName = this.propertyInfo.estateName;
      // this.autocompleteNameEN = this.propertyInfo.estateNameEN;
      // 由于cancel先于changeSearch执行，切换地址时 需要保留屋苑,座数,地区，所以增加字段进行保存
      // this.autocompletebuild = this.propertyInfo.buildingNameWithCulture || this.propertyInfo.buildingName;
      this.propertyInfo.gscopeFaCode = '';
      this.propertyInfo.gscopeCode = '';
      // this.propertyInfo.estateName = '';
      // this.propertyInfo.estateNameEN = '';
      this.estAdress.buildings = [];
      this.estAdress.phaseEstates = []
      // if(!this.estateStep){
      //   this.estateZoneCode = ''
      // }
      // this.resetPhamore()
      this.resetPhamore('backSpaceName')
      // this.cateFromEstate()
      if(this.mode == 'edit'){
        this.clearBoc = true;
        this.clearBocPro();
      }
    },
    closeLogin() {
      this.showLogin = false;
      this.$router.push('/login');
    }
  }
};
